/* tslint:disable */
/* eslint-disable */
/**
 * DealerKit API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 91.3.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setBasicAuthToObject, setBearerAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, BaseAPI, operationServerMap } from './base';
/**
 *
 * @export
 * @enum {string}
 */
export const AccountQuotaStatus = {
    Under: 'under',
    Ok: 'ok',
    Over: 'over'
};
/**
 *
 * @export
 * @enum {string}
 */
export const AccountingAutoEntryDocumentType = {
    PurchaseInvoice: 'purchase_invoice',
    TillReceipt: 'till_receipt',
    CreditNote: 'credit_note',
    StatementOfAccount: 'statement_of_account'
};
/**
 *
 * @export
 * @enum {string}
 */
export const AccountingAutoEntryEventType = {
    Queued: 'ai.auto.entry.document.queued',
    Complete: 'ai.auto.entry.document.complete',
    Failed: 'ai.auto.entry.document.failed'
};
/**
 *
 * @export
 * @enum {string}
 */
export const AccountingAutoEntryImportStatus = {
    InProgress: 'in_progress',
    Complete: 'complete',
    Failed: 'failed'
};
/**
 *
 * @export
 * @enum {string}
 */
export const AccountingExportAdapterType = {
    File: 'file',
    Api: 'api'
};
/**
 *
 * @export
 * @enum {string}
 */
export const AccountingExportBatchStatus = {
    Preparing: 'preparing',
    Draft: 'draft',
    Pending: 'pending',
    Processing: 'processing',
    Exported: 'exported',
    Error: 'error'
};
/**
 *
 * @export
 * @enum {string}
 */
export const AccountingExportEventTypes = {
    BatchStarted: 'ax.batch.started',
    BatchCompleted: 'ax.batch.completed',
    BatchError: 'ax.batch.error',
    BatchSegmentStarted: 'ax.batch.segment.started',
    BatchSegmentCompleted: 'ax.batch.segment.completed',
    ExportStarted: 'ax.export.started',
    ExportCompleted: 'ax.export.completed',
    ExportError: 'ax.export.error'
};
/**
 *
 * @export
 * @enum {string}
 */
export const AccountingExportItemStatus = {
    Draft: 'draft',
    Pending: 'pending',
    Exported: 'exported',
    Skipped: 'skipped',
    Error: 'error'
};
/**
 *
 * @export
 * @enum {string}
 */
export const AccountingExportItemSubType = {
    Fci: 'FCI',
    Fcp: 'FCP',
    Fsi: 'FSI',
    Fsp: 'FSP',
    Smo: 'SMO',
    Smi: 'SMI',
    Fsmi: 'FSMI',
    Exp: 'EXP',
    Bso: 'BSO',
    Bsi: 'BSI',
    Rsi: 'RSI',
    Rsp: 'RSP',
    Pr: 'PR'
};
/**
 *
 * @export
 * @enum {string}
 */
export const AccountingExportItemType = {
    Si: 'SI',
    Sc: 'SC',
    Pi: 'PI',
    Pc: 'PC',
    Jd: 'JD',
    Jc: 'JC',
    Sa: 'SA',
    Pa: 'PA',
    Pp: 'PP'
};
/**
 *
 * @export
 * @enum {string}
 */
export const AccountingIntegrationFramework = {
    None: 'none',
    V1: 'v1',
    V2: 'v2'
};
/**
 *
 * @export
 * @enum {string}
 */
export const AnalyticDatapointType = {
    DealsCompleted: 'deals.completed',
    DealsNetMargin: 'deals.net.margin',
    DealsTotalNetMargin: 'deals.total.net.margin',
    DealsWarrantyNetMargin: 'deals.warranty.net.margin',
    DealsCompletedRevenue: 'deals.completed.revenue',
    DealsCompletedFinanceRevenue: 'deals.completed.finance.revenue',
    StockCostNet: 'stock.cost.net',
    StockCount: 'stock.count',
    StockFundedValue: 'stock.funded.value',
    StockDays: 'stock.days',
    StockNetMargin: 'stock.net.margin',
    StockAdvertisedPrice: 'stock.advertised.price',
    SmsSent: 'sms.sent',
    SmsReceived: 'sms.received',
    SmsSegmentsSent: 'sms.segments.sent',
    SmsSegmentsReceived: 'sms.segments.received',
    SmsCostSent: 'sms.cost.sent',
    SmsCostReceived: 'sms.cost.received',
    SmsRetailSent: 'sms.retail.sent',
    SmsRetailReceived: 'sms.retail.received',
    EsignSent: 'esign.sent',
    EsignCompleted: 'esign.completed',
    EsignRetailCompleted: 'esign.retail.completed',
    BackgroundRemoval: 'background.removal',
    ExpenseAutoEntryDocumentsCompleted: 'expense.auto.entry.documents.completed',
    ExpenseAutoEntryExpensesCompleted: 'expense.auto.entry.expenses.completed',
    ExpenseAutoEntryRetailCompleted: 'expense.auto.entry.retail.completed'
};
/**
 *
 * @export
 * @enum {string}
 */
export const AttributeConditionOperator = {
    Equal: '=',
    NotEqual: '!=',
    GreaterThanOrEqualTo: '>=',
    GreaterThan: '>',
    LessThanOrEqualTo: '<=',
    LessThan: '<',
    In: 'in',
    NotIn: 'not in',
    IsNull: 'is null',
    IsNotNull: 'is not null',
    Contains: 'contains'
};
export const AutoTraderPricingInsightsDataPriceIndicatorEnum = {
    Higher: 'Higher',
    Fair: 'Fair',
    Good: 'Good',
    Great: 'Great',
    Lower: 'Lower'
};
/**
 *
 * @export
 * @enum {string}
 */
export const AutotraderAdvertStatus = {
    Published: 'published',
    Unpublished: 'unpublished',
    Capped: 'capped',
    Rejected: 'rejected'
};
/**
 *
 * @export
 * @enum {string}
 */
export const AutotraderPriceIndicators = {
    Higher: 'HIGHER',
    Fair: 'FAIR',
    Good: 'GOOD',
    Great: 'GREAT',
    Lower: 'LOWER',
    Noanalysis: 'NOANALYSIS'
};
/**
 *
 * @export
 * @enum {string}
 */
export const AutotraderSyncStatus = {
    Unsynced: 'unsynced',
    Syncing: 'syncing',
    Synced: 'synced',
    Error: 'error'
};
/**
 *
 * @export
 * @enum {string}
 */
export const BackgroundReportStatus = {
    Pending: 'pending',
    Processing: 'processing',
    Completed: 'completed',
    Failed: 'failed'
};
/**
 *
 * @export
 * @enum {string}
 */
export const BankTransactionAllocationType = {
    Expense: 'expense',
    ExpenseCredit: 'expense.credit'
};
/**
 *
 * @export
 * @enum {string}
 */
export const CaravanBedroomLayout = {
    DinetteConversion: 'Dinette conversion',
    DropDownBed: 'Drop-down bed',
    FixedBunkBeds: 'Fixed bunk beds',
    FixedIslandBed: 'Fixed island bed',
    FixedSingleBeds: 'Fixed single beds',
    FrenchBed: 'French bed',
    LoungeConversion: 'Lounge Conversion',
    TransverseBed: 'Transverse bed',
    FixedBed: 'Fixed bed'
};
/**
 *
 * @export
 * @enum {string}
 */
export const CaravanEndLayout = {
    Bedroom: 'End bedroom',
    BedroomWashroom: 'End bedroom / washroom',
    Dinette: 'End dinette',
    Kitchen: 'End kitchen',
    KitchenWashroom: 'End kitchen / washroom',
    Lounge: 'End lounge',
    Washroom: 'End washroom'
};
/**
 *
 * @export
 * @enum {ContactFragment}
 */
export const ContactTitle = {
    Mr: 'Mr',
    Mrs: 'Mrs',
    Ms: 'Ms',
    Mx: 'Mx',
    Master: 'Master',
    Miss: 'Miss',
    Dr: 'Dr',
    Prof: 'Prof',
    Dame: 'Dame',
    Sir: 'Sir',
    Lord: 'Lord',
    Lady: 'Lady',
    Rev: 'Rev'
};
/**
 *
 * @export
 * @enum {string}
 */
export const ContactType = {
    Record: 'record',
    Lead: 'lead',
    Customer: 'customer',
    Supplier: 'supplier',
    TradeCustomer: 'trade_customer',
    FinanceProvider: 'finance_provider',
    Other: 'other'
};
export const CrmSettingsActivityDefaultDisplayEnum = {
    CreatedByOrAssignedToThem: 'created_by_or_assigned_to_them',
    AssignedToThem: 'assigned_to_them',
    All: 'all'
};
export const CrmSettingsDefaultLeadVisibilityPolicyEnum = {
    All: 'all',
    AssignedToThem: 'assigned_to_them',
    AssignedToAnyone: 'assigned_to_anyone'
};
export const CrmSettingsDefaultLeadDeletionPolicyEnum = {
    All: 'all',
    Own: 'own',
    None: 'none'
};
export const CrmSettingsDefaultLoseLeadPolicyEnum = {
    All: 'all',
    None: 'none'
};
export const CrmSettingsPayloadActivityDefaultDisplayEnum = {
    CreatedByOrAssignedToThem: 'created_by_or_assigned_to_them',
    AssignedToThem: 'assigned_to_them',
    All: 'all'
};
export const CrmSettingsPayloadDefaultLeadVisibilityPolicyEnum = {
    All: 'all',
    AssignedToThem: 'assigned_to_them',
    AssignedToAnyone: 'assigned_to_anyone'
};
export const CrmSettingsPayloadDefaultLeadDeletionPolicyEnum = {
    All: 'all',
    Own: 'own',
    None: 'none'
};
export const CrmSettingsPayloadDefaultLoseLeadPolicyEnum = {
    All: 'all',
    None: 'none'
};
/**
 *
 * @export
 * @enum {string}
 */
export const DocumentOwnerType = {
    VehicleInstance: 'vehicle.instance',
    AccountingExpense: 'accounting.expense',
    Task: 'task',
    Deal: 'deal'
};
/**
 *
 * @export
 * @enum {string}
 */
export const DocumentType = {
    Other: 'other',
    Image: 'image',
    Document: 'document',
    InspectionImage: 'inspection_image',
    TaskDocument: 'task_document',
    Watermark: 'watermark',
    PromoSlide: 'promo_slide',
    TemplateDocument: 'template_document',
    SignableDocument: 'signable_document',
    InboxAttachment: 'inbox_attachment',
    ArchivedDealDocument: 'archived_deal_document',
    ConfiguredPackDocument: 'configured_pack_document'
};
/**
 *
 * @export
 * @enum {string}
 */
export const DrivePosition = {
    Right: 'right',
    Left: 'left',
    Centre: 'centre'
};
/**
 *
 * @export
 * @enum {string}
 */
export const DriveTrain = {
    _4Wd: '4WD',
    Fwd: 'FWD',
    Rwd: 'RWD'
};
/**
 *
 * @export
 * @enum {string}
 */
export const ExpenseStatus = {
    ForReview: 'for_review',
    Authorized: 'authorized'
};
/**
 *
 * @export
 * @enum {string}
 */
export const ExteriorFinish = {
    Solid: 'Solid',
    Metallic: 'Metallic',
    Pearlescent: 'Pearlescent',
    Matt: 'Matt',
    Iridescent: 'Iridescent',
    Custom: 'Custom'
};
/**
 *
 * @export
 * @enum {string}
 */
export const FinanceProductType = {
    Hp: 'HP',
    Pcp: 'PCP',
    Cs: 'CS'
};
/**
 *
 * @export
 * @enum {string}
 */
export const FinanceQuoteType = {
    Business: 'BUSINESS',
    Personal: 'PERSONAL'
};
/**
 *
 * @export
 * @enum {string}
 */
export const FuelType = {
    Petrol: 'Petrol',
    Diesel: 'Diesel',
    BiFuel: 'Bi-Fuel',
    DieselHybrid: 'Diesel Hybrid',
    DieselPlugInHybrid: 'Diesel Plug-in Hybrid',
    Electric: 'Electric',
    Hydrogen: 'Hydrogen',
    PetrolHybrid: 'Petrol Hybrid',
    PetrolPlugInHybrid: 'Petrol Plug-in Hybrid'
};
/**
 *
 * @export
 * @enum {string}
 */
export const FundingType = {
    Demo: 'DEMO',
    Rent: 'RENT',
    Prer: 'PRER',
    Csgn: 'CSGN',
    New: 'NEW',
    Used: 'USED'
};
/**
 *
 * @export
 * @enum {string}
 */
export const GenerativeAdvertisingDescriptionStyle = {
    Basic: 'basic',
    Extended: 'extended',
    Emoji: 'emoji',
    Clarksonesque: 'clarksonesque',
    CoDriver: 'co_driver'
};
export const HistoricRetailPriceChangeDirectionEnum = {
    Down: 'down',
    Up: 'up',
    Static: 'static'
};
/**
 *
 * @export
 * @enum {string}
 */
export const InspectionAnswerDefectPanel = {
    NearsideFrontWheel: 'Nearside - Front Wheel',
    NearsideRearWheel: 'Nearside - Rear Wheel',
    NearsideFrontTyre: 'Nearside - Front Tyre',
    NearsideRearTyre: 'Nearside - Rear Tyre',
    NearsideRearDoor: 'Nearside - Rear Door',
    NearsideFrontDoor: 'Nearside - Front Door',
    NearsideSill: 'Nearside Sill',
    NearsideRearQuarter: 'Nearside - Rear Quarter',
    NearsideRearArch: 'Nearside - Rear Arch',
    NearsideFrontArch: 'Nearside - Front Arch',
    NearsideWing: 'Nearside - Wing',
    NearsideHeadlight: 'Nearside - Headlight',
    NearsideFrontPillar: 'Nearside - Front Pillar',
    NearsideRearLight: 'Nearside - Rear Light',
    NearsideRearBumper: 'Nearside - Rear Bumper',
    TailgateNearside: 'Tailgate - Nearside',
    TailgateOffside: 'Tailgate - Offside',
    OffsideRearBumper: 'Offside - Rear Bumper',
    RearGlass: 'Rear Glass',
    Tailgate: 'Tailgate',
    RearBumper: 'Rear Bumper',
    OffsideRearLight: 'Offside - Rear Light',
    FrontBumperOffside: 'Front Bumper - Offside',
    FrontBumperNearside: 'Front Bumper - Nearside',
    BonnetNearside: 'Bonnet - Nearside',
    WindscreenNearside: 'Windscreen - Nearside',
    BonnetOffside: 'Bonnet - Offside',
    WindscreenOffside: 'Windscreen - Offside',
    Windscreen: 'Windscreen',
    FrontBumper: 'Front Bumper',
    Bonnet: 'Bonnet',
    RoofNearside: 'Roof - Nearside',
    RoofOffside: 'Roof - Offside',
    Roof: 'Roof',
    OffsideFrontWheel: 'Offside - Front Wheel',
    OffsideRearWheel: 'Offside - Rear Wheel',
    OffsideFrontTyre: 'Offside - Front Tyre',
    OffsideRearTyre: 'Offside - Rear Tyre',
    OffsideWingMirror: 'Offside - Wing Mirror',
    OffsideFrontArch: 'Offside - Front Arch',
    OffsideRearArch: 'Offside - Rear Arch',
    OffsideRearQuarter: 'Offside - Rear Quarter',
    OffsideRearDoor: 'Offside - Rear Door',
    OffsideFrontDoor: 'Offside - Front Door',
    OffsideWing: 'Offside - Wing',
    OffsideSill: 'Offside - Sill',
    OffsideHeadlight: 'Offside - Headlight',
    OffsideFrontPillar: 'Offside - Front Pillar'
};
/**
 *
 * @export
 * @enum {string}
 */
export const InspectionAnswerDefectType = {
    BrokenOrMissingPart: 'broken_or_missing_part',
    Panel: 'panel',
    Chip: 'chip',
    Crack: 'crack',
    Dent: 'dent',
    Scuff: 'scuff',
    Scratch: 'scratch',
    Worn: 'worn',
    Other: 'other'
};
/**
 *
 * @export
 * @enum {string}
 */
export const InspectionAnswerOutcome = {
    Passed: 'passed',
    Advisory: 'advisory',
    Failed: 'failed',
    Skipped: 'skipped'
};
/**
 *
 * @export
 * @enum {string}
 */
export const InspectionCreationTriggerType = {
    StockListingSaved: 'stock_listing.saved',
    StockListingCheckedIn: 'stock_listing.checked_in',
    BookingSaved: 'booking.saved'
};
/**
 *
 * @export
 * @enum {string}
 */
export const InspectionQuestionType = {
    Text: 'text',
    TextBox: 'text.box',
    TextArea: 'text.area',
    BodyworkDefectGroup: 'bodywork.defect.group',
    InteriorDefectGroup: 'interior.defect.group',
    TyreState: 'tyre.state',
    BrakeState: 'brake.state'
};
/**
 *
 * @export
 * @enum {string}
 */
export const InteriorColour = {
    Beige: 'Beige',
    Black: 'Black',
    Blue: 'Blue',
    Bronze: 'Bronze',
    Brown: 'Brown',
    Burgundy: 'Burgundy',
    Gold: 'Gold',
    Green: 'Green',
    Grey: 'Grey',
    Indigo: 'Indigo',
    Magenta: 'Magenta',
    Maroon: 'Maroon',
    Multicolour: 'Multicolour',
    Navy: 'Navy',
    Orange: 'Orange',
    Pink: 'Pink',
    Purple: 'Purple',
    Red: 'Red',
    Silver: 'Silver',
    Tan: 'Tan',
    Turquoise: 'Turquoise',
    White: 'White',
    Yellow: 'Yellow'
};
/**
 *
 * @export
 * @enum {string}
 */
export const InteriorTrim = {
    Cloth: 'Cloth',
    PartLeather: 'Part leather',
    FullLeather: 'Full leather',
    PartSuede: 'Part suede',
    FullSuede: 'Full suede',
    Velour: 'Velour',
    Vinyl: 'Vinyl'
};
/**
 *
 * @export
 * @enum {string}
 */
export const JobCleanUpAction = {
    Complete: 'complete',
    Delete: 'delete'
};
/**
 *
 * @export
 * @enum {string}
 */
export const JobCleanUpSubject = {
    Stock: 'stock',
    Sold: 'sold'
};
/**
 *
 * @export
 * @enum {string}
 */
export const JobLabourRateType = {
    User: 'user'
};
/**
 *
 * @export
 * @enum {string}
 */
export const JobTypeClass = {
    Group: 'group',
    Item: 'item',
    GroupItem: 'group-item'
};
/**
 *
 * @export
 * @enum {string}
 */
export const JobTypeWorkflowTrigger = {
    None: 'none',
    StockListingCreated: 'stock_listing.created',
    JobCompleted: 'job.completed',
    InspectionCompleted: 'inspection.completed',
    StockListingStatus: 'stock_listing.status',
    DealCompleted: 'deal.completed',
    DealStacked: 'deal.stacked'
};
/**
 *
 * @export
 * @enum {LeadFragment}
 */
export const LeadType = {
    Buying: 'buying',
    Sales: 'sales'
};
/**
 *
 * @export
 * @enum {string}
 */
export const LedgerAccountType = {
    Bank: 'bank',
    Asset: 'asset',
    Liability: 'liability',
    Revenue: 'revenue',
    Expense: 'expense',
    Equity: 'equity'
};
/**
 *
 * @export
 * @enum {string}
 */
export const MarketType = {
    None: 'none',
    Trade: 'trade',
    Retail: 'retail'
};
/**
 *
 * @export
 * @enum {string}
 */
export const MotDefectType = {
    Advisory: 'ADVISORY',
    Dangerous: 'DANGEROUS',
    Fail: 'FAIL',
    Major: 'MAJOR',
    Minor: 'MINOR',
    NonSpecific: 'NON SPECIFIC',
    SystemGenerated: 'SYSTEM GENERATED',
    UserEntered: 'USER ENTERED'
};
/**
 *
 * @export
 * @enum {string}
 */
export const MotJobCardCompletionType = {
    PendingComplete: 'pending_complete',
    Complete: 'complete'
};
/**
 *
 * @export
 * @enum {string}
 */
export const MotJobCardValidityUnit = {
    Days: 'days',
    Months: 'months',
    Years: 'years'
};
/**
 *
 * @export
 * @enum {string}
 */
export const MotTestResult = {
    Passed: 'PASSED',
    Failed: 'FAILED'
};
/**
 *
 * @export
 * @enum {string}
 */
export const MotTestUnit = {
    Km: 'KM',
    Mi: 'MI'
};
/**
 *
 * @export
 * @enum {string}
 */
export const MotorhomeBedroomLayout = {
    DinetteConversion: 'Dinette conversion',
    DropDownBed: 'Drop-down bed',
    FixedBunkBeds: 'Fixed bunk beds',
    FixedIslandBed: 'Fixed island bed',
    FixedSingleBeds: 'Fixed single beds',
    FrenchBed: 'French bed',
    LoungeConversion: 'Lounge Conversion',
    TransverseBed: 'Transverse bed',
    FixedDoubleBed: 'Fixed double bed',
    OvercabBedDouble: 'Overcab bed - double',
    OvercabBedSingle: 'Overcab bed - single',
    PopUpRoofDoubleBed: 'Pop-up roof double bed',
    RockNRollBed: 'Rock n Roll bed'
};
/**
 *
 * @export
 * @enum {string}
 */
export const MotorhomeEndLayout = {
    Bedroom: 'End bedroom',
    BedroomWashroom: 'End bedroom / washroom',
    Dinette: 'End dinette',
    Kitchen: 'End kitchen',
    KitchenWashroom: 'End kitchen / washroom',
    Lounge: 'End lounge',
    Washroom: 'End washroom',
    Garage: 'End Garage'
};
/**
 *
 * @export
 * @enum {string}
 */
export const OfferStatus = {
    Active: 'active',
    Cancelled: 'cancelled',
    Expired: 'expired'
};
/**
 *
 * @export
 * @enum {string}
 */
export const OfferSupplementaryItemType = {
    AdminFee: 'admin_fee',
    DeliveryFee: 'delivery_fee',
    Other: 'other'
};
/**
 *
 * @export
 * @enum {string}
 */
export const OfferType = {
    Purchase: 'purchase',
    Sale: 'sale'
};
/**
 *
 * @export
 * @enum {string}
 */
export const PartLedgerTransactionSubType = {
    Refund: 'refund',
    Loss: 'loss',
    Fulfillment: 'fulfillment'
};
/**
 *
 * @export
 * @enum {string}
 */
export const PartLedgerTransactionType = {
    In: 'stock_in',
    Out: 'stock_out'
};
export const PatchLeadPayloadTypeEnum = {
    Sales: 'sales',
    Buying: 'buying'
};
/**
 *
 * @export
 * @enum {string}
 */
export const PaymentMethod = {
    Card: 'card',
    Cash: 'cash',
    Cheque: 'cheque',
    BankTransfer: 'bank_transfer',
    Finance: 'finance',
    Tbc: 'tbc',
    CreditNote: 'credit_note'
};
/**
 *
 * @export
 * @enum {string}
 */
export const PersonTitle = {
    Mr: 'Mr',
    Mrs: 'Mrs',
    Ms: 'Ms',
    Mx: 'Mx',
    Master: 'Master',
    Miss: 'Miss',
    Dr: 'Dr',
    Prof: 'Prof',
    Dame: 'Dame',
    Sir: 'Sir',
    Lord: 'Lord',
    Lady: 'Lady',
    Rev: 'Rev'
};
/**
 *
 * @export
 * @enum {string}
 */
export const ProductClass = {
    ValueAddProduct: 'value_add_product',
    Accessory: 'accessory',
    Unfinanceable: 'unfinanceable'
};
/**
 *
 * @export
 * @enum {string}
 */
export const ProductType = {
    Warranty: 'warranty',
    GapRtiInsurance: 'gap_rti_insurance',
    SmartInsurance: 'smart_insurance',
    PaintProtection: 'paint_protection',
    KeyInsurance: 'key_insurance',
    Finance: 'finance',
    TyreInsurance: 'tyre_insurance',
    BreakDownCover: 'break_down_cover',
    AlloyWheelInsurance: 'alloy_wheel_insurance',
    ServicePlan: 'service_plan',
    Tracker: 'tracker',
    ValueAddPack: 'value_add_pack'
};
/**
 *
 * @export
 * @enum {string}
 */
export const RecallStatus = {
    NoKnownRecalls: 'no_known_recalls',
    RecallsRemediated: 'recalls_remediated',
    OutstandingRecalls: 'outstanding_recalls',
    Unavailable: 'unavailable'
};
export const ReportTemplateSubjectEnum = {
    Contact: 'contact',
    VehicleInstance: 'vehicle.instance',
    Lead: 'lead',
    Deal: 'deal',
    ArchivedDeal: 'archived.deal',
    AccountingInvoice: 'accounting.invoice',
    AccountingInvoiceItem: 'accounting.invoice.item',
    AccountingExpense: 'accounting.expense',
    AccountingExpenseItem: 'accounting.expense.item',
    AccountingPayment: 'accounting.payment',
    Task: 'task',
    TimeCard: 'time.card',
    Activity: 'activity',
    User: 'user',
    VehicleReservation: 'vehicle.reservation'
};
export const ReportTemplatePeriodEnum = {
    Custom: 'custom',
    ThisWeek: 'this_week',
    ThisMonth: 'this_month',
    ThisQuarter: 'this_quarter',
    ThisYear: 'this_year',
    LastWeek: 'last_week',
    LastMonth: 'last_month',
    LastQuarter: 'last_quarter',
    LastYear: 'last_year',
    Last7: 'last_7',
    Last14: 'last_14',
    Last30: 'last_30',
    Last60: 'last_60',
    Last90: 'last_90',
    Yesterday: 'yesterday',
    Today: 'today',
    Tomorrow: 'tomorrow',
    AllTime: 'all_time',
    NextWeek: 'next_week',
    NextMonth: 'next_month',
    NextQuarter: 'next_quarter',
    NextYear: 'next_year'
};
export const SalesTeamHandoverBookingStrategyEnum = {
    QuarterHourly: 'QuarterHourly',
    HalfHourly: 'HalfHourly',
    Hourly: 'Hourly'
};
export const SalesTeamHandoverBookingSlotLengthEnum = {
    NUMBER_15: 15,
    NUMBER_30: 30,
    NUMBER_60: 60
};
export const SalesTeamHandoverBookingPayloadStrategyEnum = {
    QuarterHourly: 'QuarterHourly',
    HalfHourly: 'HalfHourly',
    Hourly: 'Hourly'
};
export const SalesTeamHandoverBookingPayloadSlotLengthEnum = {
    NUMBER_15: 15,
    NUMBER_30: 30,
    NUMBER_60: 60
};
/**
 *
 * @export
 * @enum {string}
 */
export const StockListingAssetClass = {
    Stock: 'stock',
    CourtesyVehicle: 'courtesy_vehicle',
    DirectorsVehicle: 'directors_vehicle',
    VehicleTransporter: 'vehicle_transporter',
    PoolVehicle: 'pool_vehicle',
    Other: 'other',
    None: 'none'
};
/**
 *
 * @export
 * @enum {string}
 */
export const StockListingForecourtPhase = {
    Profit: 'profit',
    Turn: 'turn',
    Release: 'release',
    Overage: 'overage'
};
export const StockListingLocationPhysicalTypeEnum = {
    Contact: 'contact',
    Location: 'location'
};
/**
 *
 * @export
 * @enum {string}
 */
export const StockListingMarket = {
    None: 'none',
    Trade: 'trade',
    Retail: 'retail'
};
/**
 *
 * @export
 * @enum {string}
 */
export const StockListingStatus = {
    DueIn: 'Due In',
    InStock: 'In Stock',
    Reserved: 'Reserved',
    AwaitingDelivery: 'Awaiting Delivery',
    Sold: 'Sold',
    NonStock: 'Non-Stock'
};
export const StockSettingsDaysToMarketDateKeyEnum = {
    PhotographedOn: 'first_photographed_on',
    AdvertisedOn: 'first_advertised_on'
};
export const StockSettingsPayloadDaysToMarketDateKeyEnum = {
    PhotographedOn: 'first_photographed_on',
    AdvertisedOn: 'first_advertised_on'
};
/**
 *
 * @export
 * @enum {string}
 */
export const TeamType = {
    Sales: 'sales',
    Workshop: 'workshop',
    Bodyshop: 'bodyshop',
    Accounts: 'accounts',
    Valeting: 'valeting',
    Bookable: 'bookable',
    Other: 'other'
};
/**
 *
 * @export
 * @enum {string}
 */
export const TemplateDataSource = {
    VehicleInstance: 'vehicle.instance',
    Quote: 'quote',
    InboxConversation: 'inbox.conversation',
    Deal: 'deal',
    AccountingInvoice: 'accounting.invoice',
    AccountingQuote: 'accounting.quote',
    Lead: 'lead',
    InboxConversationVehicleOfInterest: 'inbox.conversation.vehicle_of_interest',
    InboxConversationPartExchangeOffered: 'inbox.conversation.part_exchange_offered',
    InboxConversationVehicleReserved: 'inbox.conversation.vehicle_reserved',
    InboxConversationAppointment: 'inbox.conversation.appointment',
    InboxConversationLead: 'inbox.conversation.lead'
};
/**
 *
 * @export
 * @enum {string}
 */
export const TemplateFormat = {
    Text: 'text',
    Html: 'html'
};
/**
 *
 * @export
 * @enum {string}
 */
export const TransmissionType = {
    Manual: 'Manual',
    Automatic: 'Automatic'
};
/**
 *
 * @export
 * @enum {string}
 */
export const UseType = {
    Private: 'private',
    Commercial: 'commercial',
    Lifestyle: 'lifestyle',
    HireAndReward: 'hire_and_reward',
    Motability: 'motability'
};
/**
 *
 * @export
 * @enum {string}
 */
export const V5Status = {
    InPossession: 'In Possession',
    MovedToTrade: 'Moved to Trade',
    Missing: 'Missing',
    OnRetention: 'On Retention',
    Motability: 'Motability',
    InTransit: 'In Transit'
};
/**
 *
 * @export
 * @enum {string}
 */
export const VatTreatment = {
    Auto: 'auto',
    Margin: 'margin',
    VatQualifying: 'vat_qualifying',
    Commercial: 'commercial'
};
/**
 *
 * @export
 * @enum {string}
 */
export const VehicleCondition = {
    Poor: 'poor',
    Average: 'average',
    Good: 'good',
    Excellent: 'excellent'
};
/**
 *
 * @export
 * @enum {string}
 */
export const VehicleOwnershipCondition = {
    New: 'new',
    Used: 'used'
};
/**
 *
 * @export
 * @enum {string}
 */
export const VehicleServiceHistory = {
    None: 'none',
    Partial: 'partial',
    Full: 'full',
    FullMainDealer: 'full_main_dealer'
};
/**
 *
 * @export
 * @enum {string}
 */
export const VehicleType = {
    Car: 'Car',
    Lcv: 'LCV',
    Hgv: 'HGV',
    Motorcycle: 'Motorcycle',
    Motorhome: 'Motorhome',
    Caravan: 'Caravan',
    Plant: 'Plant',
    Farm: 'Farm',
    Other: 'Other'
};
/**
 *
 * @export
 * @enum {string}
 */
export const VideoType = {
    Youtube: 'youtube',
    Embed: 'embed'
};
/**
 *
 * @export
 * @enum {string}
 */
export const XeroLegacyStatus = {
    Pending: 'pending',
    Syncing: 'syncing',
    Failed: 'failed',
    Completed: 'completed'
};
/**
 * AccountingApi - axios parameter creator
 * @export
 */
export const AccountingApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get the current state of the accounting integration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountingIntegrationOverview: async (options = {}) => {
            const localVarPath = `/accounting-integration/overview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create a bank transaction allocation
         * @param {Array<BankTransactionAllocationPayload>} bankTransactionAllocationPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allocateBankTransactions: async (bankTransactionAllocationPayload, options = {}) => {
            // verify required parameter 'bankTransactionAllocationPayload' is not null or undefined
            assertParamExists('allocateBankTransactions', 'bankTransactionAllocationPayload', bankTransactionAllocationPayload);
            const localVarPath = `/bank-transaction-allocations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(bankTransactionAllocationPayload, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create a expense credit note allocation
         * @param {Array<CreditNoteAllocationPayload>} creditNoteAllocationPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allocateExpenseCreditNotes: async (creditNoteAllocationPayload, options = {}) => {
            // verify required parameter 'creditNoteAllocationPayload' is not null or undefined
            assertParamExists('allocateExpenseCreditNotes', 'creditNoteAllocationPayload', creditNoteAllocationPayload);
            const localVarPath = `/expense-credit-note-allocations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(creditNoteAllocationPayload, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create a new draft batch
         * @param {CreateDraftBatchPayload} createDraftBatchPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIntegrationBatch: async (createDraftBatchPayload, options = {}) => {
            // verify required parameter 'createDraftBatchPayload' is not null or undefined
            assertParamExists('createIntegrationBatch', 'createDraftBatchPayload', createDraftBatchPayload);
            const localVarPath = `/accounting-integration/batches`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createDraftBatchPayload, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Destroy a bank transaction
         * @param {number} id ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBankTransaction: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteBankTransaction', 'id', id);
            const localVarPath = `/bank-transactions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Destroy an account
         * @param {number} id ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLedgerAccount: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteLedgerAccount', 'id', id);
            const localVarPath = `/chart-of-accounts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Remove a bank transaction allocation
         * @param {number} id ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        destroyBankTransactionAllocation: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('destroyBankTransactionAllocation', 'id', id);
            const localVarPath = `/bank-transaction-allocations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The item will be included in the next batch
         * @summary Remove an item from a batch
         * @param {number} batchId Batch ID
         * @param {number} itemId Item ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        destroyIntegrationBatchItem: async (batchId, itemId, options = {}) => {
            // verify required parameter 'batchId' is not null or undefined
            assertParamExists('destroyIntegrationBatchItem', 'batchId', batchId);
            // verify required parameter 'itemId' is not null or undefined
            assertParamExists('destroyIntegrationBatchItem', 'itemId', itemId);
            const localVarPath = `/accounting-integration/batches/{batch_id}/items/{item_id}`
                .replace(`{${"batch_id"}}`, encodeURIComponent(String(batchId)))
                .replace(`{${"item_id"}}`, encodeURIComponent(String(itemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Disconnect Xero
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disconnectXeroLegacy: async (options = {}) => {
            const localVarPath = `/xero-legacy-integration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Download an accounting export batch created by a file exporter
         * @param {number} id Batch ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadIntegrationBatch: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('downloadIntegrationBatch', 'id', id);
            const localVarPath = `/accounting-integration/batches/{id}/download`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Export a draft batch
         * @param {number} id Batch ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportIntegrationBatch: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('exportIntegrationBatch', 'id', id);
            const localVarPath = `/accounting-integration/batches/{id}/process`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get the current state of the accounting integration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountingIntegration: async (options = {}) => {
            const localVarPath = `/accounting-integration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get the current Auto Entry queue status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAutoEntryStatus: async (options = {}) => {
            const localVarPath = `/ai-auto-entry/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a bank transaction
         * @param {number} id Transaction ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBankTransaction: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getBankTransaction', 'id', id);
            const localVarPath = `/bank-transactions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Gets a paginated list of bank transactions
         * @param {number} [page] Page
         * @param {number} [perPage] Per Page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBankTransactions: async (page, perPage, options = {}) => {
            const localVarPath = `/bank-transactions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Gets a paginated list of export batches
         * @param {number} [page] Page
         * @param {number} [perPage] Per Page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBatches: async (page, perPage, options = {}) => {
            const localVarPath = `/accounting-integration/batches`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Contact Credit Balances
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContactCreditBalances: async (options = {}) => {
            const localVarPath = `/contact-credit-balances`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get the current expense review status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExpenseReviewStatus: async (options = {}) => {
            const localVarPath = `/expenses-review-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get an accounting export batch
         * @param {number} id Batch ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIntegrationBatch: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getIntegrationBatch', 'id', id);
            const localVarPath = `/accounting-integration/batches/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get an account
         * @param {number} id ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLedgerAccount: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getLedgerAccount', 'id', id);
            const localVarPath = `/chart-of-accounts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary List accounts
         * @param {number} [accountId] Parent Account ID
         * @param {LedgerAccountType} [type] Type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLedgerAccounts: async (accountId, type, options = {}) => {
            const localVarPath = `/chart-of-accounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (accountId !== undefined) {
                localVarQueryParameter['account_id'] = accountId;
            }
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Contact Open Balance Controller
         * @param {number} contactId Transaction ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOpenContactBalances: async (contactId, options = {}) => {
            // verify required parameter 'contactId' is not null or undefined
            assertParamExists('getOpenContactBalances', 'contactId', contactId);
            const localVarPath = `/open-contact-balances`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (contactId !== undefined) {
                localVarQueryParameter['contact_id'] = contactId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Gets a paginated list of export batches
         * @param {string} from From
         * @param {string} to To
         * @param {GetProfitAndLossComparisonEnum} [comparison] comparison
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfitAndLoss: async (from, to, comparison, options = {}) => {
            // verify required parameter 'from' is not null or undefined
            assertParamExists('getProfitAndLoss', 'from', from);
            // verify required parameter 'to' is not null or undefined
            assertParamExists('getProfitAndLoss', 'to', to);
            const localVarPath = `/profit-and-loss`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }
            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }
            if (comparison !== undefined) {
                localVarQueryParameter['comparison'] = comparison;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Show the available tax rates.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaxRates: async (options = {}) => {
            const localVarPath = `/tax-rates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get the current Xero sync & connection status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getXeroLegacyStatus: async (options = {}) => {
            const localVarPath = `/xero-legacy-integration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch an account
         * @param {number} id ID
         * @param {StoreLedgerAccountPayload1} storeLedgerAccountPayload1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchLedgerAccount: async (id, storeLedgerAccountPayload1, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patchLedgerAccount', 'id', id);
            // verify required parameter 'storeLedgerAccountPayload1' is not null or undefined
            assertParamExists('patchLedgerAccount', 'storeLedgerAccountPayload1', storeLedgerAccountPayload1);
            const localVarPath = `/chart-of-accounts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(storeLedgerAccountPayload1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This will permanently prevent the item from being exported
         * @summary Mark a batch item as skipped
         * @param {number} batchId Batch ID
         * @param {number} itemId Item ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skipIntegrationBatchItem: async (batchId, itemId, options = {}) => {
            // verify required parameter 'batchId' is not null or undefined
            assertParamExists('skipIntegrationBatchItem', 'batchId', batchId);
            // verify required parameter 'itemId' is not null or undefined
            assertParamExists('skipIntegrationBatchItem', 'itemId', itemId);
            const localVarPath = `/accounting-integration/batches/{batch_id}/items/{item_id}/skip`
                .replace(`{${"batch_id"}}`, encodeURIComponent(String(batchId)))
                .replace(`{${"item_id"}}`, encodeURIComponent(String(itemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Start a Xero sync session
         * @param {XeroLegacyIntegrationPayload} xeroLegacyIntegrationPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startXeroLegacySync: async (xeroLegacyIntegrationPayload, options = {}) => {
            // verify required parameter 'xeroLegacyIntegrationPayload' is not null or undefined
            assertParamExists('startXeroLegacySync', 'xeroLegacyIntegrationPayload', xeroLegacyIntegrationPayload);
            const localVarPath = `/xero-legacy-integration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(xeroLegacyIntegrationPayload, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create a bank transaction
         * @param {StoreBankTransactionPayload} storeBankTransactionPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeBankTransaction: async (storeBankTransactionPayload, options = {}) => {
            // verify required parameter 'storeBankTransactionPayload' is not null or undefined
            assertParamExists('storeBankTransaction', 'storeBankTransactionPayload', storeBankTransactionPayload);
            const localVarPath = `/bank-transactions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(storeBankTransactionPayload, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create an account
         * @param {StoreLedgerAccountPayload} storeLedgerAccountPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeLedgerAccount: async (storeLedgerAccountPayload, options = {}) => {
            // verify required parameter 'storeLedgerAccountPayload' is not null or undefined
            assertParamExists('storeLedgerAccount', 'storeLedgerAccountPayload', storeLedgerAccountPayload);
            const localVarPath = `/chart-of-accounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(storeLedgerAccountPayload, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Submit a document for AI auto entry
         * @param {AccountingAutoEntryPayload} accountingAutoEntryPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitForAutoEntry: async (accountingAutoEntryPayload, options = {}) => {
            // verify required parameter 'accountingAutoEntryPayload' is not null or undefined
            assertParamExists('submitForAutoEntry', 'accountingAutoEntryPayload', accountingAutoEntryPayload);
            const localVarPath = `/ai-auto-entry`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(accountingAutoEntryPayload, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Destroy expense credit note allocation
         * @param {Array<CreditNoteUnallocationPayload>} creditNoteUnallocationPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unallocateExpenseCreditNotes: async (creditNoteUnallocationPayload, options = {}) => {
            // verify required parameter 'creditNoteUnallocationPayload' is not null or undefined
            assertParamExists('unallocateExpenseCreditNotes', 'creditNoteUnallocationPayload', creditNoteUnallocationPayload);
            const localVarPath = `/expense-credit-note-allocations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(creditNoteUnallocationPayload, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AccountingApi - functional programming interface
 * @export
 */
export const AccountingApiFp = function (configuration) {
    const localVarAxiosParamCreator = AccountingApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Get the current state of the accounting integration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountingIntegrationOverview(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountingIntegrationOverview(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingApi.accountingIntegrationOverview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Create a bank transaction allocation
         * @param {Array<BankTransactionAllocationPayload>} bankTransactionAllocationPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async allocateBankTransactions(bankTransactionAllocationPayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.allocateBankTransactions(bankTransactionAllocationPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingApi.allocateBankTransactions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Create a expense credit note allocation
         * @param {Array<CreditNoteAllocationPayload>} creditNoteAllocationPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async allocateExpenseCreditNotes(creditNoteAllocationPayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.allocateExpenseCreditNotes(creditNoteAllocationPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingApi.allocateExpenseCreditNotes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Create a new draft batch
         * @param {CreateDraftBatchPayload} createDraftBatchPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createIntegrationBatch(createDraftBatchPayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createIntegrationBatch(createDraftBatchPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingApi.createIntegrationBatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Destroy a bank transaction
         * @param {number} id ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteBankTransaction(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteBankTransaction(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingApi.deleteBankTransaction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Destroy an account
         * @param {number} id ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteLedgerAccount(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteLedgerAccount(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingApi.deleteLedgerAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Remove a bank transaction allocation
         * @param {number} id ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async destroyBankTransactionAllocation(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.destroyBankTransactionAllocation(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingApi.destroyBankTransactionAllocation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The item will be included in the next batch
         * @summary Remove an item from a batch
         * @param {number} batchId Batch ID
         * @param {number} itemId Item ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async destroyIntegrationBatchItem(batchId, itemId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.destroyIntegrationBatchItem(batchId, itemId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingApi.destroyIntegrationBatchItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Disconnect Xero
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async disconnectXeroLegacy(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.disconnectXeroLegacy(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingApi.disconnectXeroLegacy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Download an accounting export batch created by a file exporter
         * @param {number} id Batch ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadIntegrationBatch(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadIntegrationBatch(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingApi.downloadIntegrationBatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Export a draft batch
         * @param {number} id Batch ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportIntegrationBatch(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportIntegrationBatch(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingApi.exportIntegrationBatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get the current state of the accounting integration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountingIntegration(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountingIntegration(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingApi.getAccountingIntegration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get the current Auto Entry queue status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAutoEntryStatus(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAutoEntryStatus(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingApi.getAutoEntryStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get a bank transaction
         * @param {number} id Transaction ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBankTransaction(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBankTransaction(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingApi.getBankTransaction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Gets a paginated list of bank transactions
         * @param {number} [page] Page
         * @param {number} [perPage] Per Page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBankTransactions(page, perPage, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBankTransactions(page, perPage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingApi.getBankTransactions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Gets a paginated list of export batches
         * @param {number} [page] Page
         * @param {number} [perPage] Per Page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBatches(page, perPage, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBatches(page, perPage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingApi.getBatches']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Contact Credit Balances
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getContactCreditBalances(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getContactCreditBalances(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingApi.getContactCreditBalances']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get the current expense review status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExpenseReviewStatus(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExpenseReviewStatus(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingApi.getExpenseReviewStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get an accounting export batch
         * @param {number} id Batch ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIntegrationBatch(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIntegrationBatch(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingApi.getIntegrationBatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get an account
         * @param {number} id ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLedgerAccount(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLedgerAccount(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingApi.getLedgerAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary List accounts
         * @param {number} [accountId] Parent Account ID
         * @param {LedgerAccountType} [type] Type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLedgerAccounts(accountId, type, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLedgerAccounts(accountId, type, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingApi.getLedgerAccounts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Contact Open Balance Controller
         * @param {number} contactId Transaction ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOpenContactBalances(contactId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOpenContactBalances(contactId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingApi.getOpenContactBalances']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Gets a paginated list of export batches
         * @param {string} from From
         * @param {string} to To
         * @param {GetProfitAndLossComparisonEnum} [comparison] comparison
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProfitAndLoss(from, to, comparison, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProfitAndLoss(from, to, comparison, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingApi.getProfitAndLoss']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Show the available tax rates.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTaxRates(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTaxRates(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingApi.getTaxRates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get the current Xero sync & connection status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getXeroLegacyStatus(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getXeroLegacyStatus(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingApi.getXeroLegacyStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Patch an account
         * @param {number} id ID
         * @param {StoreLedgerAccountPayload1} storeLedgerAccountPayload1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchLedgerAccount(id, storeLedgerAccountPayload1, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchLedgerAccount(id, storeLedgerAccountPayload1, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingApi.patchLedgerAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * This will permanently prevent the item from being exported
         * @summary Mark a batch item as skipped
         * @param {number} batchId Batch ID
         * @param {number} itemId Item ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skipIntegrationBatchItem(batchId, itemId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skipIntegrationBatchItem(batchId, itemId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingApi.skipIntegrationBatchItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Start a Xero sync session
         * @param {XeroLegacyIntegrationPayload} xeroLegacyIntegrationPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startXeroLegacySync(xeroLegacyIntegrationPayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startXeroLegacySync(xeroLegacyIntegrationPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingApi.startXeroLegacySync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Create a bank transaction
         * @param {StoreBankTransactionPayload} storeBankTransactionPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storeBankTransaction(storeBankTransactionPayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storeBankTransaction(storeBankTransactionPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingApi.storeBankTransaction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Create an account
         * @param {StoreLedgerAccountPayload} storeLedgerAccountPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storeLedgerAccount(storeLedgerAccountPayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storeLedgerAccount(storeLedgerAccountPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingApi.storeLedgerAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Submit a document for AI auto entry
         * @param {AccountingAutoEntryPayload} accountingAutoEntryPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitForAutoEntry(accountingAutoEntryPayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitForAutoEntry(accountingAutoEntryPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingApi.submitForAutoEntry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Destroy expense credit note allocation
         * @param {Array<CreditNoteUnallocationPayload>} creditNoteUnallocationPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unallocateExpenseCreditNotes(creditNoteUnallocationPayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unallocateExpenseCreditNotes(creditNoteUnallocationPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingApi.unallocateExpenseCreditNotes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * AccountingApi - factory interface
 * @export
 */
export const AccountingApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AccountingApiFp(configuration);
    return {
        /**
         *
         * @summary Get the current state of the accounting integration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountingIntegrationOverview(options) {
            return localVarFp.accountingIntegrationOverview(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create a bank transaction allocation
         * @param {Array<BankTransactionAllocationPayload>} bankTransactionAllocationPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allocateBankTransactions(bankTransactionAllocationPayload, options) {
            return localVarFp.allocateBankTransactions(bankTransactionAllocationPayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create a expense credit note allocation
         * @param {Array<CreditNoteAllocationPayload>} creditNoteAllocationPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allocateExpenseCreditNotes(creditNoteAllocationPayload, options) {
            return localVarFp.allocateExpenseCreditNotes(creditNoteAllocationPayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create a new draft batch
         * @param {CreateDraftBatchPayload} createDraftBatchPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIntegrationBatch(createDraftBatchPayload, options) {
            return localVarFp.createIntegrationBatch(createDraftBatchPayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Destroy a bank transaction
         * @param {number} id ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBankTransaction(id, options) {
            return localVarFp.deleteBankTransaction(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Destroy an account
         * @param {number} id ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLedgerAccount(id, options) {
            return localVarFp.deleteLedgerAccount(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Remove a bank transaction allocation
         * @param {number} id ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        destroyBankTransactionAllocation(id, options) {
            return localVarFp.destroyBankTransactionAllocation(id, options).then((request) => request(axios, basePath));
        },
        /**
         * The item will be included in the next batch
         * @summary Remove an item from a batch
         * @param {number} batchId Batch ID
         * @param {number} itemId Item ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        destroyIntegrationBatchItem(batchId, itemId, options) {
            return localVarFp.destroyIntegrationBatchItem(batchId, itemId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Disconnect Xero
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disconnectXeroLegacy(options) {
            return localVarFp.disconnectXeroLegacy(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Download an accounting export batch created by a file exporter
         * @param {number} id Batch ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadIntegrationBatch(id, options) {
            return localVarFp.downloadIntegrationBatch(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Export a draft batch
         * @param {number} id Batch ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportIntegrationBatch(id, options) {
            return localVarFp.exportIntegrationBatch(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get the current state of the accounting integration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountingIntegration(options) {
            return localVarFp.getAccountingIntegration(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get the current Auto Entry queue status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAutoEntryStatus(options) {
            return localVarFp.getAutoEntryStatus(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a bank transaction
         * @param {number} id Transaction ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBankTransaction(id, options) {
            return localVarFp.getBankTransaction(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets a paginated list of bank transactions
         * @param {number} [page] Page
         * @param {number} [perPage] Per Page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBankTransactions(page, perPage, options) {
            return localVarFp.getBankTransactions(page, perPage, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets a paginated list of export batches
         * @param {number} [page] Page
         * @param {number} [perPage] Per Page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBatches(page, perPage, options) {
            return localVarFp.getBatches(page, perPage, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Contact Credit Balances
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContactCreditBalances(options) {
            return localVarFp.getContactCreditBalances(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get the current expense review status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExpenseReviewStatus(options) {
            return localVarFp.getExpenseReviewStatus(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get an accounting export batch
         * @param {number} id Batch ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIntegrationBatch(id, options) {
            return localVarFp.getIntegrationBatch(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get an account
         * @param {number} id ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLedgerAccount(id, options) {
            return localVarFp.getLedgerAccount(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List accounts
         * @param {number} [accountId] Parent Account ID
         * @param {LedgerAccountType} [type] Type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLedgerAccounts(accountId, type, options) {
            return localVarFp.getLedgerAccounts(accountId, type, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Contact Open Balance Controller
         * @param {number} contactId Transaction ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOpenContactBalances(contactId, options) {
            return localVarFp.getOpenContactBalances(contactId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets a paginated list of export batches
         * @param {string} from From
         * @param {string} to To
         * @param {GetProfitAndLossComparisonEnum} [comparison] comparison
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfitAndLoss(from, to, comparison, options) {
            return localVarFp.getProfitAndLoss(from, to, comparison, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Show the available tax rates.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaxRates(options) {
            return localVarFp.getTaxRates(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get the current Xero sync & connection status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getXeroLegacyStatus(options) {
            return localVarFp.getXeroLegacyStatus(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch an account
         * @param {number} id ID
         * @param {StoreLedgerAccountPayload1} storeLedgerAccountPayload1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchLedgerAccount(id, storeLedgerAccountPayload1, options) {
            return localVarFp.patchLedgerAccount(id, storeLedgerAccountPayload1, options).then((request) => request(axios, basePath));
        },
        /**
         * This will permanently prevent the item from being exported
         * @summary Mark a batch item as skipped
         * @param {number} batchId Batch ID
         * @param {number} itemId Item ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skipIntegrationBatchItem(batchId, itemId, options) {
            return localVarFp.skipIntegrationBatchItem(batchId, itemId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Start a Xero sync session
         * @param {XeroLegacyIntegrationPayload} xeroLegacyIntegrationPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startXeroLegacySync(xeroLegacyIntegrationPayload, options) {
            return localVarFp.startXeroLegacySync(xeroLegacyIntegrationPayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create a bank transaction
         * @param {StoreBankTransactionPayload} storeBankTransactionPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeBankTransaction(storeBankTransactionPayload, options) {
            return localVarFp.storeBankTransaction(storeBankTransactionPayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create an account
         * @param {StoreLedgerAccountPayload} storeLedgerAccountPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeLedgerAccount(storeLedgerAccountPayload, options) {
            return localVarFp.storeLedgerAccount(storeLedgerAccountPayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Submit a document for AI auto entry
         * @param {AccountingAutoEntryPayload} accountingAutoEntryPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitForAutoEntry(accountingAutoEntryPayload, options) {
            return localVarFp.submitForAutoEntry(accountingAutoEntryPayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Destroy expense credit note allocation
         * @param {Array<CreditNoteUnallocationPayload>} creditNoteUnallocationPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unallocateExpenseCreditNotes(creditNoteUnallocationPayload, options) {
            return localVarFp.unallocateExpenseCreditNotes(creditNoteUnallocationPayload, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AccountingApi - object-oriented interface
 * @export
 * @class AccountingApi
 * @extends {BaseAPI}
 */
export class AccountingApi extends BaseAPI {
    /**
     *
     * @summary Get the current state of the accounting integration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingApi
     */
    accountingIntegrationOverview(options) {
        return AccountingApiFp(this.configuration).accountingIntegrationOverview(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create a bank transaction allocation
     * @param {Array<BankTransactionAllocationPayload>} bankTransactionAllocationPayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingApi
     */
    allocateBankTransactions(bankTransactionAllocationPayload, options) {
        return AccountingApiFp(this.configuration).allocateBankTransactions(bankTransactionAllocationPayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create a expense credit note allocation
     * @param {Array<CreditNoteAllocationPayload>} creditNoteAllocationPayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingApi
     */
    allocateExpenseCreditNotes(creditNoteAllocationPayload, options) {
        return AccountingApiFp(this.configuration).allocateExpenseCreditNotes(creditNoteAllocationPayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create a new draft batch
     * @param {CreateDraftBatchPayload} createDraftBatchPayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingApi
     */
    createIntegrationBatch(createDraftBatchPayload, options) {
        return AccountingApiFp(this.configuration).createIntegrationBatch(createDraftBatchPayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Destroy a bank transaction
     * @param {number} id ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingApi
     */
    deleteBankTransaction(id, options) {
        return AccountingApiFp(this.configuration).deleteBankTransaction(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Destroy an account
     * @param {number} id ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingApi
     */
    deleteLedgerAccount(id, options) {
        return AccountingApiFp(this.configuration).deleteLedgerAccount(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Remove a bank transaction allocation
     * @param {number} id ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingApi
     */
    destroyBankTransactionAllocation(id, options) {
        return AccountingApiFp(this.configuration).destroyBankTransactionAllocation(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * The item will be included in the next batch
     * @summary Remove an item from a batch
     * @param {number} batchId Batch ID
     * @param {number} itemId Item ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingApi
     */
    destroyIntegrationBatchItem(batchId, itemId, options) {
        return AccountingApiFp(this.configuration).destroyIntegrationBatchItem(batchId, itemId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Disconnect Xero
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingApi
     */
    disconnectXeroLegacy(options) {
        return AccountingApiFp(this.configuration).disconnectXeroLegacy(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Download an accounting export batch created by a file exporter
     * @param {number} id Batch ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingApi
     */
    downloadIntegrationBatch(id, options) {
        return AccountingApiFp(this.configuration).downloadIntegrationBatch(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Export a draft batch
     * @param {number} id Batch ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingApi
     */
    exportIntegrationBatch(id, options) {
        return AccountingApiFp(this.configuration).exportIntegrationBatch(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get the current state of the accounting integration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingApi
     */
    getAccountingIntegration(options) {
        return AccountingApiFp(this.configuration).getAccountingIntegration(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get the current Auto Entry queue status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingApi
     */
    getAutoEntryStatus(options) {
        return AccountingApiFp(this.configuration).getAutoEntryStatus(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a bank transaction
     * @param {number} id Transaction ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingApi
     */
    getBankTransaction(id, options) {
        return AccountingApiFp(this.configuration).getBankTransaction(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets a paginated list of bank transactions
     * @param {number} [page] Page
     * @param {number} [perPage] Per Page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingApi
     */
    getBankTransactions(page, perPage, options) {
        return AccountingApiFp(this.configuration).getBankTransactions(page, perPage, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets a paginated list of export batches
     * @param {number} [page] Page
     * @param {number} [perPage] Per Page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingApi
     */
    getBatches(page, perPage, options) {
        return AccountingApiFp(this.configuration).getBatches(page, perPage, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Contact Credit Balances
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingApi
     */
    getContactCreditBalances(options) {
        return AccountingApiFp(this.configuration).getContactCreditBalances(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get the current expense review status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingApi
     */
    getExpenseReviewStatus(options) {
        return AccountingApiFp(this.configuration).getExpenseReviewStatus(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get an accounting export batch
     * @param {number} id Batch ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingApi
     */
    getIntegrationBatch(id, options) {
        return AccountingApiFp(this.configuration).getIntegrationBatch(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get an account
     * @param {number} id ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingApi
     */
    getLedgerAccount(id, options) {
        return AccountingApiFp(this.configuration).getLedgerAccount(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List accounts
     * @param {number} [accountId] Parent Account ID
     * @param {LedgerAccountType} [type] Type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingApi
     */
    getLedgerAccounts(accountId, type, options) {
        return AccountingApiFp(this.configuration).getLedgerAccounts(accountId, type, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Contact Open Balance Controller
     * @param {number} contactId Transaction ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingApi
     */
    getOpenContactBalances(contactId, options) {
        return AccountingApiFp(this.configuration).getOpenContactBalances(contactId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets a paginated list of export batches
     * @param {string} from From
     * @param {string} to To
     * @param {GetProfitAndLossComparisonEnum} [comparison] comparison
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingApi
     */
    getProfitAndLoss(from, to, comparison, options) {
        return AccountingApiFp(this.configuration).getProfitAndLoss(from, to, comparison, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Show the available tax rates.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingApi
     */
    getTaxRates(options) {
        return AccountingApiFp(this.configuration).getTaxRates(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get the current Xero sync & connection status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingApi
     */
    getXeroLegacyStatus(options) {
        return AccountingApiFp(this.configuration).getXeroLegacyStatus(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch an account
     * @param {number} id ID
     * @param {StoreLedgerAccountPayload1} storeLedgerAccountPayload1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingApi
     */
    patchLedgerAccount(id, storeLedgerAccountPayload1, options) {
        return AccountingApiFp(this.configuration).patchLedgerAccount(id, storeLedgerAccountPayload1, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * This will permanently prevent the item from being exported
     * @summary Mark a batch item as skipped
     * @param {number} batchId Batch ID
     * @param {number} itemId Item ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingApi
     */
    skipIntegrationBatchItem(batchId, itemId, options) {
        return AccountingApiFp(this.configuration).skipIntegrationBatchItem(batchId, itemId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Start a Xero sync session
     * @param {XeroLegacyIntegrationPayload} xeroLegacyIntegrationPayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingApi
     */
    startXeroLegacySync(xeroLegacyIntegrationPayload, options) {
        return AccountingApiFp(this.configuration).startXeroLegacySync(xeroLegacyIntegrationPayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create a bank transaction
     * @param {StoreBankTransactionPayload} storeBankTransactionPayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingApi
     */
    storeBankTransaction(storeBankTransactionPayload, options) {
        return AccountingApiFp(this.configuration).storeBankTransaction(storeBankTransactionPayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create an account
     * @param {StoreLedgerAccountPayload} storeLedgerAccountPayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingApi
     */
    storeLedgerAccount(storeLedgerAccountPayload, options) {
        return AccountingApiFp(this.configuration).storeLedgerAccount(storeLedgerAccountPayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Submit a document for AI auto entry
     * @param {AccountingAutoEntryPayload} accountingAutoEntryPayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingApi
     */
    submitForAutoEntry(accountingAutoEntryPayload, options) {
        return AccountingApiFp(this.configuration).submitForAutoEntry(accountingAutoEntryPayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Destroy expense credit note allocation
     * @param {Array<CreditNoteUnallocationPayload>} creditNoteUnallocationPayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingApi
     */
    unallocateExpenseCreditNotes(creditNoteUnallocationPayload, options) {
        return AccountingApiFp(this.configuration).unallocateExpenseCreditNotes(creditNoteUnallocationPayload, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * @export
 */
export const GetProfitAndLossComparisonEnum = {
    Weekly: 'weekly',
    Monthly: 'monthly',
    Yearly: 'yearly'
};
/**
 * AccountingExportsApi - axios parameter creator
 * @export
 */
export const AccountingExportsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Export expenses created within a date range to Xero.
         * @param {string} from From
         * @param {string} to To
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportForSage50: async (from, to, options = {}) => {
            // verify required parameter 'from' is not null or undefined
            assertParamExists('exportForSage50', 'from', from);
            // verify required parameter 'to' is not null or undefined
            assertParamExists('exportForSage50', 'to', to);
            const localVarPath = `/accounting/exports/sage-50`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }
            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Export expenses created within a date range to Xero.
         * @param {string} from From
         * @param {string} to To
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportForXero: async (from, to, options = {}) => {
            // verify required parameter 'from' is not null or undefined
            assertParamExists('exportForXero', 'from', from);
            // verify required parameter 'to' is not null or undefined
            assertParamExists('exportForXero', 'to', to);
            const localVarPath = `/accounting/exports/xero`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }
            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AccountingExportsApi - functional programming interface
 * @export
 */
export const AccountingExportsApiFp = function (configuration) {
    const localVarAxiosParamCreator = AccountingExportsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Export expenses created within a date range to Xero.
         * @param {string} from From
         * @param {string} to To
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportForSage50(from, to, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportForSage50(from, to, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingExportsApi.exportForSage50']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Export expenses created within a date range to Xero.
         * @param {string} from From
         * @param {string} to To
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportForXero(from, to, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportForXero(from, to, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountingExportsApi.exportForXero']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * AccountingExportsApi - factory interface
 * @export
 */
export const AccountingExportsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AccountingExportsApiFp(configuration);
    return {
        /**
         *
         * @summary Export expenses created within a date range to Xero.
         * @param {string} from From
         * @param {string} to To
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportForSage50(from, to, options) {
            return localVarFp.exportForSage50(from, to, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Export expenses created within a date range to Xero.
         * @param {string} from From
         * @param {string} to To
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportForXero(from, to, options) {
            return localVarFp.exportForXero(from, to, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AccountingExportsApi - object-oriented interface
 * @export
 * @class AccountingExportsApi
 * @extends {BaseAPI}
 */
export class AccountingExportsApi extends BaseAPI {
    /**
     *
     * @summary Export expenses created within a date range to Xero.
     * @param {string} from From
     * @param {string} to To
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingExportsApi
     */
    exportForSage50(from, to, options) {
        return AccountingExportsApiFp(this.configuration).exportForSage50(from, to, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Export expenses created within a date range to Xero.
     * @param {string} from From
     * @param {string} to To
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountingExportsApi
     */
    exportForXero(from, to, options) {
        return AccountingExportsApiFp(this.configuration).exportForXero(from, to, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AdvertisingApi - axios parameter creator
 * @export
 */
export const AdvertisingApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Delete an advertising template
         * @param {number} id ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        destroyAdvertisingTemplate: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('destroyAdvertisingTemplate', 'id', id);
            const localVarPath = `/advertising-description-templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary List templates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdvertisingDescriptionTemplates: async (options = {}) => {
            const localVarPath = `/advertising-description-templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get an advertising template
         * @param {number} id ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdvertisingTemplate: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAdvertisingTemplate', 'id', id);
            const localVarPath = `/advertising-description-templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Provides currently advertised stock in Google Vehicle Listing CSV format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGoogleVehicleListingFeed: async (options = {}) => {
            const localVarPath = `/google-vehicle-listing-feed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Provides currently advertised stock in meta catalogue CSV format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMetaCatalogue: async (options = {}) => {
            const localVarPath = `/meta-catalogue`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Store an advertising template
         * @param {StoreAdvertisingDescriptionPayload} storeAdvertisingDescriptionPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeAdvertisingTemplate: async (storeAdvertisingDescriptionPayload, options = {}) => {
            // verify required parameter 'storeAdvertisingDescriptionPayload' is not null or undefined
            assertParamExists('storeAdvertisingTemplate', 'storeAdvertisingDescriptionPayload', storeAdvertisingDescriptionPayload);
            const localVarPath = `/advertising-description-templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(storeAdvertisingDescriptionPayload, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AdvertisingApi - functional programming interface
 * @export
 */
export const AdvertisingApiFp = function (configuration) {
    const localVarAxiosParamCreator = AdvertisingApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Delete an advertising template
         * @param {number} id ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async destroyAdvertisingTemplate(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.destroyAdvertisingTemplate(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdvertisingApi.destroyAdvertisingTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary List templates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdvertisingDescriptionTemplates(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdvertisingDescriptionTemplates(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdvertisingApi.getAdvertisingDescriptionTemplates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get an advertising template
         * @param {number} id ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdvertisingTemplate(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdvertisingTemplate(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdvertisingApi.getAdvertisingTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Provides currently advertised stock in Google Vehicle Listing CSV format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGoogleVehicleListingFeed(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGoogleVehicleListingFeed(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdvertisingApi.getGoogleVehicleListingFeed']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Provides currently advertised stock in meta catalogue CSV format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMetaCatalogue(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMetaCatalogue(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdvertisingApi.getMetaCatalogue']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Store an advertising template
         * @param {StoreAdvertisingDescriptionPayload} storeAdvertisingDescriptionPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storeAdvertisingTemplate(storeAdvertisingDescriptionPayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storeAdvertisingTemplate(storeAdvertisingDescriptionPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdvertisingApi.storeAdvertisingTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * AdvertisingApi - factory interface
 * @export
 */
export const AdvertisingApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AdvertisingApiFp(configuration);
    return {
        /**
         *
         * @summary Delete an advertising template
         * @param {number} id ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        destroyAdvertisingTemplate(id, options) {
            return localVarFp.destroyAdvertisingTemplate(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List templates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdvertisingDescriptionTemplates(options) {
            return localVarFp.getAdvertisingDescriptionTemplates(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get an advertising template
         * @param {number} id ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdvertisingTemplate(id, options) {
            return localVarFp.getAdvertisingTemplate(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Provides currently advertised stock in Google Vehicle Listing CSV format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGoogleVehicleListingFeed(options) {
            return localVarFp.getGoogleVehicleListingFeed(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Provides currently advertised stock in meta catalogue CSV format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMetaCatalogue(options) {
            return localVarFp.getMetaCatalogue(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Store an advertising template
         * @param {StoreAdvertisingDescriptionPayload} storeAdvertisingDescriptionPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeAdvertisingTemplate(storeAdvertisingDescriptionPayload, options) {
            return localVarFp.storeAdvertisingTemplate(storeAdvertisingDescriptionPayload, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AdvertisingApi - object-oriented interface
 * @export
 * @class AdvertisingApi
 * @extends {BaseAPI}
 */
export class AdvertisingApi extends BaseAPI {
    /**
     *
     * @summary Delete an advertising template
     * @param {number} id ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvertisingApi
     */
    destroyAdvertisingTemplate(id, options) {
        return AdvertisingApiFp(this.configuration).destroyAdvertisingTemplate(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List templates
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvertisingApi
     */
    getAdvertisingDescriptionTemplates(options) {
        return AdvertisingApiFp(this.configuration).getAdvertisingDescriptionTemplates(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get an advertising template
     * @param {number} id ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvertisingApi
     */
    getAdvertisingTemplate(id, options) {
        return AdvertisingApiFp(this.configuration).getAdvertisingTemplate(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Provides currently advertised stock in Google Vehicle Listing CSV format
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvertisingApi
     */
    getGoogleVehicleListingFeed(options) {
        return AdvertisingApiFp(this.configuration).getGoogleVehicleListingFeed(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Provides currently advertised stock in meta catalogue CSV format
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvertisingApi
     */
    getMetaCatalogue(options) {
        return AdvertisingApiFp(this.configuration).getMetaCatalogue(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Store an advertising template
     * @param {StoreAdvertisingDescriptionPayload} storeAdvertisingDescriptionPayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvertisingApi
     */
    storeAdvertisingTemplate(storeAdvertisingDescriptionPayload, options) {
        return AdvertisingApiFp(this.configuration).storeAdvertisingTemplate(storeAdvertisingDescriptionPayload, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AdvertisingChannelsApi - axios parameter creator
 * @export
 */
export const AdvertisingChannelsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Gets a list of advertising channels.
         * @param {boolean} [stockCounts] Stock Counts
         * @param {boolean} [ids] IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdvertisingChannels: async (stockCounts, ids, options = {}) => {
            const localVarPath = `/advertising-channels`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (stockCounts !== undefined) {
                localVarQueryParameter['stock_counts'] = stockCounts;
            }
            if (ids !== undefined) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch an advertising channel
         * @param {string} channelHandle Channel Handle
         * @param {PatchAdvertisingChannelPayload} patchAdvertisingChannelPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAdvertisingChannel: async (channelHandle, patchAdvertisingChannelPayload, options = {}) => {
            // verify required parameter 'channelHandle' is not null or undefined
            assertParamExists('patchAdvertisingChannel', 'channelHandle', channelHandle);
            // verify required parameter 'patchAdvertisingChannelPayload' is not null or undefined
            assertParamExists('patchAdvertisingChannel', 'patchAdvertisingChannelPayload', patchAdvertisingChannelPayload);
            const localVarPath = `/advertising-channels/{channel_handle}`
                .replace(`{${"channel_handle"}}`, encodeURIComponent(String(channelHandle)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(patchAdvertisingChannelPayload, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AdvertisingChannelsApi - functional programming interface
 * @export
 */
export const AdvertisingChannelsApiFp = function (configuration) {
    const localVarAxiosParamCreator = AdvertisingChannelsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Gets a list of advertising channels.
         * @param {boolean} [stockCounts] Stock Counts
         * @param {boolean} [ids] IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdvertisingChannels(stockCounts, ids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdvertisingChannels(stockCounts, ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdvertisingChannelsApi.getAdvertisingChannels']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Patch an advertising channel
         * @param {string} channelHandle Channel Handle
         * @param {PatchAdvertisingChannelPayload} patchAdvertisingChannelPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchAdvertisingChannel(channelHandle, patchAdvertisingChannelPayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchAdvertisingChannel(channelHandle, patchAdvertisingChannelPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdvertisingChannelsApi.patchAdvertisingChannel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * AdvertisingChannelsApi - factory interface
 * @export
 */
export const AdvertisingChannelsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AdvertisingChannelsApiFp(configuration);
    return {
        /**
         *
         * @summary Gets a list of advertising channels.
         * @param {boolean} [stockCounts] Stock Counts
         * @param {boolean} [ids] IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdvertisingChannels(stockCounts, ids, options) {
            return localVarFp.getAdvertisingChannels(stockCounts, ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch an advertising channel
         * @param {string} channelHandle Channel Handle
         * @param {PatchAdvertisingChannelPayload} patchAdvertisingChannelPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAdvertisingChannel(channelHandle, patchAdvertisingChannelPayload, options) {
            return localVarFp.patchAdvertisingChannel(channelHandle, patchAdvertisingChannelPayload, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AdvertisingChannelsApi - object-oriented interface
 * @export
 * @class AdvertisingChannelsApi
 * @extends {BaseAPI}
 */
export class AdvertisingChannelsApi extends BaseAPI {
    /**
     *
     * @summary Gets a list of advertising channels.
     * @param {boolean} [stockCounts] Stock Counts
     * @param {boolean} [ids] IDs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvertisingChannelsApi
     */
    getAdvertisingChannels(stockCounts, ids, options) {
        return AdvertisingChannelsApiFp(this.configuration).getAdvertisingChannels(stockCounts, ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch an advertising channel
     * @param {string} channelHandle Channel Handle
     * @param {PatchAdvertisingChannelPayload} patchAdvertisingChannelPayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvertisingChannelsApi
     */
    patchAdvertisingChannel(channelHandle, patchAdvertisingChannelPayload, options) {
        return AdvertisingChannelsApiFp(this.configuration).patchAdvertisingChannel(channelHandle, patchAdvertisingChannelPayload, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AnalyticsApi - axios parameter creator
 * @export
 */
export const AnalyticsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Gets a paginated list of kits
         * @param {AnalyticDatapointType} [type] Data Point Type
         * @param {GetAnalyticsResolutionEnum} [resolution] Resolution
         * @param {string} [from] Date From
         * @param {string} [to] Date To
         * @param {string} [labelGroup] Label to group by
         * @param {string} [labelFilter] Label to filter by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnalytics: async (type, resolution, from, to, labelGroup, labelFilter, options = {}) => {
            const localVarPath = `/analytics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            if (resolution !== undefined) {
                localVarQueryParameter['resolution'] = resolution;
            }
            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }
            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }
            if (labelGroup !== undefined) {
                localVarQueryParameter['label_group'] = labelGroup;
            }
            if (labelFilter !== undefined) {
                localVarQueryParameter['label_filter'] = labelFilter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AnalyticsApi - functional programming interface
 * @export
 */
export const AnalyticsApiFp = function (configuration) {
    const localVarAxiosParamCreator = AnalyticsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Gets a paginated list of kits
         * @param {AnalyticDatapointType} [type] Data Point Type
         * @param {GetAnalyticsResolutionEnum} [resolution] Resolution
         * @param {string} [from] Date From
         * @param {string} [to] Date To
         * @param {string} [labelGroup] Label to group by
         * @param {string} [labelFilter] Label to filter by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAnalytics(type, resolution, from, to, labelGroup, labelFilter, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAnalytics(type, resolution, from, to, labelGroup, labelFilter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsApi.getAnalytics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * AnalyticsApi - factory interface
 * @export
 */
export const AnalyticsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AnalyticsApiFp(configuration);
    return {
        /**
         *
         * @summary Gets a paginated list of kits
         * @param {AnalyticDatapointType} [type] Data Point Type
         * @param {GetAnalyticsResolutionEnum} [resolution] Resolution
         * @param {string} [from] Date From
         * @param {string} [to] Date To
         * @param {string} [labelGroup] Label to group by
         * @param {string} [labelFilter] Label to filter by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnalytics(type, resolution, from, to, labelGroup, labelFilter, options) {
            return localVarFp.getAnalytics(type, resolution, from, to, labelGroup, labelFilter, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AnalyticsApi - object-oriented interface
 * @export
 * @class AnalyticsApi
 * @extends {BaseAPI}
 */
export class AnalyticsApi extends BaseAPI {
    /**
     *
     * @summary Gets a paginated list of kits
     * @param {AnalyticDatapointType} [type] Data Point Type
     * @param {GetAnalyticsResolutionEnum} [resolution] Resolution
     * @param {string} [from] Date From
     * @param {string} [to] Date To
     * @param {string} [labelGroup] Label to group by
     * @param {string} [labelFilter] Label to filter by
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalyticsApi
     */
    getAnalytics(type, resolution, from, to, labelGroup, labelFilter, options) {
        return AnalyticsApiFp(this.configuration).getAnalytics(type, resolution, from, to, labelGroup, labelFilter, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * @export
 */
export const GetAnalyticsResolutionEnum = {
    Hours: 'hours',
    Days: 'days',
    Weeks: 'weeks',
    Months: 'months',
    Years: 'years'
};
/**
 * AssistantApi - axios parameter creator
 * @export
 */
export const AssistantApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Create a new discussion
         * @param {CreateAssistantDiscussionRequestBody} [createAssistantDiscussionRequestBody] Create Assistant Discussion Request Body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAssistantDiscussion: async (createAssistantDiscussionRequestBody, options = {}) => {
            const localVarPath = `/assistant-discussions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createAssistantDiscussionRequestBody, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create a new message in a discussion
         * @param {number} id ID
         * @param {CreateAssistantDiscussionMessageRequestBody} [createAssistantDiscussionMessageRequestBody] Create Assistant Discussion Message Request Body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAssistantDiscussionMessage: async (id, createAssistantDiscussionMessageRequestBody, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createAssistantDiscussionMessage', 'id', id);
            const localVarPath = `/assistant-discussions/{id}/messages`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createAssistantDiscussionMessageRequestBody, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete a discussion
         * @param {number} id ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        destroyAssistantDiscussion: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('destroyAssistantDiscussion', 'id', id);
            const localVarPath = `/assistant-discussions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Show the users discussions.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssistantDiscussions: async (options = {}) => {
            const localVarPath = `/assistant-discussions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AssistantApi - functional programming interface
 * @export
 */
export const AssistantApiFp = function (configuration) {
    const localVarAxiosParamCreator = AssistantApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Create a new discussion
         * @param {CreateAssistantDiscussionRequestBody} [createAssistantDiscussionRequestBody] Create Assistant Discussion Request Body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAssistantDiscussion(createAssistantDiscussionRequestBody, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAssistantDiscussion(createAssistantDiscussionRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssistantApi.createAssistantDiscussion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Create a new message in a discussion
         * @param {number} id ID
         * @param {CreateAssistantDiscussionMessageRequestBody} [createAssistantDiscussionMessageRequestBody] Create Assistant Discussion Message Request Body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAssistantDiscussionMessage(id, createAssistantDiscussionMessageRequestBody, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAssistantDiscussionMessage(id, createAssistantDiscussionMessageRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssistantApi.createAssistantDiscussionMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Delete a discussion
         * @param {number} id ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async destroyAssistantDiscussion(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.destroyAssistantDiscussion(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssistantApi.destroyAssistantDiscussion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Show the users discussions.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAssistantDiscussions(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAssistantDiscussions(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssistantApi.getAssistantDiscussions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * AssistantApi - factory interface
 * @export
 */
export const AssistantApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AssistantApiFp(configuration);
    return {
        /**
         *
         * @summary Create a new discussion
         * @param {CreateAssistantDiscussionRequestBody} [createAssistantDiscussionRequestBody] Create Assistant Discussion Request Body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAssistantDiscussion(createAssistantDiscussionRequestBody, options) {
            return localVarFp.createAssistantDiscussion(createAssistantDiscussionRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create a new message in a discussion
         * @param {number} id ID
         * @param {CreateAssistantDiscussionMessageRequestBody} [createAssistantDiscussionMessageRequestBody] Create Assistant Discussion Message Request Body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAssistantDiscussionMessage(id, createAssistantDiscussionMessageRequestBody, options) {
            return localVarFp.createAssistantDiscussionMessage(id, createAssistantDiscussionMessageRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a discussion
         * @param {number} id ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        destroyAssistantDiscussion(id, options) {
            return localVarFp.destroyAssistantDiscussion(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Show the users discussions.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssistantDiscussions(options) {
            return localVarFp.getAssistantDiscussions(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AssistantApi - object-oriented interface
 * @export
 * @class AssistantApi
 * @extends {BaseAPI}
 */
export class AssistantApi extends BaseAPI {
    /**
     *
     * @summary Create a new discussion
     * @param {CreateAssistantDiscussionRequestBody} [createAssistantDiscussionRequestBody] Create Assistant Discussion Request Body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssistantApi
     */
    createAssistantDiscussion(createAssistantDiscussionRequestBody, options) {
        return AssistantApiFp(this.configuration).createAssistantDiscussion(createAssistantDiscussionRequestBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create a new message in a discussion
     * @param {number} id ID
     * @param {CreateAssistantDiscussionMessageRequestBody} [createAssistantDiscussionMessageRequestBody] Create Assistant Discussion Message Request Body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssistantApi
     */
    createAssistantDiscussionMessage(id, createAssistantDiscussionMessageRequestBody, options) {
        return AssistantApiFp(this.configuration).createAssistantDiscussionMessage(id, createAssistantDiscussionMessageRequestBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete a discussion
     * @param {number} id ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssistantApi
     */
    destroyAssistantDiscussion(id, options) {
        return AssistantApiFp(this.configuration).destroyAssistantDiscussion(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Show the users discussions.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssistantApi
     */
    getAssistantDiscussions(options) {
        return AssistantApiFp(this.configuration).getAssistantDiscussions(options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AuthApi - axios parameter creator
 * @export
 */
export const AuthApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get support access log entries
         * @param {number} [perPage] Number of results per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupportAccessLogs: async (perPage, options = {}) => {
            const localVarPath = `/auth/support-access/logs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Support access status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupportAccessStatus: async (options = {}) => {
            const localVarPath = `/auth/support-access`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Grant support access
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantSupportAccess: async (options = {}) => {
            const localVarPath = `/auth/support-access`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Revoke support access
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeSupportAccess: async (options = {}) => {
            const localVarPath = `/auth/support-access`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AuthApi - functional programming interface
 * @export
 */
export const AuthApiFp = function (configuration) {
    const localVarAxiosParamCreator = AuthApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Get support access log entries
         * @param {number} [perPage] Number of results per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSupportAccessLogs(perPage, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSupportAccessLogs(perPage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.getSupportAccessLogs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Support access status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSupportAccessStatus(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSupportAccessStatus(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.getSupportAccessStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Grant support access
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async grantSupportAccess(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.grantSupportAccess(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.grantSupportAccess']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Revoke support access
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revokeSupportAccess(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revokeSupportAccess(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.revokeSupportAccess']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * AuthApi - factory interface
 * @export
 */
export const AuthApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AuthApiFp(configuration);
    return {
        /**
         *
         * @summary Get support access log entries
         * @param {number} [perPage] Number of results per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupportAccessLogs(perPage, options) {
            return localVarFp.getSupportAccessLogs(perPage, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Support access status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupportAccessStatus(options) {
            return localVarFp.getSupportAccessStatus(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Grant support access
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantSupportAccess(options) {
            return localVarFp.grantSupportAccess(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Revoke support access
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeSupportAccess(options) {
            return localVarFp.revokeSupportAccess(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AuthApi - object-oriented interface
 * @export
 * @class AuthApi
 * @extends {BaseAPI}
 */
export class AuthApi extends BaseAPI {
    /**
     *
     * @summary Get support access log entries
     * @param {number} [perPage] Number of results per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    getSupportAccessLogs(perPage, options) {
        return AuthApiFp(this.configuration).getSupportAccessLogs(perPage, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Support access status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    getSupportAccessStatus(options) {
        return AuthApiFp(this.configuration).getSupportAccessStatus(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Grant support access
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    grantSupportAccess(options) {
        return AuthApiFp(this.configuration).grantSupportAccess(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Revoke support access
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    revokeSupportAccess(options) {
        return AuthApiFp(this.configuration).revokeSupportAccess(options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * CRMApi - axios parameter creator
 * @export
 */
export const CRMApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Delete a referral source
         * @param {string} id ID of the referral source
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        destroyReferralSource: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('destroyReferralSource', 'id', id);
            const localVarPath = `/referral-sources/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Exports all a contacts conversations plain/text content to ZIP file
         * @param {ContactConversationExportPayload} contactConversationExportPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportContactConversations: async (contactConversationExportPayload, options = {}) => {
            // verify required parameter 'contactConversationExportPayload' is not null or undefined
            assertParamExists('exportContactConversations', 'contactConversationExportPayload', contactConversationExportPayload);
            const localVarPath = `/contact-conversation-export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(contactConversationExportPayload, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Exports conversation plain/text content to ZIP file
         * @param {ConversationExportPayload} conversationExportPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportConversation: async (conversationExportPayload, options = {}) => {
            // verify required parameter 'conversationExportPayload' is not null or undefined
            assertParamExists('exportConversation', 'conversationExportPayload', conversationExportPayload);
            const localVarPath = `/conversation-export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(conversationExportPayload, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get available template data sources for a contact
         * @param {number} id ID of the contact
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContactTemplateDataSources: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getContactTemplateDataSources', 'id', id);
            const localVarPath = `/contacts/{id}/template-data-sources`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a referral source
         * @param {number} id ID of the referral source
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferralSource: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getReferralSource', 'id', id);
            const localVarPath = `/referral-sources/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Show the referral sources.
         * @param {number} [page] Page Number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferralSources: async (page, options = {}) => {
            const localVarPath = `/referral-sources`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch a referral source
         * @param {number} id ID of the referral source
         * @param {StoreReferralSourcePayload} storeReferralSourcePayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchReferralSource: async (id, storeReferralSourcePayload, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patchReferralSource', 'id', id);
            // verify required parameter 'storeReferralSourcePayload' is not null or undefined
            assertParamExists('patchReferralSource', 'storeReferralSourcePayload', storeReferralSourcePayload);
            const localVarPath = `/referral-sources/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(storeReferralSourcePayload, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create a referral source
         * @param {PatchReferralSourcePayload} patchReferralSourcePayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeReferralSource: async (patchReferralSourcePayload, options = {}) => {
            // verify required parameter 'patchReferralSourcePayload' is not null or undefined
            assertParamExists('storeReferralSource', 'patchReferralSourcePayload', patchReferralSourcePayload);
            const localVarPath = `/referral-sources`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(patchReferralSourcePayload, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * CRMApi - functional programming interface
 * @export
 */
export const CRMApiFp = function (configuration) {
    const localVarAxiosParamCreator = CRMApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Delete a referral source
         * @param {string} id ID of the referral source
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async destroyReferralSource(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.destroyReferralSource(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CRMApi.destroyReferralSource']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Exports all a contacts conversations plain/text content to ZIP file
         * @param {ContactConversationExportPayload} contactConversationExportPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportContactConversations(contactConversationExportPayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportContactConversations(contactConversationExportPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CRMApi.exportContactConversations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Exports conversation plain/text content to ZIP file
         * @param {ConversationExportPayload} conversationExportPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportConversation(conversationExportPayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportConversation(conversationExportPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CRMApi.exportConversation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get available template data sources for a contact
         * @param {number} id ID of the contact
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getContactTemplateDataSources(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getContactTemplateDataSources(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CRMApi.getContactTemplateDataSources']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get a referral source
         * @param {number} id ID of the referral source
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReferralSource(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReferralSource(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CRMApi.getReferralSource']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Show the referral sources.
         * @param {number} [page] Page Number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReferralSources(page, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReferralSources(page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CRMApi.getReferralSources']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Patch a referral source
         * @param {number} id ID of the referral source
         * @param {StoreReferralSourcePayload} storeReferralSourcePayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchReferralSource(id, storeReferralSourcePayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchReferralSource(id, storeReferralSourcePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CRMApi.patchReferralSource']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Create a referral source
         * @param {PatchReferralSourcePayload} patchReferralSourcePayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storeReferralSource(patchReferralSourcePayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storeReferralSource(patchReferralSourcePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CRMApi.storeReferralSource']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * CRMApi - factory interface
 * @export
 */
export const CRMApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CRMApiFp(configuration);
    return {
        /**
         *
         * @summary Delete a referral source
         * @param {string} id ID of the referral source
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        destroyReferralSource(id, options) {
            return localVarFp.destroyReferralSource(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Exports all a contacts conversations plain/text content to ZIP file
         * @param {ContactConversationExportPayload} contactConversationExportPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportContactConversations(contactConversationExportPayload, options) {
            return localVarFp.exportContactConversations(contactConversationExportPayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Exports conversation plain/text content to ZIP file
         * @param {ConversationExportPayload} conversationExportPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportConversation(conversationExportPayload, options) {
            return localVarFp.exportConversation(conversationExportPayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get available template data sources for a contact
         * @param {number} id ID of the contact
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContactTemplateDataSources(id, options) {
            return localVarFp.getContactTemplateDataSources(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a referral source
         * @param {number} id ID of the referral source
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferralSource(id, options) {
            return localVarFp.getReferralSource(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Show the referral sources.
         * @param {number} [page] Page Number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferralSources(page, options) {
            return localVarFp.getReferralSources(page, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch a referral source
         * @param {number} id ID of the referral source
         * @param {StoreReferralSourcePayload} storeReferralSourcePayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchReferralSource(id, storeReferralSourcePayload, options) {
            return localVarFp.patchReferralSource(id, storeReferralSourcePayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create a referral source
         * @param {PatchReferralSourcePayload} patchReferralSourcePayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeReferralSource(patchReferralSourcePayload, options) {
            return localVarFp.storeReferralSource(patchReferralSourcePayload, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CRMApi - object-oriented interface
 * @export
 * @class CRMApi
 * @extends {BaseAPI}
 */
export class CRMApi extends BaseAPI {
    /**
     *
     * @summary Delete a referral source
     * @param {string} id ID of the referral source
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CRMApi
     */
    destroyReferralSource(id, options) {
        return CRMApiFp(this.configuration).destroyReferralSource(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Exports all a contacts conversations plain/text content to ZIP file
     * @param {ContactConversationExportPayload} contactConversationExportPayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CRMApi
     */
    exportContactConversations(contactConversationExportPayload, options) {
        return CRMApiFp(this.configuration).exportContactConversations(contactConversationExportPayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Exports conversation plain/text content to ZIP file
     * @param {ConversationExportPayload} conversationExportPayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CRMApi
     */
    exportConversation(conversationExportPayload, options) {
        return CRMApiFp(this.configuration).exportConversation(conversationExportPayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get available template data sources for a contact
     * @param {number} id ID of the contact
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CRMApi
     */
    getContactTemplateDataSources(id, options) {
        return CRMApiFp(this.configuration).getContactTemplateDataSources(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a referral source
     * @param {number} id ID of the referral source
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CRMApi
     */
    getReferralSource(id, options) {
        return CRMApiFp(this.configuration).getReferralSource(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Show the referral sources.
     * @param {number} [page] Page Number
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CRMApi
     */
    getReferralSources(page, options) {
        return CRMApiFp(this.configuration).getReferralSources(page, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch a referral source
     * @param {number} id ID of the referral source
     * @param {StoreReferralSourcePayload} storeReferralSourcePayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CRMApi
     */
    patchReferralSource(id, storeReferralSourcePayload, options) {
        return CRMApiFp(this.configuration).patchReferralSource(id, storeReferralSourcePayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create a referral source
     * @param {PatchReferralSourcePayload} patchReferralSourcePayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CRMApi
     */
    storeReferralSource(patchReferralSourcePayload, options) {
        return CRMApiFp(this.configuration).storeReferralSource(patchReferralSourcePayload, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * CompanyApi - axios parameter creator
 * @export
 */
export const CompanyApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Delete a knowledge base item
         * @param {number} id Knowledge ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        destroyKnowledge: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('destroyKnowledge', 'id', id);
            const localVarPath = `/knowledge/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get the past invoice
         * @param {number} id Invoice ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadCompanyInvoice: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('downloadCompanyInvoice', 'id', id);
            const localVarPath = `/company/billing/invoices/{id}/pdf`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Show the authenticated users company.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompany: async (options = {}) => {
            const localVarPath = `/company`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get the current companies branding
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyBranding: async (options = {}) => {
            const localVarPath = `/company/branding`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get the companies past invoices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyInvoices: async (options = {}) => {
            const localVarPath = `/company/billing/invoices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get the companies estimated next invoice estimate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyNextInvoiceEstimate: async (options = {}) => {
            const localVarPath = `/company/billing/next-invoice-estimate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get the company\'s phone and email addresses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyPhoneAndEmailAddresses: async (options = {}) => {
            const localVarPath = `/company/phone-and-email-addresses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get the companies usage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyUsage: async (options = {}) => {
            const localVarPath = `/company/billing/usage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary List the knowledge base
         * @param {number} page Page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listKnowledge: async (page, options = {}) => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('listKnowledge', 'page', page);
            const localVarPath = `/knowledge`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch the authenticated users company.
         * @param {PatchCompanyDetailsRequestBody} [patchCompanyDetailsRequestBody] Patch Company Details Request Body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCompany: async (patchCompanyDetailsRequestBody, options = {}) => {
            const localVarPath = `/company`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(patchCompanyDetailsRequestBody, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create a knowledge base item
         * @param {number} id Knowledge ID
         * @param {PatchKnowledgePayload} patchKnowledgePayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchKnowledge: async (id, patchKnowledgePayload, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patchKnowledge', 'id', id);
            // verify required parameter 'patchKnowledgePayload' is not null or undefined
            assertParamExists('patchKnowledge', 'patchKnowledgePayload', patchKnowledgePayload);
            const localVarPath = `/knowledge/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(patchKnowledgePayload, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Search the knowledge base
         * @param {string} query Query term
         * @param {number} page Page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchKnowledge: async (query, page, options = {}) => {
            // verify required parameter 'query' is not null or undefined
            assertParamExists('searchKnowledge', 'query', query);
            // verify required parameter 'page' is not null or undefined
            assertParamExists('searchKnowledge', 'page', page);
            const localVarPath = `/knowledge/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create a knowledge base item
         * @param {StoreKnowledgePayload} storeKnowledgePayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeKnowledge: async (storeKnowledgePayload, options = {}) => {
            // verify required parameter 'storeKnowledgePayload' is not null or undefined
            assertParamExists('storeKnowledge', 'storeKnowledgePayload', storeKnowledgePayload);
            const localVarPath = `/knowledge`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(storeKnowledgePayload, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * CompanyApi - functional programming interface
 * @export
 */
export const CompanyApiFp = function (configuration) {
    const localVarAxiosParamCreator = CompanyApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Delete a knowledge base item
         * @param {number} id Knowledge ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async destroyKnowledge(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.destroyKnowledge(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.destroyKnowledge']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get the past invoice
         * @param {number} id Invoice ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadCompanyInvoice(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadCompanyInvoice(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.downloadCompanyInvoice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Show the authenticated users company.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompany(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompany(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.getCompany']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get the current companies branding
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompanyBranding(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompanyBranding(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.getCompanyBranding']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get the companies past invoices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompanyInvoices(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompanyInvoices(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.getCompanyInvoices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get the companies estimated next invoice estimate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompanyNextInvoiceEstimate(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompanyNextInvoiceEstimate(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.getCompanyNextInvoiceEstimate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get the company\'s phone and email addresses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompanyPhoneAndEmailAddresses(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompanyPhoneAndEmailAddresses(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.getCompanyPhoneAndEmailAddresses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get the companies usage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompanyUsage(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompanyUsage(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.getCompanyUsage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary List the knowledge base
         * @param {number} page Page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listKnowledge(page, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listKnowledge(page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.listKnowledge']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Patch the authenticated users company.
         * @param {PatchCompanyDetailsRequestBody} [patchCompanyDetailsRequestBody] Patch Company Details Request Body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchCompany(patchCompanyDetailsRequestBody, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchCompany(patchCompanyDetailsRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.patchCompany']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Create a knowledge base item
         * @param {number} id Knowledge ID
         * @param {PatchKnowledgePayload} patchKnowledgePayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchKnowledge(id, patchKnowledgePayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchKnowledge(id, patchKnowledgePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.patchKnowledge']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Search the knowledge base
         * @param {string} query Query term
         * @param {number} page Page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchKnowledge(query, page, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchKnowledge(query, page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.searchKnowledge']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Create a knowledge base item
         * @param {StoreKnowledgePayload} storeKnowledgePayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storeKnowledge(storeKnowledgePayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storeKnowledge(storeKnowledgePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.storeKnowledge']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * CompanyApi - factory interface
 * @export
 */
export const CompanyApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CompanyApiFp(configuration);
    return {
        /**
         *
         * @summary Delete a knowledge base item
         * @param {number} id Knowledge ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        destroyKnowledge(id, options) {
            return localVarFp.destroyKnowledge(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get the past invoice
         * @param {number} id Invoice ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadCompanyInvoice(id, options) {
            return localVarFp.downloadCompanyInvoice(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Show the authenticated users company.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompany(options) {
            return localVarFp.getCompany(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get the current companies branding
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyBranding(options) {
            return localVarFp.getCompanyBranding(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get the companies past invoices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyInvoices(options) {
            return localVarFp.getCompanyInvoices(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get the companies estimated next invoice estimate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyNextInvoiceEstimate(options) {
            return localVarFp.getCompanyNextInvoiceEstimate(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get the company\'s phone and email addresses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyPhoneAndEmailAddresses(options) {
            return localVarFp.getCompanyPhoneAndEmailAddresses(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get the companies usage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyUsage(options) {
            return localVarFp.getCompanyUsage(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List the knowledge base
         * @param {number} page Page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listKnowledge(page, options) {
            return localVarFp.listKnowledge(page, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch the authenticated users company.
         * @param {PatchCompanyDetailsRequestBody} [patchCompanyDetailsRequestBody] Patch Company Details Request Body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCompany(patchCompanyDetailsRequestBody, options) {
            return localVarFp.patchCompany(patchCompanyDetailsRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create a knowledge base item
         * @param {number} id Knowledge ID
         * @param {PatchKnowledgePayload} patchKnowledgePayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchKnowledge(id, patchKnowledgePayload, options) {
            return localVarFp.patchKnowledge(id, patchKnowledgePayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Search the knowledge base
         * @param {string} query Query term
         * @param {number} page Page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchKnowledge(query, page, options) {
            return localVarFp.searchKnowledge(query, page, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create a knowledge base item
         * @param {StoreKnowledgePayload} storeKnowledgePayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeKnowledge(storeKnowledgePayload, options) {
            return localVarFp.storeKnowledge(storeKnowledgePayload, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CompanyApi - object-oriented interface
 * @export
 * @class CompanyApi
 * @extends {BaseAPI}
 */
export class CompanyApi extends BaseAPI {
    /**
     *
     * @summary Delete a knowledge base item
     * @param {number} id Knowledge ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    destroyKnowledge(id, options) {
        return CompanyApiFp(this.configuration).destroyKnowledge(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get the past invoice
     * @param {number} id Invoice ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    downloadCompanyInvoice(id, options) {
        return CompanyApiFp(this.configuration).downloadCompanyInvoice(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Show the authenticated users company.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    getCompany(options) {
        return CompanyApiFp(this.configuration).getCompany(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get the current companies branding
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    getCompanyBranding(options) {
        return CompanyApiFp(this.configuration).getCompanyBranding(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get the companies past invoices
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    getCompanyInvoices(options) {
        return CompanyApiFp(this.configuration).getCompanyInvoices(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get the companies estimated next invoice estimate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    getCompanyNextInvoiceEstimate(options) {
        return CompanyApiFp(this.configuration).getCompanyNextInvoiceEstimate(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get the company\'s phone and email addresses
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    getCompanyPhoneAndEmailAddresses(options) {
        return CompanyApiFp(this.configuration).getCompanyPhoneAndEmailAddresses(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get the companies usage
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    getCompanyUsage(options) {
        return CompanyApiFp(this.configuration).getCompanyUsage(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List the knowledge base
     * @param {number} page Page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    listKnowledge(page, options) {
        return CompanyApiFp(this.configuration).listKnowledge(page, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch the authenticated users company.
     * @param {PatchCompanyDetailsRequestBody} [patchCompanyDetailsRequestBody] Patch Company Details Request Body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    patchCompany(patchCompanyDetailsRequestBody, options) {
        return CompanyApiFp(this.configuration).patchCompany(patchCompanyDetailsRequestBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create a knowledge base item
     * @param {number} id Knowledge ID
     * @param {PatchKnowledgePayload} patchKnowledgePayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    patchKnowledge(id, patchKnowledgePayload, options) {
        return CompanyApiFp(this.configuration).patchKnowledge(id, patchKnowledgePayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Search the knowledge base
     * @param {string} query Query term
     * @param {number} page Page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    searchKnowledge(query, page, options) {
        return CompanyApiFp(this.configuration).searchKnowledge(query, page, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create a knowledge base item
     * @param {StoreKnowledgePayload} storeKnowledgePayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    storeKnowledge(storeKnowledgePayload, options) {
        return CompanyApiFp(this.configuration).storeKnowledge(storeKnowledgePayload, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ContactsApi - axios parameter creator
 * @export
 */
export const ContactsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Create a contact.
         * @param {CreateContactRequestBody} [createContactRequestBody] Create Contact Request Body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createContact: async (createContactRequestBody, options = {}) => {
            const localVarPath = `/contacts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createContactRequestBody, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {CreateContactNoteRequestBody} [createContactNoteRequestBody] Create Contact Note Request Body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createContactNote: async (createContactNoteRequestBody, options = {}) => {
            const localVarPath = `/contact-notes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createContactNoteRequestBody, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a contact.
         * @param {number} id Contact ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContact: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getContact', 'id', id);
            const localVarPath = `/contacts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Validate a CSV file containing contact items.
         * @param {File} [data] CSV file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importContacts: async (data, options = {}) => {
            const localVarPath = `/contacts/import`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (data !== undefined) {
                localVarFormParams.append('data', data);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Validate a CSV file containing expense line items.
         * @param {File} [data] CSV file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateContactImport: async (data, options = {}) => {
            const localVarPath = `/contacts/validate-import`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (data !== undefined) {
                localVarFormParams.append('data', data);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ContactsApi - functional programming interface
 * @export
 */
export const ContactsApiFp = function (configuration) {
    const localVarAxiosParamCreator = ContactsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Create a contact.
         * @param {CreateContactRequestBody} [createContactRequestBody] Create Contact Request Body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createContact(createContactRequestBody, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createContact(createContactRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactsApi.createContact']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {CreateContactNoteRequestBody} [createContactNoteRequestBody] Create Contact Note Request Body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createContactNote(createContactNoteRequestBody, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createContactNote(createContactNoteRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactsApi.createContactNote']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get a contact.
         * @param {number} id Contact ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getContact(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getContact(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactsApi.getContact']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Validate a CSV file containing contact items.
         * @param {File} [data] CSV file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importContacts(data, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importContacts(data, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactsApi.importContacts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Validate a CSV file containing expense line items.
         * @param {File} [data] CSV file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateContactImport(data, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateContactImport(data, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactsApi.validateContactImport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * ContactsApi - factory interface
 * @export
 */
export const ContactsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ContactsApiFp(configuration);
    return {
        /**
         *
         * @summary Create a contact.
         * @param {CreateContactRequestBody} [createContactRequestBody] Create Contact Request Body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createContact(createContactRequestBody, options) {
            return localVarFp.createContact(createContactRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreateContactNoteRequestBody} [createContactNoteRequestBody] Create Contact Note Request Body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createContactNote(createContactNoteRequestBody, options) {
            return localVarFp.createContactNote(createContactNoteRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a contact.
         * @param {number} id Contact ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContact(id, options) {
            return localVarFp.getContact(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Validate a CSV file containing contact items.
         * @param {File} [data] CSV file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importContacts(data, options) {
            return localVarFp.importContacts(data, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Validate a CSV file containing expense line items.
         * @param {File} [data] CSV file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateContactImport(data, options) {
            return localVarFp.validateContactImport(data, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ContactsApi - object-oriented interface
 * @export
 * @class ContactsApi
 * @extends {BaseAPI}
 */
export class ContactsApi extends BaseAPI {
    /**
     *
     * @summary Create a contact.
     * @param {CreateContactRequestBody} [createContactRequestBody] Create Contact Request Body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApi
     */
    createContact(createContactRequestBody, options) {
        return ContactsApiFp(this.configuration).createContact(createContactRequestBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CreateContactNoteRequestBody} [createContactNoteRequestBody] Create Contact Note Request Body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApi
     */
    createContactNote(createContactNoteRequestBody, options) {
        return ContactsApiFp(this.configuration).createContactNote(createContactNoteRequestBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a contact.
     * @param {number} id Contact ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApi
     */
    getContact(id, options) {
        return ContactsApiFp(this.configuration).getContact(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Validate a CSV file containing contact items.
     * @param {File} [data] CSV file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApi
     */
    importContacts(data, options) {
        return ContactsApiFp(this.configuration).importContacts(data, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Validate a CSV file containing expense line items.
     * @param {File} [data] CSV file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApi
     */
    validateContactImport(data, options) {
        return ContactsApiFp(this.configuration).validateContactImport(data, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * DealsApi - axios parameter creator
 * @export
 */
export const DealsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Delete a sundry item
         * @param {string} sku SKU
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        destroySundryItem: async (sku, options = {}) => {
            // verify required parameter 'sku' is not null or undefined
            assertParamExists('destroySundryItem', 'sku', sku);
            const localVarPath = `/sundry-items/{sku}`
                .replace(`{${"sku"}}`, encodeURIComponent(String(sku)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a sundry item
         * @param {string} sku SKU
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSundryItem: async (sku, options = {}) => {
            // verify required parameter 'sku' is not null or undefined
            assertParamExists('getSundryItem', 'sku', sku);
            const localVarPath = `/sundry-items/{sku}`
                .replace(`{${"sku"}}`, encodeURIComponent(String(sku)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary List sundry items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSundryItems: async (options = {}) => {
            const localVarPath = `/sundry-items`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch a sundry item
         * @param {string} sku SKU
         * @param {PatchSundryItemPayload} patchSundryItemPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchSundryItem: async (sku, patchSundryItemPayload, options = {}) => {
            // verify required parameter 'sku' is not null or undefined
            assertParamExists('patchSundryItem', 'sku', sku);
            // verify required parameter 'patchSundryItemPayload' is not null or undefined
            assertParamExists('patchSundryItem', 'patchSundryItemPayload', patchSundryItemPayload);
            const localVarPath = `/sundry-items/{sku}`
                .replace(`{${"sku"}}`, encodeURIComponent(String(sku)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(patchSundryItemPayload, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Show the available products.
         * @param {number} id ID of the deal to requote
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requoteProducts: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('requoteProducts', 'id', id);
            const localVarPath = `/deals/{id}/requote-products`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create a sundry item
         * @param {StoreSundryItemPayload} storeSundryItemPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeSundryItem: async (storeSundryItemPayload, options = {}) => {
            // verify required parameter 'storeSundryItemPayload' is not null or undefined
            assertParamExists('storeSundryItem', 'storeSundryItemPayload', storeSundryItemPayload);
            const localVarPath = `/sundry-items`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(storeSundryItemPayload, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * DealsApi - functional programming interface
 * @export
 */
export const DealsApiFp = function (configuration) {
    const localVarAxiosParamCreator = DealsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Delete a sundry item
         * @param {string} sku SKU
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async destroySundryItem(sku, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.destroySundryItem(sku, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DealsApi.destroySundryItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get a sundry item
         * @param {string} sku SKU
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSundryItem(sku, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSundryItem(sku, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DealsApi.getSundryItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary List sundry items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSundryItems(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSundryItems(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DealsApi.getSundryItems']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Patch a sundry item
         * @param {string} sku SKU
         * @param {PatchSundryItemPayload} patchSundryItemPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchSundryItem(sku, patchSundryItemPayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchSundryItem(sku, patchSundryItemPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DealsApi.patchSundryItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Show the available products.
         * @param {number} id ID of the deal to requote
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requoteProducts(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requoteProducts(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DealsApi.requoteProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Create a sundry item
         * @param {StoreSundryItemPayload} storeSundryItemPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storeSundryItem(storeSundryItemPayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storeSundryItem(storeSundryItemPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DealsApi.storeSundryItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * DealsApi - factory interface
 * @export
 */
export const DealsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = DealsApiFp(configuration);
    return {
        /**
         *
         * @summary Delete a sundry item
         * @param {string} sku SKU
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        destroySundryItem(sku, options) {
            return localVarFp.destroySundryItem(sku, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a sundry item
         * @param {string} sku SKU
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSundryItem(sku, options) {
            return localVarFp.getSundryItem(sku, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List sundry items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSundryItems(options) {
            return localVarFp.getSundryItems(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch a sundry item
         * @param {string} sku SKU
         * @param {PatchSundryItemPayload} patchSundryItemPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchSundryItem(sku, patchSundryItemPayload, options) {
            return localVarFp.patchSundryItem(sku, patchSundryItemPayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Show the available products.
         * @param {number} id ID of the deal to requote
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requoteProducts(id, options) {
            return localVarFp.requoteProducts(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create a sundry item
         * @param {StoreSundryItemPayload} storeSundryItemPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeSundryItem(storeSundryItemPayload, options) {
            return localVarFp.storeSundryItem(storeSundryItemPayload, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * DealsApi - object-oriented interface
 * @export
 * @class DealsApi
 * @extends {BaseAPI}
 */
export class DealsApi extends BaseAPI {
    /**
     *
     * @summary Delete a sundry item
     * @param {string} sku SKU
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApi
     */
    destroySundryItem(sku, options) {
        return DealsApiFp(this.configuration).destroySundryItem(sku, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a sundry item
     * @param {string} sku SKU
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApi
     */
    getSundryItem(sku, options) {
        return DealsApiFp(this.configuration).getSundryItem(sku, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List sundry items
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApi
     */
    getSundryItems(options) {
        return DealsApiFp(this.configuration).getSundryItems(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch a sundry item
     * @param {string} sku SKU
     * @param {PatchSundryItemPayload} patchSundryItemPayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApi
     */
    patchSundryItem(sku, patchSundryItemPayload, options) {
        return DealsApiFp(this.configuration).patchSundryItem(sku, patchSundryItemPayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Show the available products.
     * @param {number} id ID of the deal to requote
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApi
     */
    requoteProducts(id, options) {
        return DealsApiFp(this.configuration).requoteProducts(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create a sundry item
     * @param {StoreSundryItemPayload} storeSundryItemPayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApi
     */
    storeSundryItem(storeSundryItemPayload, options) {
        return DealsApiFp(this.configuration).storeSundryItem(storeSundryItemPayload, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * DocumentsApi - axios parameter creator
 * @export
 */
export const DocumentsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Associate documents with another object.
         * @param {DocumentAssociationPayload} documentAssociationPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        associateDocuments: async (documentAssociationPayload, options = {}) => {
            // verify required parameter 'documentAssociationPayload' is not null or undefined
            assertParamExists('associateDocuments', 'documentAssociationPayload', documentAssociationPayload);
            const localVarPath = `/documents/associate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(documentAssociationPayload, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Destroy many documents.
         * @param {DocumentDestructionPayload} documentDestructionPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        destroyDocuments: async (documentDestructionPayload, options = {}) => {
            // verify required parameter 'documentDestructionPayload' is not null or undefined
            assertParamExists('destroyDocuments', 'documentDestructionPayload', documentDestructionPayload);
            const localVarPath = `/documents/destroy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(documentDestructionPayload, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Associate documents with another object.
         * @param {DocumentBackgroundRemovalPayload} documentBackgroundRemovalPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeDocumentBackground: async (documentBackgroundRemovalPayload, options = {}) => {
            // verify required parameter 'documentBackgroundRemovalPayload' is not null or undefined
            assertParamExists('removeDocumentBackground', 'documentBackgroundRemovalPayload', documentBackgroundRemovalPayload);
            const localVarPath = `/documents/remove-background`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(documentBackgroundRemovalPayload, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * DocumentsApi - functional programming interface
 * @export
 */
export const DocumentsApiFp = function (configuration) {
    const localVarAxiosParamCreator = DocumentsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Associate documents with another object.
         * @param {DocumentAssociationPayload} documentAssociationPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async associateDocuments(documentAssociationPayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.associateDocuments(documentAssociationPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.associateDocuments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Destroy many documents.
         * @param {DocumentDestructionPayload} documentDestructionPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async destroyDocuments(documentDestructionPayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.destroyDocuments(documentDestructionPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.destroyDocuments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Associate documents with another object.
         * @param {DocumentBackgroundRemovalPayload} documentBackgroundRemovalPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeDocumentBackground(documentBackgroundRemovalPayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeDocumentBackground(documentBackgroundRemovalPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentsApi.removeDocumentBackground']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * DocumentsApi - factory interface
 * @export
 */
export const DocumentsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = DocumentsApiFp(configuration);
    return {
        /**
         *
         * @summary Associate documents with another object.
         * @param {DocumentAssociationPayload} documentAssociationPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        associateDocuments(documentAssociationPayload, options) {
            return localVarFp.associateDocuments(documentAssociationPayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Destroy many documents.
         * @param {DocumentDestructionPayload} documentDestructionPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        destroyDocuments(documentDestructionPayload, options) {
            return localVarFp.destroyDocuments(documentDestructionPayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Associate documents with another object.
         * @param {DocumentBackgroundRemovalPayload} documentBackgroundRemovalPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeDocumentBackground(documentBackgroundRemovalPayload, options) {
            return localVarFp.removeDocumentBackground(documentBackgroundRemovalPayload, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * DocumentsApi - object-oriented interface
 * @export
 * @class DocumentsApi
 * @extends {BaseAPI}
 */
export class DocumentsApi extends BaseAPI {
    /**
     *
     * @summary Associate documents with another object.
     * @param {DocumentAssociationPayload} documentAssociationPayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    associateDocuments(documentAssociationPayload, options) {
        return DocumentsApiFp(this.configuration).associateDocuments(documentAssociationPayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Destroy many documents.
     * @param {DocumentDestructionPayload} documentDestructionPayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    destroyDocuments(documentDestructionPayload, options) {
        return DocumentsApiFp(this.configuration).destroyDocuments(documentDestructionPayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Associate documents with another object.
     * @param {DocumentBackgroundRemovalPayload} documentBackgroundRemovalPayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    removeDocumentBackground(documentBackgroundRemovalPayload, options) {
        return DocumentsApiFp(this.configuration).removeDocumentBackground(documentBackgroundRemovalPayload, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ExpensesApi - axios parameter creator
 * @export
 */
export const ExpensesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Validate a CSV file containing expense line items.
         * @param {File} [data] CSV file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importExpenses: async (data, options = {}) => {
            const localVarPath = `/expenses/import`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (data !== undefined) {
                localVarFormParams.append('data', data);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Validate a CSV file containing expense line items.
         * @param {File} [data] CSV file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateExpenseImport: async (data, options = {}) => {
            const localVarPath = `/expenses/validate-import`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (data !== undefined) {
                localVarFormParams.append('data', data);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ExpensesApi - functional programming interface
 * @export
 */
export const ExpensesApiFp = function (configuration) {
    const localVarAxiosParamCreator = ExpensesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Validate a CSV file containing expense line items.
         * @param {File} [data] CSV file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importExpenses(data, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importExpenses(data, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExpensesApi.importExpenses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Validate a CSV file containing expense line items.
         * @param {File} [data] CSV file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateExpenseImport(data, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateExpenseImport(data, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExpensesApi.validateExpenseImport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * ExpensesApi - factory interface
 * @export
 */
export const ExpensesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ExpensesApiFp(configuration);
    return {
        /**
         *
         * @summary Validate a CSV file containing expense line items.
         * @param {File} [data] CSV file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importExpenses(data, options) {
            return localVarFp.importExpenses(data, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Validate a CSV file containing expense line items.
         * @param {File} [data] CSV file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateExpenseImport(data, options) {
            return localVarFp.validateExpenseImport(data, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ExpensesApi - object-oriented interface
 * @export
 * @class ExpensesApi
 * @extends {BaseAPI}
 */
export class ExpensesApi extends BaseAPI {
    /**
     *
     * @summary Validate a CSV file containing expense line items.
     * @param {File} [data] CSV file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExpensesApi
     */
    importExpenses(data, options) {
        return ExpensesApiFp(this.configuration).importExpenses(data, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Validate a CSV file containing expense line items.
     * @param {File} [data] CSV file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExpensesApi
     */
    validateExpenseImport(data, options) {
        return ExpensesApiFp(this.configuration).validateExpenseImport(data, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * FinanceCommissionApi - axios parameter creator
 * @export
 */
export const FinanceCommissionApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Update an agreements commission detail.
         * @param {number} id Finance Agreement ID
         * @param {FinanceCommissionPayload} financeCommissionPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putFinanceCommission: async (id, financeCommissionPayload, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('putFinanceCommission', 'id', id);
            // verify required parameter 'financeCommissionPayload' is not null or undefined
            assertParamExists('putFinanceCommission', 'financeCommissionPayload', financeCommissionPayload);
            const localVarPath = `/finance-commission/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(financeCommissionPayload, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * FinanceCommissionApi - functional programming interface
 * @export
 */
export const FinanceCommissionApiFp = function (configuration) {
    const localVarAxiosParamCreator = FinanceCommissionApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Update an agreements commission detail.
         * @param {number} id Finance Agreement ID
         * @param {FinanceCommissionPayload} financeCommissionPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putFinanceCommission(id, financeCommissionPayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putFinanceCommission(id, financeCommissionPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FinanceCommissionApi.putFinanceCommission']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * FinanceCommissionApi - factory interface
 * @export
 */
export const FinanceCommissionApiFactory = function (configuration, basePath, axios) {
    const localVarFp = FinanceCommissionApiFp(configuration);
    return {
        /**
         *
         * @summary Update an agreements commission detail.
         * @param {number} id Finance Agreement ID
         * @param {FinanceCommissionPayload} financeCommissionPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putFinanceCommission(id, financeCommissionPayload, options) {
            return localVarFp.putFinanceCommission(id, financeCommissionPayload, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * FinanceCommissionApi - object-oriented interface
 * @export
 * @class FinanceCommissionApi
 * @extends {BaseAPI}
 */
export class FinanceCommissionApi extends BaseAPI {
    /**
     *
     * @summary Update an agreements commission detail.
     * @param {number} id Finance Agreement ID
     * @param {FinanceCommissionPayload} financeCommissionPayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FinanceCommissionApi
     */
    putFinanceCommission(id, financeCommissionPayload, options) {
        return FinanceCommissionApiFp(this.configuration).putFinanceCommission(id, financeCommissionPayload, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * FinanceContrasApi - axios parameter creator
 * @export
 */
export const FinanceContrasApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Contra a finance agreement with a settlement.
         * @param {number} id Agreement ID
         * @param {ContraFinanceAgreementPayload} contraFinanceAgreementPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contraFinanceAgreement: async (id, contraFinanceAgreementPayload, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('contraFinanceAgreement', 'id', id);
            // verify required parameter 'contraFinanceAgreementPayload' is not null or undefined
            assertParamExists('contraFinanceAgreement', 'contraFinanceAgreementPayload', contraFinanceAgreementPayload);
            const localVarPath = `/finance-contras/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(contraFinanceAgreementPayload, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a list of settlements that can be contra entered against a finance settlement.
         * @param {number} id Agreement ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableSettlements: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAvailableSettlements', 'id', id);
            const localVarPath = `/finance-contras/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Remove a finance agreements contra settlement.
         * @param {number} agreementId Agreement ID
         * @param {number} settlementId Settlement ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeFinanceAgreementContra: async (agreementId, settlementId, options = {}) => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('removeFinanceAgreementContra', 'agreementId', agreementId);
            // verify required parameter 'settlementId' is not null or undefined
            assertParamExists('removeFinanceAgreementContra', 'settlementId', settlementId);
            const localVarPath = `/finance-contras/{agreement_id}/{settlement_id}`
                .replace(`{${"agreement_id"}}`, encodeURIComponent(String(agreementId)))
                .replace(`{${"settlement_id"}}`, encodeURIComponent(String(settlementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * FinanceContrasApi - functional programming interface
 * @export
 */
export const FinanceContrasApiFp = function (configuration) {
    const localVarAxiosParamCreator = FinanceContrasApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Contra a finance agreement with a settlement.
         * @param {number} id Agreement ID
         * @param {ContraFinanceAgreementPayload} contraFinanceAgreementPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async contraFinanceAgreement(id, contraFinanceAgreementPayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.contraFinanceAgreement(id, contraFinanceAgreementPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FinanceContrasApi.contraFinanceAgreement']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get a list of settlements that can be contra entered against a finance settlement.
         * @param {number} id Agreement ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvailableSettlements(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAvailableSettlements(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FinanceContrasApi.getAvailableSettlements']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Remove a finance agreements contra settlement.
         * @param {number} agreementId Agreement ID
         * @param {number} settlementId Settlement ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeFinanceAgreementContra(agreementId, settlementId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeFinanceAgreementContra(agreementId, settlementId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FinanceContrasApi.removeFinanceAgreementContra']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * FinanceContrasApi - factory interface
 * @export
 */
export const FinanceContrasApiFactory = function (configuration, basePath, axios) {
    const localVarFp = FinanceContrasApiFp(configuration);
    return {
        /**
         *
         * @summary Contra a finance agreement with a settlement.
         * @param {number} id Agreement ID
         * @param {ContraFinanceAgreementPayload} contraFinanceAgreementPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contraFinanceAgreement(id, contraFinanceAgreementPayload, options) {
            return localVarFp.contraFinanceAgreement(id, contraFinanceAgreementPayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a list of settlements that can be contra entered against a finance settlement.
         * @param {number} id Agreement ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableSettlements(id, options) {
            return localVarFp.getAvailableSettlements(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Remove a finance agreements contra settlement.
         * @param {number} agreementId Agreement ID
         * @param {number} settlementId Settlement ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeFinanceAgreementContra(agreementId, settlementId, options) {
            return localVarFp.removeFinanceAgreementContra(agreementId, settlementId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * FinanceContrasApi - object-oriented interface
 * @export
 * @class FinanceContrasApi
 * @extends {BaseAPI}
 */
export class FinanceContrasApi extends BaseAPI {
    /**
     *
     * @summary Contra a finance agreement with a settlement.
     * @param {number} id Agreement ID
     * @param {ContraFinanceAgreementPayload} contraFinanceAgreementPayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FinanceContrasApi
     */
    contraFinanceAgreement(id, contraFinanceAgreementPayload, options) {
        return FinanceContrasApiFp(this.configuration).contraFinanceAgreement(id, contraFinanceAgreementPayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a list of settlements that can be contra entered against a finance settlement.
     * @param {number} id Agreement ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FinanceContrasApi
     */
    getAvailableSettlements(id, options) {
        return FinanceContrasApiFp(this.configuration).getAvailableSettlements(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Remove a finance agreements contra settlement.
     * @param {number} agreementId Agreement ID
     * @param {number} settlementId Settlement ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FinanceContrasApi
     */
    removeFinanceAgreementContra(agreementId, settlementId, options) {
        return FinanceContrasApiFp(this.configuration).removeFinanceAgreementContra(agreementId, settlementId, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * FinanceSettlementsApi - axios parameter creator
 * @export
 */
export const FinanceSettlementsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Delete a finance settlement.
         * @param {number} id Settlement ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        destroyFinanceSettlement: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('destroyFinanceSettlement', 'id', id);
            const localVarPath = `/finance-settlements/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary List finance settlements.
         * @param {number} [page] Page
         * @param {string} [filters] Filters
         * @param {ListFinanceSettlementsSortOrderEnum} [sortOrder] Sort Order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFinanceSettlements: async (page, filters, sortOrder, options = {}) => {
            const localVarPath = `/finance-settlements`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (filters !== undefined) {
                localVarQueryParameter['filters'] = filters;
            }
            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Show finance settlement.
         * @param {number} id Settlement ID
         * @param {Array<ShowFinanceSettlementExpandEnum>} [expand] Relations to expand
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        showFinanceSettlement: async (id, expand, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('showFinanceSettlement', 'id', id);
            const localVarPath = `/finance-settlements/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (expand) {
                localVarQueryParameter['expand[]'] = expand;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Store finance settlement.
         * @param {StoreSettlementPayload} storeSettlementPayload
         * @param {Array<StoreFinanceSettlementExpandEnum>} [expand] Relations to expand
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeFinanceSettlement: async (storeSettlementPayload, expand, options = {}) => {
            // verify required parameter 'storeSettlementPayload' is not null or undefined
            assertParamExists('storeFinanceSettlement', 'storeSettlementPayload', storeSettlementPayload);
            const localVarPath = `/finance-settlements`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (expand) {
                localVarQueryParameter['expand[]'] = expand;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(storeSettlementPayload, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update finance settlement.
         * @param {number} id Settlement ID
         * @param {UpdateSettlementPayload} updateSettlementPayload
         * @param {Array<UpdateFinanceSettlementExpandEnum>} [expand] Relations to expand
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFinanceSettlement: async (id, updateSettlementPayload, expand, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateFinanceSettlement', 'id', id);
            // verify required parameter 'updateSettlementPayload' is not null or undefined
            assertParamExists('updateFinanceSettlement', 'updateSettlementPayload', updateSettlementPayload);
            const localVarPath = `/finance-settlements/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (expand) {
                localVarQueryParameter['expand[]'] = expand;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(updateSettlementPayload, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * FinanceSettlementsApi - functional programming interface
 * @export
 */
export const FinanceSettlementsApiFp = function (configuration) {
    const localVarAxiosParamCreator = FinanceSettlementsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Delete a finance settlement.
         * @param {number} id Settlement ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async destroyFinanceSettlement(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.destroyFinanceSettlement(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FinanceSettlementsApi.destroyFinanceSettlement']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary List finance settlements.
         * @param {number} [page] Page
         * @param {string} [filters] Filters
         * @param {ListFinanceSettlementsSortOrderEnum} [sortOrder] Sort Order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listFinanceSettlements(page, filters, sortOrder, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listFinanceSettlements(page, filters, sortOrder, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FinanceSettlementsApi.listFinanceSettlements']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Show finance settlement.
         * @param {number} id Settlement ID
         * @param {Array<ShowFinanceSettlementExpandEnum>} [expand] Relations to expand
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async showFinanceSettlement(id, expand, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.showFinanceSettlement(id, expand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FinanceSettlementsApi.showFinanceSettlement']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Store finance settlement.
         * @param {StoreSettlementPayload} storeSettlementPayload
         * @param {Array<StoreFinanceSettlementExpandEnum>} [expand] Relations to expand
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storeFinanceSettlement(storeSettlementPayload, expand, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storeFinanceSettlement(storeSettlementPayload, expand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FinanceSettlementsApi.storeFinanceSettlement']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Update finance settlement.
         * @param {number} id Settlement ID
         * @param {UpdateSettlementPayload} updateSettlementPayload
         * @param {Array<UpdateFinanceSettlementExpandEnum>} [expand] Relations to expand
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFinanceSettlement(id, updateSettlementPayload, expand, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFinanceSettlement(id, updateSettlementPayload, expand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FinanceSettlementsApi.updateFinanceSettlement']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * FinanceSettlementsApi - factory interface
 * @export
 */
export const FinanceSettlementsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = FinanceSettlementsApiFp(configuration);
    return {
        /**
         *
         * @summary Delete a finance settlement.
         * @param {number} id Settlement ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        destroyFinanceSettlement(id, options) {
            return localVarFp.destroyFinanceSettlement(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List finance settlements.
         * @param {number} [page] Page
         * @param {string} [filters] Filters
         * @param {ListFinanceSettlementsSortOrderEnum} [sortOrder] Sort Order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFinanceSettlements(page, filters, sortOrder, options) {
            return localVarFp.listFinanceSettlements(page, filters, sortOrder, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Show finance settlement.
         * @param {number} id Settlement ID
         * @param {Array<ShowFinanceSettlementExpandEnum>} [expand] Relations to expand
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        showFinanceSettlement(id, expand, options) {
            return localVarFp.showFinanceSettlement(id, expand, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Store finance settlement.
         * @param {StoreSettlementPayload} storeSettlementPayload
         * @param {Array<StoreFinanceSettlementExpandEnum>} [expand] Relations to expand
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeFinanceSettlement(storeSettlementPayload, expand, options) {
            return localVarFp.storeFinanceSettlement(storeSettlementPayload, expand, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update finance settlement.
         * @param {number} id Settlement ID
         * @param {UpdateSettlementPayload} updateSettlementPayload
         * @param {Array<UpdateFinanceSettlementExpandEnum>} [expand] Relations to expand
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFinanceSettlement(id, updateSettlementPayload, expand, options) {
            return localVarFp.updateFinanceSettlement(id, updateSettlementPayload, expand, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * FinanceSettlementsApi - object-oriented interface
 * @export
 * @class FinanceSettlementsApi
 * @extends {BaseAPI}
 */
export class FinanceSettlementsApi extends BaseAPI {
    /**
     *
     * @summary Delete a finance settlement.
     * @param {number} id Settlement ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FinanceSettlementsApi
     */
    destroyFinanceSettlement(id, options) {
        return FinanceSettlementsApiFp(this.configuration).destroyFinanceSettlement(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List finance settlements.
     * @param {number} [page] Page
     * @param {string} [filters] Filters
     * @param {ListFinanceSettlementsSortOrderEnum} [sortOrder] Sort Order
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FinanceSettlementsApi
     */
    listFinanceSettlements(page, filters, sortOrder, options) {
        return FinanceSettlementsApiFp(this.configuration).listFinanceSettlements(page, filters, sortOrder, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Show finance settlement.
     * @param {number} id Settlement ID
     * @param {Array<ShowFinanceSettlementExpandEnum>} [expand] Relations to expand
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FinanceSettlementsApi
     */
    showFinanceSettlement(id, expand, options) {
        return FinanceSettlementsApiFp(this.configuration).showFinanceSettlement(id, expand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Store finance settlement.
     * @param {StoreSettlementPayload} storeSettlementPayload
     * @param {Array<StoreFinanceSettlementExpandEnum>} [expand] Relations to expand
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FinanceSettlementsApi
     */
    storeFinanceSettlement(storeSettlementPayload, expand, options) {
        return FinanceSettlementsApiFp(this.configuration).storeFinanceSettlement(storeSettlementPayload, expand, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update finance settlement.
     * @param {number} id Settlement ID
     * @param {UpdateSettlementPayload} updateSettlementPayload
     * @param {Array<UpdateFinanceSettlementExpandEnum>} [expand] Relations to expand
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FinanceSettlementsApi
     */
    updateFinanceSettlement(id, updateSettlementPayload, expand, options) {
        return FinanceSettlementsApiFp(this.configuration).updateFinanceSettlement(id, updateSettlementPayload, expand, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * @export
 */
export const ListFinanceSettlementsSortOrderEnum = {
    Newest: 'newest',
    Oldest: 'oldest'
};
/**
 * @export
 */
export const ShowFinanceSettlementExpandEnum = {
    StockListing: 'stock_listing'
};
/**
 * @export
 */
export const StoreFinanceSettlementExpandEnum = {
    StockListing: 'stock_listing'
};
/**
 * @export
 */
export const UpdateFinanceSettlementExpandEnum = {
    StockListing: 'stock_listing'
};
/**
 * InboxApi - axios parameter creator
 * @export
 */
export const InboxApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Stop a given AI response from being sent automatically.
         * @param {number} id ID of the AI response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelAiAutoResponse: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cancelAiAutoResponse', 'id', id);
            const localVarPath = `/inbox/ai-responses/{id}/cancel`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Stop a given AI response from being sent automatically.
         * @param {number} id ID of the AI agent action
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeAiAgentAction: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('completeAiAgentAction', 'id', id);
            const localVarPath = `/inbox/ai-agent-actions/{id}/complete`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Send a given AI response to the contact
         * @param {number} id ID of the AI response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendAiResponse: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('sendAiResponse', 'id', id);
            const localVarPath = `/inbox/ai-responses/{id}/send`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * InboxApi - functional programming interface
 * @export
 */
export const InboxApiFp = function (configuration) {
    const localVarAxiosParamCreator = InboxApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Stop a given AI response from being sent automatically.
         * @param {number} id ID of the AI response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelAiAutoResponse(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelAiAutoResponse(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InboxApi.cancelAiAutoResponse']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Stop a given AI response from being sent automatically.
         * @param {number} id ID of the AI agent action
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async completeAiAgentAction(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.completeAiAgentAction(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InboxApi.completeAiAgentAction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Send a given AI response to the contact
         * @param {number} id ID of the AI response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendAiResponse(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendAiResponse(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InboxApi.sendAiResponse']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * InboxApi - factory interface
 * @export
 */
export const InboxApiFactory = function (configuration, basePath, axios) {
    const localVarFp = InboxApiFp(configuration);
    return {
        /**
         *
         * @summary Stop a given AI response from being sent automatically.
         * @param {number} id ID of the AI response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelAiAutoResponse(id, options) {
            return localVarFp.cancelAiAutoResponse(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Stop a given AI response from being sent automatically.
         * @param {number} id ID of the AI agent action
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeAiAgentAction(id, options) {
            return localVarFp.completeAiAgentAction(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Send a given AI response to the contact
         * @param {number} id ID of the AI response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendAiResponse(id, options) {
            return localVarFp.sendAiResponse(id, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * InboxApi - object-oriented interface
 * @export
 * @class InboxApi
 * @extends {BaseAPI}
 */
export class InboxApi extends BaseAPI {
    /**
     *
     * @summary Stop a given AI response from being sent automatically.
     * @param {number} id ID of the AI response
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InboxApi
     */
    cancelAiAutoResponse(id, options) {
        return InboxApiFp(this.configuration).cancelAiAutoResponse(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Stop a given AI response from being sent automatically.
     * @param {number} id ID of the AI agent action
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InboxApi
     */
    completeAiAgentAction(id, options) {
        return InboxApiFp(this.configuration).completeAiAgentAction(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Send a given AI response to the contact
     * @param {number} id ID of the AI response
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InboxApi
     */
    sendAiResponse(id, options) {
        return InboxApiFp(this.configuration).sendAiResponse(id, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * InspectionsApi - axios parameter creator
 * @export
 */
export const InspectionsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Complete inspection.
         * @param {number} inspectionId ID of the inspection to be completed
         * @param {CompleteInspection} completeInspection Inspection completion request body.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeInspection: async (inspectionId, completeInspection, options = {}) => {
            // verify required parameter 'inspectionId' is not null or undefined
            assertParamExists('completeInspection', 'inspectionId', inspectionId);
            // verify required parameter 'completeInspection' is not null or undefined
            assertParamExists('completeInspection', 'completeInspection', completeInspection);
            const localVarPath = `/inspections/{inspection_id}/complete`
                .replace(`{${"inspection_id"}}`, encodeURIComponent(String(inspectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(completeInspection, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create an inspection type
         * @param {InspectionType} [inspectionType] Create Inspection Type Request Body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInspectionType: async (inspectionType, options = {}) => {
            const localVarPath = `/inspection-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(inspectionType, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete inspection.
         * @param {number} inspectionId ID of the inspection to be deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteInspection: async (inspectionId, options = {}) => {
            // verify required parameter 'inspectionId' is not null or undefined
            assertParamExists('deleteInspection', 'inspectionId', inspectionId);
            const localVarPath = `/inspections/{inspection_id}`
                .replace(`{${"inspection_id"}}`, encodeURIComponent(String(inspectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch an inspection type
         * @param {number} id ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteInspectionType: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteInspectionType', 'id', id);
            const localVarPath = `/inspection-types/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Show inspection.
         * @param {number} inspectionId ID of the inspection to be shown
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findInspection: async (inspectionId, options = {}) => {
            // verify required parameter 'inspectionId' is not null or undefined
            assertParamExists('findInspection', 'inspectionId', inspectionId);
            const localVarPath = `/inspections/{inspection_id}`
                .replace(`{${"inspection_id"}}`, encodeURIComponent(String(inspectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get an inspection type
         * @param {number} id ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInspectionType: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getInspectionType', 'id', id);
            const localVarPath = `/inspection-types/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Gets a list of inspection types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInspectionTypes: async (options = {}) => {
            const localVarPath = `/inspection-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary List inspections.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInspections: async (options = {}) => {
            const localVarPath = `/inspections`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch an inspection type
         * @param {number} id ID
         * @param {PatchInspectionTypeRequestBody} [patchInspectionTypeRequestBody] Patch Inspection Type Request Body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchInspectionType: async (id, patchInspectionTypeRequestBody, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patchInspectionType', 'id', id);
            const localVarPath = `/inspection-types/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(patchInspectionTypeRequestBody, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Reset inspection.
         * @param {number} inspectionId ID of the inspection to be reset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetInspection: async (inspectionId, options = {}) => {
            // verify required parameter 'inspectionId' is not null or undefined
            assertParamExists('resetInspection', 'inspectionId', inspectionId);
            const localVarPath = `/inspections/{inspection_id}/reset`
                .replace(`{${"inspection_id"}}`, encodeURIComponent(String(inspectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * InspectionsApi - functional programming interface
 * @export
 */
export const InspectionsApiFp = function (configuration) {
    const localVarAxiosParamCreator = InspectionsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Complete inspection.
         * @param {number} inspectionId ID of the inspection to be completed
         * @param {CompleteInspection} completeInspection Inspection completion request body.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async completeInspection(inspectionId, completeInspection, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.completeInspection(inspectionId, completeInspection, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InspectionsApi.completeInspection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Create an inspection type
         * @param {InspectionType} [inspectionType] Create Inspection Type Request Body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createInspectionType(inspectionType, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createInspectionType(inspectionType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InspectionsApi.createInspectionType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Delete inspection.
         * @param {number} inspectionId ID of the inspection to be deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteInspection(inspectionId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteInspection(inspectionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InspectionsApi.deleteInspection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Patch an inspection type
         * @param {number} id ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteInspectionType(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteInspectionType(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InspectionsApi.deleteInspectionType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Show inspection.
         * @param {number} inspectionId ID of the inspection to be shown
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findInspection(inspectionId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findInspection(inspectionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InspectionsApi.findInspection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get an inspection type
         * @param {number} id ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInspectionType(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInspectionType(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InspectionsApi.getInspectionType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Gets a list of inspection types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInspectionTypes(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInspectionTypes(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InspectionsApi.getInspectionTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary List inspections.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listInspections(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listInspections(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InspectionsApi.listInspections']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Patch an inspection type
         * @param {number} id ID
         * @param {PatchInspectionTypeRequestBody} [patchInspectionTypeRequestBody] Patch Inspection Type Request Body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchInspectionType(id, patchInspectionTypeRequestBody, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchInspectionType(id, patchInspectionTypeRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InspectionsApi.patchInspectionType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Reset inspection.
         * @param {number} inspectionId ID of the inspection to be reset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetInspection(inspectionId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetInspection(inspectionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InspectionsApi.resetInspection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * InspectionsApi - factory interface
 * @export
 */
export const InspectionsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = InspectionsApiFp(configuration);
    return {
        /**
         *
         * @summary Complete inspection.
         * @param {number} inspectionId ID of the inspection to be completed
         * @param {CompleteInspection} completeInspection Inspection completion request body.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeInspection(inspectionId, completeInspection, options) {
            return localVarFp.completeInspection(inspectionId, completeInspection, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create an inspection type
         * @param {InspectionType} [inspectionType] Create Inspection Type Request Body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInspectionType(inspectionType, options) {
            return localVarFp.createInspectionType(inspectionType, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete inspection.
         * @param {number} inspectionId ID of the inspection to be deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteInspection(inspectionId, options) {
            return localVarFp.deleteInspection(inspectionId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch an inspection type
         * @param {number} id ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteInspectionType(id, options) {
            return localVarFp.deleteInspectionType(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Show inspection.
         * @param {number} inspectionId ID of the inspection to be shown
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findInspection(inspectionId, options) {
            return localVarFp.findInspection(inspectionId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get an inspection type
         * @param {number} id ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInspectionType(id, options) {
            return localVarFp.getInspectionType(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets a list of inspection types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInspectionTypes(options) {
            return localVarFp.getInspectionTypes(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List inspections.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInspections(options) {
            return localVarFp.listInspections(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch an inspection type
         * @param {number} id ID
         * @param {PatchInspectionTypeRequestBody} [patchInspectionTypeRequestBody] Patch Inspection Type Request Body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchInspectionType(id, patchInspectionTypeRequestBody, options) {
            return localVarFp.patchInspectionType(id, patchInspectionTypeRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Reset inspection.
         * @param {number} inspectionId ID of the inspection to be reset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetInspection(inspectionId, options) {
            return localVarFp.resetInspection(inspectionId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * InspectionsApi - object-oriented interface
 * @export
 * @class InspectionsApi
 * @extends {BaseAPI}
 */
export class InspectionsApi extends BaseAPI {
    /**
     *
     * @summary Complete inspection.
     * @param {number} inspectionId ID of the inspection to be completed
     * @param {CompleteInspection} completeInspection Inspection completion request body.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InspectionsApi
     */
    completeInspection(inspectionId, completeInspection, options) {
        return InspectionsApiFp(this.configuration).completeInspection(inspectionId, completeInspection, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create an inspection type
     * @param {InspectionType} [inspectionType] Create Inspection Type Request Body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InspectionsApi
     */
    createInspectionType(inspectionType, options) {
        return InspectionsApiFp(this.configuration).createInspectionType(inspectionType, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete inspection.
     * @param {number} inspectionId ID of the inspection to be deleted
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InspectionsApi
     */
    deleteInspection(inspectionId, options) {
        return InspectionsApiFp(this.configuration).deleteInspection(inspectionId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch an inspection type
     * @param {number} id ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InspectionsApi
     */
    deleteInspectionType(id, options) {
        return InspectionsApiFp(this.configuration).deleteInspectionType(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Show inspection.
     * @param {number} inspectionId ID of the inspection to be shown
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InspectionsApi
     */
    findInspection(inspectionId, options) {
        return InspectionsApiFp(this.configuration).findInspection(inspectionId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get an inspection type
     * @param {number} id ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InspectionsApi
     */
    getInspectionType(id, options) {
        return InspectionsApiFp(this.configuration).getInspectionType(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets a list of inspection types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InspectionsApi
     */
    getInspectionTypes(options) {
        return InspectionsApiFp(this.configuration).getInspectionTypes(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List inspections.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InspectionsApi
     */
    listInspections(options) {
        return InspectionsApiFp(this.configuration).listInspections(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch an inspection type
     * @param {number} id ID
     * @param {PatchInspectionTypeRequestBody} [patchInspectionTypeRequestBody] Patch Inspection Type Request Body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InspectionsApi
     */
    patchInspectionType(id, patchInspectionTypeRequestBody, options) {
        return InspectionsApiFp(this.configuration).patchInspectionType(id, patchInspectionTypeRequestBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Reset inspection.
     * @param {number} inspectionId ID of the inspection to be reset
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InspectionsApi
     */
    resetInspection(inspectionId, options) {
        return InspectionsApiFp(this.configuration).resetInspection(inspectionId, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * JobsApi - axios parameter creator
 * @export
 */
export const JobsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Delete a job type
         * @param {string} id ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        destroyJobType: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('destroyJobType', 'id', id);
            const localVarPath = `/jobs/types/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Show a job type
         * @param {string} id ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobType: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getJobType', 'id', id);
            const localVarPath = `/jobs/types/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary List the companies job types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobTypes: async (options = {}) => {
            const localVarPath = `/jobs/types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a summary of the outstanding jobs grouped by template type.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupedJobs: async (options = {}) => {
            const localVarPath = `/jobs/groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a groups jobs.
         * @param {number} group ID of template to show the grouped jobs for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobGroup: async (group, options = {}) => {
            // verify required parameter 'group' is not null or undefined
            assertParamExists('jobGroup', 'group', group);
            const localVarPath = `/jobs/groups/{group}`
                .replace(`{${"group"}}`, encodeURIComponent(String(group)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch a job type
         * @param {string} id ID
         * @param {PatchJobTypePayload} patchJobTypePayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchJobType: async (id, patchJobTypePayload, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patchJobType', 'id', id);
            // verify required parameter 'patchJobTypePayload' is not null or undefined
            assertParamExists('patchJobType', 'patchJobTypePayload', patchJobTypePayload);
            const localVarPath = `/jobs/types/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(patchJobTypePayload, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create a job type
         * @param {StoreJobTypePayload} storeJobTypePayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeJobType: async (storeJobTypePayload, options = {}) => {
            // verify required parameter 'storeJobTypePayload' is not null or undefined
            assertParamExists('storeJobType', 'storeJobTypePayload', storeJobTypePayload);
            const localVarPath = `/jobs/types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(storeJobTypePayload, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * JobsApi - functional programming interface
 * @export
 */
export const JobsApiFp = function (configuration) {
    const localVarAxiosParamCreator = JobsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Delete a job type
         * @param {string} id ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async destroyJobType(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.destroyJobType(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobsApi.destroyJobType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Show a job type
         * @param {string} id ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getJobType(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getJobType(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobsApi.getJobType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary List the companies job types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getJobTypes(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getJobTypes(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobsApi.getJobTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get a summary of the outstanding jobs grouped by template type.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async groupedJobs(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.groupedJobs(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobsApi.groupedJobs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get a groups jobs.
         * @param {number} group ID of template to show the grouped jobs for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async jobGroup(group, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.jobGroup(group, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobsApi.jobGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Patch a job type
         * @param {string} id ID
         * @param {PatchJobTypePayload} patchJobTypePayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchJobType(id, patchJobTypePayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchJobType(id, patchJobTypePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobsApi.patchJobType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Create a job type
         * @param {StoreJobTypePayload} storeJobTypePayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storeJobType(storeJobTypePayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storeJobType(storeJobTypePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobsApi.storeJobType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * JobsApi - factory interface
 * @export
 */
export const JobsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = JobsApiFp(configuration);
    return {
        /**
         *
         * @summary Delete a job type
         * @param {string} id ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        destroyJobType(id, options) {
            return localVarFp.destroyJobType(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Show a job type
         * @param {string} id ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobType(id, options) {
            return localVarFp.getJobType(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List the companies job types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobTypes(options) {
            return localVarFp.getJobTypes(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a summary of the outstanding jobs grouped by template type.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupedJobs(options) {
            return localVarFp.groupedJobs(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a groups jobs.
         * @param {number} group ID of template to show the grouped jobs for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobGroup(group, options) {
            return localVarFp.jobGroup(group, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch a job type
         * @param {string} id ID
         * @param {PatchJobTypePayload} patchJobTypePayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchJobType(id, patchJobTypePayload, options) {
            return localVarFp.patchJobType(id, patchJobTypePayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create a job type
         * @param {StoreJobTypePayload} storeJobTypePayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeJobType(storeJobTypePayload, options) {
            return localVarFp.storeJobType(storeJobTypePayload, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * JobsApi - object-oriented interface
 * @export
 * @class JobsApi
 * @extends {BaseAPI}
 */
export class JobsApi extends BaseAPI {
    /**
     *
     * @summary Delete a job type
     * @param {string} id ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobsApi
     */
    destroyJobType(id, options) {
        return JobsApiFp(this.configuration).destroyJobType(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Show a job type
     * @param {string} id ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobsApi
     */
    getJobType(id, options) {
        return JobsApiFp(this.configuration).getJobType(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List the companies job types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobsApi
     */
    getJobTypes(options) {
        return JobsApiFp(this.configuration).getJobTypes(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a summary of the outstanding jobs grouped by template type.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobsApi
     */
    groupedJobs(options) {
        return JobsApiFp(this.configuration).groupedJobs(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a groups jobs.
     * @param {number} group ID of template to show the grouped jobs for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobsApi
     */
    jobGroup(group, options) {
        return JobsApiFp(this.configuration).jobGroup(group, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch a job type
     * @param {string} id ID
     * @param {PatchJobTypePayload} patchJobTypePayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobsApi
     */
    patchJobType(id, patchJobTypePayload, options) {
        return JobsApiFp(this.configuration).patchJobType(id, patchJobTypePayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create a job type
     * @param {StoreJobTypePayload} storeJobTypePayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobsApi
     */
    storeJobType(storeJobTypePayload, options) {
        return JobsApiFp(this.configuration).storeJobType(storeJobTypePayload, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * KitsApi - axios parameter creator
 * @export
 */
export const KitsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Delete a kit
         * @param {number} id Kit ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        destroyKit: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('destroyKit', 'id', id);
            const localVarPath = `/kits/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Fit a kit to a stock listing optionally via a deal
         * @param {number} id Kit ID
         * @param {FitKitRequest} fitKitRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fitKit: async (id, fitKitRequest, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('fitKit', 'id', id);
            // verify required parameter 'fitKitRequest' is not null or undefined
            assertParamExists('fitKit', 'fitKitRequest', fitKitRequest);
            const localVarPath = `/kits/{id}/fit`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(fitKitRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a kit
         * @param {number} id Kit ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKit: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getKit', 'id', id);
            const localVarPath = `/kits/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Gets a paginated list of kits
         * @param {number} [page] Page
         * @param {number} [perPage] Per Page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKits: async (page, perPage, options = {}) => {
            const localVarPath = `/kits`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create a kit
         * @param {StoreKitPayload} storeKitPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeKit: async (storeKitPayload, options = {}) => {
            // verify required parameter 'storeKitPayload' is not null or undefined
            assertParamExists('storeKit', 'storeKitPayload', storeKitPayload);
            const localVarPath = `/kits`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(storeKitPayload, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Unfit a kit from a stock listing optionally via a deal
         * @param {number} id Kit ID
         * @param {UnfitKitRequest} unfitKitRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unfitKit: async (id, unfitKitRequest, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('unfitKit', 'id', id);
            // verify required parameter 'unfitKitRequest' is not null or undefined
            assertParamExists('unfitKit', 'unfitKitRequest', unfitKitRequest);
            const localVarPath = `/kits/{id}/unfit`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(unfitKitRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * KitsApi - functional programming interface
 * @export
 */
export const KitsApiFp = function (configuration) {
    const localVarAxiosParamCreator = KitsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Delete a kit
         * @param {number} id Kit ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async destroyKit(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.destroyKit(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KitsApi.destroyKit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Fit a kit to a stock listing optionally via a deal
         * @param {number} id Kit ID
         * @param {FitKitRequest} fitKitRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fitKit(id, fitKitRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fitKit(id, fitKitRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KitsApi.fitKit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get a kit
         * @param {number} id Kit ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getKit(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getKit(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KitsApi.getKit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Gets a paginated list of kits
         * @param {number} [page] Page
         * @param {number} [perPage] Per Page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getKits(page, perPage, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getKits(page, perPage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KitsApi.getKits']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Create a kit
         * @param {StoreKitPayload} storeKitPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storeKit(storeKitPayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storeKit(storeKitPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KitsApi.storeKit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Unfit a kit from a stock listing optionally via a deal
         * @param {number} id Kit ID
         * @param {UnfitKitRequest} unfitKitRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unfitKit(id, unfitKitRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unfitKit(id, unfitKitRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KitsApi.unfitKit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * KitsApi - factory interface
 * @export
 */
export const KitsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = KitsApiFp(configuration);
    return {
        /**
         *
         * @summary Delete a kit
         * @param {number} id Kit ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        destroyKit(id, options) {
            return localVarFp.destroyKit(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Fit a kit to a stock listing optionally via a deal
         * @param {number} id Kit ID
         * @param {FitKitRequest} fitKitRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fitKit(id, fitKitRequest, options) {
            return localVarFp.fitKit(id, fitKitRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a kit
         * @param {number} id Kit ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKit(id, options) {
            return localVarFp.getKit(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets a paginated list of kits
         * @param {number} [page] Page
         * @param {number} [perPage] Per Page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKits(page, perPage, options) {
            return localVarFp.getKits(page, perPage, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create a kit
         * @param {StoreKitPayload} storeKitPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeKit(storeKitPayload, options) {
            return localVarFp.storeKit(storeKitPayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Unfit a kit from a stock listing optionally via a deal
         * @param {number} id Kit ID
         * @param {UnfitKitRequest} unfitKitRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unfitKit(id, unfitKitRequest, options) {
            return localVarFp.unfitKit(id, unfitKitRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * KitsApi - object-oriented interface
 * @export
 * @class KitsApi
 * @extends {BaseAPI}
 */
export class KitsApi extends BaseAPI {
    /**
     *
     * @summary Delete a kit
     * @param {number} id Kit ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KitsApi
     */
    destroyKit(id, options) {
        return KitsApiFp(this.configuration).destroyKit(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Fit a kit to a stock listing optionally via a deal
     * @param {number} id Kit ID
     * @param {FitKitRequest} fitKitRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KitsApi
     */
    fitKit(id, fitKitRequest, options) {
        return KitsApiFp(this.configuration).fitKit(id, fitKitRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a kit
     * @param {number} id Kit ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KitsApi
     */
    getKit(id, options) {
        return KitsApiFp(this.configuration).getKit(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets a paginated list of kits
     * @param {number} [page] Page
     * @param {number} [perPage] Per Page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KitsApi
     */
    getKits(page, perPage, options) {
        return KitsApiFp(this.configuration).getKits(page, perPage, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create a kit
     * @param {StoreKitPayload} storeKitPayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KitsApi
     */
    storeKit(storeKitPayload, options) {
        return KitsApiFp(this.configuration).storeKit(storeKitPayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Unfit a kit from a stock listing optionally via a deal
     * @param {number} id Kit ID
     * @param {UnfitKitRequest} unfitKitRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KitsApi
     */
    unfitKit(id, unfitKitRequest, options) {
        return KitsApiFp(this.configuration).unfitKit(id, unfitKitRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * LeadPipelinesApi - axios parameter creator
 * @export
 */
export const LeadPipelinesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Archive a lead pipeline.
         * @param {number} id Lead Pipeline ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLeadPipeline: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteLeadPipeline', 'id', id);
            const localVarPath = `/lead-pipelines/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary List the available lead pipelines.
         * @param {number} id ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeadPipeline: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getLeadPipeline', 'id', id);
            const localVarPath = `/lead-pipelines/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary List the available lead pipelines.
         * @param {number} [page] Page
         * @param {string} [leadType] Lead Type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeadPipelines: async (page, leadType, options = {}) => {
            const localVarPath = `/lead-pipelines`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (leadType !== undefined) {
                localVarQueryParameter['lead_type'] = leadType;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update a lead pipeline.
         * @param {number} id Lead Pipeline ID
         * @param {PatchLeadPipelinePayload} patchLeadPipelinePayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchLeadPipeline: async (id, patchLeadPipelinePayload, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patchLeadPipeline', 'id', id);
            // verify required parameter 'patchLeadPipelinePayload' is not null or undefined
            assertParamExists('patchLeadPipeline', 'patchLeadPipelinePayload', patchLeadPipelinePayload);
            const localVarPath = `/lead-pipelines/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(patchLeadPipelinePayload, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Reorder lead pipelines.
         * @param {ReorderLeadPipelinesPayload} reorderLeadPipelinesPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reorderLeadPipelines: async (reorderLeadPipelinesPayload, options = {}) => {
            // verify required parameter 'reorderLeadPipelinesPayload' is not null or undefined
            assertParamExists('reorderLeadPipelines', 'reorderLeadPipelinesPayload', reorderLeadPipelinesPayload);
            const localVarPath = `/lead-pipelines/reorder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(reorderLeadPipelinesPayload, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Restore a lead pipeline.
         * @param {number} id Lead Pipeline ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreLeadPipeline: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('restoreLeadPipeline', 'id', id);
            const localVarPath = `/lead-pipelines/{id}/restore`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Store a lead pipeline.
         * @param {StoreLeadPipelinePayload} storeLeadPipelinePayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeLeadPipeline: async (storeLeadPipelinePayload, options = {}) => {
            // verify required parameter 'storeLeadPipelinePayload' is not null or undefined
            assertParamExists('storeLeadPipeline', 'storeLeadPipelinePayload', storeLeadPipelinePayload);
            const localVarPath = `/lead-pipelines`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(storeLeadPipelinePayload, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * LeadPipelinesApi - functional programming interface
 * @export
 */
export const LeadPipelinesApiFp = function (configuration) {
    const localVarAxiosParamCreator = LeadPipelinesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Archive a lead pipeline.
         * @param {number} id Lead Pipeline ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteLeadPipeline(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteLeadPipeline(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LeadPipelinesApi.deleteLeadPipeline']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary List the available lead pipelines.
         * @param {number} id ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLeadPipeline(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLeadPipeline(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LeadPipelinesApi.getLeadPipeline']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary List the available lead pipelines.
         * @param {number} [page] Page
         * @param {string} [leadType] Lead Type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLeadPipelines(page, leadType, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLeadPipelines(page, leadType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LeadPipelinesApi.getLeadPipelines']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Update a lead pipeline.
         * @param {number} id Lead Pipeline ID
         * @param {PatchLeadPipelinePayload} patchLeadPipelinePayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchLeadPipeline(id, patchLeadPipelinePayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchLeadPipeline(id, patchLeadPipelinePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LeadPipelinesApi.patchLeadPipeline']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Reorder lead pipelines.
         * @param {ReorderLeadPipelinesPayload} reorderLeadPipelinesPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reorderLeadPipelines(reorderLeadPipelinesPayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reorderLeadPipelines(reorderLeadPipelinesPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LeadPipelinesApi.reorderLeadPipelines']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Restore a lead pipeline.
         * @param {number} id Lead Pipeline ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restoreLeadPipeline(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restoreLeadPipeline(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LeadPipelinesApi.restoreLeadPipeline']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Store a lead pipeline.
         * @param {StoreLeadPipelinePayload} storeLeadPipelinePayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storeLeadPipeline(storeLeadPipelinePayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storeLeadPipeline(storeLeadPipelinePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LeadPipelinesApi.storeLeadPipeline']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * LeadPipelinesApi - factory interface
 * @export
 */
export const LeadPipelinesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = LeadPipelinesApiFp(configuration);
    return {
        /**
         *
         * @summary Archive a lead pipeline.
         * @param {number} id Lead Pipeline ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLeadPipeline(id, options) {
            return localVarFp.deleteLeadPipeline(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List the available lead pipelines.
         * @param {number} id ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeadPipeline(id, options) {
            return localVarFp.getLeadPipeline(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List the available lead pipelines.
         * @param {number} [page] Page
         * @param {string} [leadType] Lead Type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeadPipelines(page, leadType, options) {
            return localVarFp.getLeadPipelines(page, leadType, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update a lead pipeline.
         * @param {number} id Lead Pipeline ID
         * @param {PatchLeadPipelinePayload} patchLeadPipelinePayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchLeadPipeline(id, patchLeadPipelinePayload, options) {
            return localVarFp.patchLeadPipeline(id, patchLeadPipelinePayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Reorder lead pipelines.
         * @param {ReorderLeadPipelinesPayload} reorderLeadPipelinesPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reorderLeadPipelines(reorderLeadPipelinesPayload, options) {
            return localVarFp.reorderLeadPipelines(reorderLeadPipelinesPayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Restore a lead pipeline.
         * @param {number} id Lead Pipeline ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreLeadPipeline(id, options) {
            return localVarFp.restoreLeadPipeline(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Store a lead pipeline.
         * @param {StoreLeadPipelinePayload} storeLeadPipelinePayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeLeadPipeline(storeLeadPipelinePayload, options) {
            return localVarFp.storeLeadPipeline(storeLeadPipelinePayload, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * LeadPipelinesApi - object-oriented interface
 * @export
 * @class LeadPipelinesApi
 * @extends {BaseAPI}
 */
export class LeadPipelinesApi extends BaseAPI {
    /**
     *
     * @summary Archive a lead pipeline.
     * @param {number} id Lead Pipeline ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadPipelinesApi
     */
    deleteLeadPipeline(id, options) {
        return LeadPipelinesApiFp(this.configuration).deleteLeadPipeline(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List the available lead pipelines.
     * @param {number} id ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadPipelinesApi
     */
    getLeadPipeline(id, options) {
        return LeadPipelinesApiFp(this.configuration).getLeadPipeline(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List the available lead pipelines.
     * @param {number} [page] Page
     * @param {string} [leadType] Lead Type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadPipelinesApi
     */
    getLeadPipelines(page, leadType, options) {
        return LeadPipelinesApiFp(this.configuration).getLeadPipelines(page, leadType, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update a lead pipeline.
     * @param {number} id Lead Pipeline ID
     * @param {PatchLeadPipelinePayload} patchLeadPipelinePayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadPipelinesApi
     */
    patchLeadPipeline(id, patchLeadPipelinePayload, options) {
        return LeadPipelinesApiFp(this.configuration).patchLeadPipeline(id, patchLeadPipelinePayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Reorder lead pipelines.
     * @param {ReorderLeadPipelinesPayload} reorderLeadPipelinesPayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadPipelinesApi
     */
    reorderLeadPipelines(reorderLeadPipelinesPayload, options) {
        return LeadPipelinesApiFp(this.configuration).reorderLeadPipelines(reorderLeadPipelinesPayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Restore a lead pipeline.
     * @param {number} id Lead Pipeline ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadPipelinesApi
     */
    restoreLeadPipeline(id, options) {
        return LeadPipelinesApiFp(this.configuration).restoreLeadPipeline(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Store a lead pipeline.
     * @param {StoreLeadPipelinePayload} storeLeadPipelinePayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadPipelinesApi
     */
    storeLeadPipeline(storeLeadPipelinePayload, options) {
        return LeadPipelinesApiFp(this.configuration).storeLeadPipeline(storeLeadPipelinePayload, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * LeadStagesApi - axios parameter creator
 * @export
 */
export const LeadStagesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Archive a lead stage.
         * @param {number} stageId Lead Stage ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLeadStage: async (stageId, options = {}) => {
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('deleteLeadStage', 'stageId', stageId);
            const localVarPath = `/lead-stages/{stage_id}`
                .replace(`{${"stage_id"}}`, encodeURIComponent(String(stageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary List the available lead stages.
         * @param {string} [leadType] Lead Type
         * @param {number} [page] Page
         * @param {number} [perPage] Per Page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeadStages: async (leadType, page, perPage, options = {}) => {
            const localVarPath = `/lead-stages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (leadType !== undefined) {
                localVarQueryParameter['lead_type'] = leadType;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update a lead stage.
         * @param {number} stageId Lead Stage ID
         * @param {PatchLeadStagePayload} patchLeadStagePayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchLeadStage: async (stageId, patchLeadStagePayload, options = {}) => {
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('patchLeadStage', 'stageId', stageId);
            // verify required parameter 'patchLeadStagePayload' is not null or undefined
            assertParamExists('patchLeadStage', 'patchLeadStagePayload', patchLeadStagePayload);
            const localVarPath = `/lead-stages/{stage_id}`
                .replace(`{${"stage_id"}}`, encodeURIComponent(String(stageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(patchLeadStagePayload, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Reorder lead stages within a pipeline.
         * @param {number} pipelineId Lead Pipeline ID
         * @param {ReorderLeadStagesPayload} reorderLeadStagesPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reorderLeadStages: async (pipelineId, reorderLeadStagesPayload, options = {}) => {
            // verify required parameter 'pipelineId' is not null or undefined
            assertParamExists('reorderLeadStages', 'pipelineId', pipelineId);
            // verify required parameter 'reorderLeadStagesPayload' is not null or undefined
            assertParamExists('reorderLeadStages', 'reorderLeadStagesPayload', reorderLeadStagesPayload);
            const localVarPath = `/lead-pipelines/{pipeline_id}/lead-stages/reorder`
                .replace(`{${"pipeline_id"}}`, encodeURIComponent(String(pipelineId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(reorderLeadStagesPayload, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Restore a lead stage.
         * @param {number} stageId Lead Stage ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreLeadStage: async (stageId, options = {}) => {
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('restoreLeadStage', 'stageId', stageId);
            const localVarPath = `/lead-stages/{stage_id}/restore`
                .replace(`{${"stage_id"}}`, encodeURIComponent(String(stageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Store a lead stage.
         * @param {number} pipelineId Lead Pipeline ID
         * @param {StoreLeadStagePayload} storeLeadStagePayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeLeadStage: async (pipelineId, storeLeadStagePayload, options = {}) => {
            // verify required parameter 'pipelineId' is not null or undefined
            assertParamExists('storeLeadStage', 'pipelineId', pipelineId);
            // verify required parameter 'storeLeadStagePayload' is not null or undefined
            assertParamExists('storeLeadStage', 'storeLeadStagePayload', storeLeadStagePayload);
            const localVarPath = `/lead-pipelines/{pipeline_id}/lead-stages`
                .replace(`{${"pipeline_id"}}`, encodeURIComponent(String(pipelineId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(storeLeadStagePayload, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * LeadStagesApi - functional programming interface
 * @export
 */
export const LeadStagesApiFp = function (configuration) {
    const localVarAxiosParamCreator = LeadStagesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Archive a lead stage.
         * @param {number} stageId Lead Stage ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteLeadStage(stageId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteLeadStage(stageId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LeadStagesApi.deleteLeadStage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary List the available lead stages.
         * @param {string} [leadType] Lead Type
         * @param {number} [page] Page
         * @param {number} [perPage] Per Page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLeadStages(leadType, page, perPage, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLeadStages(leadType, page, perPage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LeadStagesApi.getLeadStages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Update a lead stage.
         * @param {number} stageId Lead Stage ID
         * @param {PatchLeadStagePayload} patchLeadStagePayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchLeadStage(stageId, patchLeadStagePayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchLeadStage(stageId, patchLeadStagePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LeadStagesApi.patchLeadStage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Reorder lead stages within a pipeline.
         * @param {number} pipelineId Lead Pipeline ID
         * @param {ReorderLeadStagesPayload} reorderLeadStagesPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reorderLeadStages(pipelineId, reorderLeadStagesPayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reorderLeadStages(pipelineId, reorderLeadStagesPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LeadStagesApi.reorderLeadStages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Restore a lead stage.
         * @param {number} stageId Lead Stage ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restoreLeadStage(stageId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restoreLeadStage(stageId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LeadStagesApi.restoreLeadStage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Store a lead stage.
         * @param {number} pipelineId Lead Pipeline ID
         * @param {StoreLeadStagePayload} storeLeadStagePayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storeLeadStage(pipelineId, storeLeadStagePayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storeLeadStage(pipelineId, storeLeadStagePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LeadStagesApi.storeLeadStage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * LeadStagesApi - factory interface
 * @export
 */
export const LeadStagesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = LeadStagesApiFp(configuration);
    return {
        /**
         *
         * @summary Archive a lead stage.
         * @param {number} stageId Lead Stage ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLeadStage(stageId, options) {
            return localVarFp.deleteLeadStage(stageId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List the available lead stages.
         * @param {string} [leadType] Lead Type
         * @param {number} [page] Page
         * @param {number} [perPage] Per Page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeadStages(leadType, page, perPage, options) {
            return localVarFp.getLeadStages(leadType, page, perPage, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update a lead stage.
         * @param {number} stageId Lead Stage ID
         * @param {PatchLeadStagePayload} patchLeadStagePayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchLeadStage(stageId, patchLeadStagePayload, options) {
            return localVarFp.patchLeadStage(stageId, patchLeadStagePayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Reorder lead stages within a pipeline.
         * @param {number} pipelineId Lead Pipeline ID
         * @param {ReorderLeadStagesPayload} reorderLeadStagesPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reorderLeadStages(pipelineId, reorderLeadStagesPayload, options) {
            return localVarFp.reorderLeadStages(pipelineId, reorderLeadStagesPayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Restore a lead stage.
         * @param {number} stageId Lead Stage ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreLeadStage(stageId, options) {
            return localVarFp.restoreLeadStage(stageId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Store a lead stage.
         * @param {number} pipelineId Lead Pipeline ID
         * @param {StoreLeadStagePayload} storeLeadStagePayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeLeadStage(pipelineId, storeLeadStagePayload, options) {
            return localVarFp.storeLeadStage(pipelineId, storeLeadStagePayload, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * LeadStagesApi - object-oriented interface
 * @export
 * @class LeadStagesApi
 * @extends {BaseAPI}
 */
export class LeadStagesApi extends BaseAPI {
    /**
     *
     * @summary Archive a lead stage.
     * @param {number} stageId Lead Stage ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadStagesApi
     */
    deleteLeadStage(stageId, options) {
        return LeadStagesApiFp(this.configuration).deleteLeadStage(stageId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List the available lead stages.
     * @param {string} [leadType] Lead Type
     * @param {number} [page] Page
     * @param {number} [perPage] Per Page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadStagesApi
     */
    getLeadStages(leadType, page, perPage, options) {
        return LeadStagesApiFp(this.configuration).getLeadStages(leadType, page, perPage, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update a lead stage.
     * @param {number} stageId Lead Stage ID
     * @param {PatchLeadStagePayload} patchLeadStagePayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadStagesApi
     */
    patchLeadStage(stageId, patchLeadStagePayload, options) {
        return LeadStagesApiFp(this.configuration).patchLeadStage(stageId, patchLeadStagePayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Reorder lead stages within a pipeline.
     * @param {number} pipelineId Lead Pipeline ID
     * @param {ReorderLeadStagesPayload} reorderLeadStagesPayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadStagesApi
     */
    reorderLeadStages(pipelineId, reorderLeadStagesPayload, options) {
        return LeadStagesApiFp(this.configuration).reorderLeadStages(pipelineId, reorderLeadStagesPayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Restore a lead stage.
     * @param {number} stageId Lead Stage ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadStagesApi
     */
    restoreLeadStage(stageId, options) {
        return LeadStagesApiFp(this.configuration).restoreLeadStage(stageId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Store a lead stage.
     * @param {number} pipelineId Lead Pipeline ID
     * @param {StoreLeadStagePayload} storeLeadStagePayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadStagesApi
     */
    storeLeadStage(pipelineId, storeLeadStagePayload, options) {
        return LeadStagesApiFp(this.configuration).storeLeadStage(pipelineId, storeLeadStagePayload, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * LeadsApi - axios parameter creator
 * @export
 */
export const LeadsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Delete a vehicle of interest.
         * @param {number} leadId Lead ID
         * @param {number} vehicleOfInterestId Vehicle of Interest ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        destroyVehicleOfInterest: async (leadId, vehicleOfInterestId, options = {}) => {
            // verify required parameter 'leadId' is not null or undefined
            assertParamExists('destroyVehicleOfInterest', 'leadId', leadId);
            // verify required parameter 'vehicleOfInterestId' is not null or undefined
            assertParamExists('destroyVehicleOfInterest', 'vehicleOfInterestId', vehicleOfInterestId);
            const localVarPath = `/leads/{lead_id}/vehicles-of-interest/{vehicle_of_interest_id}`
                .replace(`{${"lead_id"}}`, encodeURIComponent(String(leadId)))
                .replace(`{${"vehicle_of_interest_id"}}`, encodeURIComponent(String(vehicleOfInterestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a list of settlements that can be contra entered against a finance settlement.
         * @param {number} id Lead ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLead: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getLead', 'id', id);
            const localVarPath = `/leads/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getlostLeadOutcomes: async (options = {}) => {
            const localVarPath = `/lost-lead-outcomes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch a lead.
         * @param {number} id Lead ID
         * @param {PatchLeadPayload} patchLeadPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchLead: async (id, patchLeadPayload, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patchLead', 'id', id);
            // verify required parameter 'patchLeadPayload' is not null or undefined
            assertParamExists('patchLead', 'patchLeadPayload', patchLeadPayload);
            const localVarPath = `/leads/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(patchLeadPayload, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Store lead.
         * @param {StoreLeadPayload} storeLeadPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeLead: async (storeLeadPayload, options = {}) => {
            // verify required parameter 'storeLeadPayload' is not null or undefined
            assertParamExists('storeLead', 'storeLeadPayload', storeLeadPayload);
            const localVarPath = `/leads`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(storeLeadPayload, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Store vehicle of interest.
         * @param {number} leadId Lead ID
         * @param {StoreVehicleOfInterestPayload} storeVehicleOfInterestPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeVehicleOfInterest: async (leadId, storeVehicleOfInterestPayload, options = {}) => {
            // verify required parameter 'leadId' is not null or undefined
            assertParamExists('storeVehicleOfInterest', 'leadId', leadId);
            // verify required parameter 'storeVehicleOfInterestPayload' is not null or undefined
            assertParamExists('storeVehicleOfInterest', 'storeVehicleOfInterestPayload', storeVehicleOfInterestPayload);
            const localVarPath = `/leads/{lead_id}/vehicles-of-interest`
                .replace(`{${"lead_id"}}`, encodeURIComponent(String(leadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(storeVehicleOfInterestPayload, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * LeadsApi - functional programming interface
 * @export
 */
export const LeadsApiFp = function (configuration) {
    const localVarAxiosParamCreator = LeadsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Delete a vehicle of interest.
         * @param {number} leadId Lead ID
         * @param {number} vehicleOfInterestId Vehicle of Interest ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async destroyVehicleOfInterest(leadId, vehicleOfInterestId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.destroyVehicleOfInterest(leadId, vehicleOfInterestId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LeadsApi.destroyVehicleOfInterest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get a list of settlements that can be contra entered against a finance settlement.
         * @param {number} id Lead ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLead(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLead(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LeadsApi.getLead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getlostLeadOutcomes(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getlostLeadOutcomes(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LeadsApi.getlostLeadOutcomes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Patch a lead.
         * @param {number} id Lead ID
         * @param {PatchLeadPayload} patchLeadPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchLead(id, patchLeadPayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchLead(id, patchLeadPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LeadsApi.patchLead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Store lead.
         * @param {StoreLeadPayload} storeLeadPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storeLead(storeLeadPayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storeLead(storeLeadPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LeadsApi.storeLead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Store vehicle of interest.
         * @param {number} leadId Lead ID
         * @param {StoreVehicleOfInterestPayload} storeVehicleOfInterestPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storeVehicleOfInterest(leadId, storeVehicleOfInterestPayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storeVehicleOfInterest(leadId, storeVehicleOfInterestPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LeadsApi.storeVehicleOfInterest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * LeadsApi - factory interface
 * @export
 */
export const LeadsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = LeadsApiFp(configuration);
    return {
        /**
         *
         * @summary Delete a vehicle of interest.
         * @param {number} leadId Lead ID
         * @param {number} vehicleOfInterestId Vehicle of Interest ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        destroyVehicleOfInterest(leadId, vehicleOfInterestId, options) {
            return localVarFp.destroyVehicleOfInterest(leadId, vehicleOfInterestId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a list of settlements that can be contra entered against a finance settlement.
         * @param {number} id Lead ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLead(id, options) {
            return localVarFp.getLead(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getlostLeadOutcomes(options) {
            return localVarFp.getlostLeadOutcomes(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch a lead.
         * @param {number} id Lead ID
         * @param {PatchLeadPayload} patchLeadPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchLead(id, patchLeadPayload, options) {
            return localVarFp.patchLead(id, patchLeadPayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Store lead.
         * @param {StoreLeadPayload} storeLeadPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeLead(storeLeadPayload, options) {
            return localVarFp.storeLead(storeLeadPayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Store vehicle of interest.
         * @param {number} leadId Lead ID
         * @param {StoreVehicleOfInterestPayload} storeVehicleOfInterestPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeVehicleOfInterest(leadId, storeVehicleOfInterestPayload, options) {
            return localVarFp.storeVehicleOfInterest(leadId, storeVehicleOfInterestPayload, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * LeadsApi - object-oriented interface
 * @export
 * @class LeadsApi
 * @extends {BaseAPI}
 */
export class LeadsApi extends BaseAPI {
    /**
     *
     * @summary Delete a vehicle of interest.
     * @param {number} leadId Lead ID
     * @param {number} vehicleOfInterestId Vehicle of Interest ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadsApi
     */
    destroyVehicleOfInterest(leadId, vehicleOfInterestId, options) {
        return LeadsApiFp(this.configuration).destroyVehicleOfInterest(leadId, vehicleOfInterestId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a list of settlements that can be contra entered against a finance settlement.
     * @param {number} id Lead ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadsApi
     */
    getLead(id, options) {
        return LeadsApiFp(this.configuration).getLead(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadsApi
     */
    getlostLeadOutcomes(options) {
        return LeadsApiFp(this.configuration).getlostLeadOutcomes(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch a lead.
     * @param {number} id Lead ID
     * @param {PatchLeadPayload} patchLeadPayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadsApi
     */
    patchLead(id, patchLeadPayload, options) {
        return LeadsApiFp(this.configuration).patchLead(id, patchLeadPayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Store lead.
     * @param {StoreLeadPayload} storeLeadPayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadsApi
     */
    storeLead(storeLeadPayload, options) {
        return LeadsApiFp(this.configuration).storeLead(storeLeadPayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Store vehicle of interest.
     * @param {number} leadId Lead ID
     * @param {StoreVehicleOfInterestPayload} storeVehicleOfInterestPayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadsApi
     */
    storeVehicleOfInterest(leadId, storeVehicleOfInterestPayload, options) {
        return LeadsApiFp(this.configuration).storeVehicleOfInterest(leadId, storeVehicleOfInterestPayload, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * LocationsApi - axios parameter creator
 * @export
 */
export const LocationsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Delete a location
         * @param {string} id ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        destroyLocation: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('destroyLocation', 'id', id);
            const localVarPath = `/locations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a location
         * @param {number} id ID of the location
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocation: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getLocation', 'id', id);
            const localVarPath = `/locations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Show the available locations.
         * @param {boolean} [withDeleted] Include deleted locations
         * @param {boolean} [withTeams] Include team fragments
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocations: async (withDeleted, withTeams, options = {}) => {
            const localVarPath = `/locations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (withDeleted !== undefined) {
                localVarQueryParameter['with_deleted'] = withDeleted;
            }
            if (withTeams !== undefined) {
                localVarQueryParameter['with_teams'] = withTeams;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Move unsold stock to another location.
         * @param {number} id
         * @param {MoveLocationStockRequest} moveLocationStockRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveLocationStock: async (id, moveLocationStockRequest, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('moveLocationStock', 'id', id);
            // verify required parameter 'moveLocationStockRequest' is not null or undefined
            assertParamExists('moveLocationStock', 'moveLocationStockRequest', moveLocationStockRequest);
            const localVarPath = `/locations/{id}/move-stock`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(moveLocationStockRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch a location
         * @param {string} id ID
         * @param {PatchLocationRequest} patchLocationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchLocation: async (id, patchLocationRequest, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patchLocation', 'id', id);
            // verify required parameter 'patchLocationRequest' is not null or undefined
            assertParamExists('patchLocation', 'patchLocationRequest', patchLocationRequest);
            const localVarPath = `/locations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(patchLocationRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Restore a location from a deleted state
         * @param {number} id ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreLocation: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('restoreLocation', 'id', id);
            const localVarPath = `/locations/{id}/restore`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create a location
         * @param {StoreLocationRequest} storeLocationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeLocation: async (storeLocationRequest, options = {}) => {
            // verify required parameter 'storeLocationRequest' is not null or undefined
            assertParamExists('storeLocation', 'storeLocationRequest', storeLocationRequest);
            const localVarPath = `/locations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(storeLocationRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * LocationsApi - functional programming interface
 * @export
 */
export const LocationsApiFp = function (configuration) {
    const localVarAxiosParamCreator = LocationsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Delete a location
         * @param {string} id ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async destroyLocation(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.destroyLocation(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.destroyLocation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get a location
         * @param {number} id ID of the location
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLocation(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLocation(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.getLocation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Show the available locations.
         * @param {boolean} [withDeleted] Include deleted locations
         * @param {boolean} [withTeams] Include team fragments
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLocations(withDeleted, withTeams, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLocations(withDeleted, withTeams, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.getLocations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Move unsold stock to another location.
         * @param {number} id
         * @param {MoveLocationStockRequest} moveLocationStockRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moveLocationStock(id, moveLocationStockRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moveLocationStock(id, moveLocationStockRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.moveLocationStock']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Patch a location
         * @param {string} id ID
         * @param {PatchLocationRequest} patchLocationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchLocation(id, patchLocationRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchLocation(id, patchLocationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.patchLocation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Restore a location from a deleted state
         * @param {number} id ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restoreLocation(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restoreLocation(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.restoreLocation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Create a location
         * @param {StoreLocationRequest} storeLocationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storeLocation(storeLocationRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storeLocation(storeLocationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.storeLocation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * LocationsApi - factory interface
 * @export
 */
export const LocationsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = LocationsApiFp(configuration);
    return {
        /**
         *
         * @summary Delete a location
         * @param {string} id ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        destroyLocation(id, options) {
            return localVarFp.destroyLocation(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a location
         * @param {number} id ID of the location
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocation(id, options) {
            return localVarFp.getLocation(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Show the available locations.
         * @param {boolean} [withDeleted] Include deleted locations
         * @param {boolean} [withTeams] Include team fragments
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocations(withDeleted, withTeams, options) {
            return localVarFp.getLocations(withDeleted, withTeams, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Move unsold stock to another location.
         * @param {number} id
         * @param {MoveLocationStockRequest} moveLocationStockRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveLocationStock(id, moveLocationStockRequest, options) {
            return localVarFp.moveLocationStock(id, moveLocationStockRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch a location
         * @param {string} id ID
         * @param {PatchLocationRequest} patchLocationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchLocation(id, patchLocationRequest, options) {
            return localVarFp.patchLocation(id, patchLocationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Restore a location from a deleted state
         * @param {number} id ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreLocation(id, options) {
            return localVarFp.restoreLocation(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create a location
         * @param {StoreLocationRequest} storeLocationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeLocation(storeLocationRequest, options) {
            return localVarFp.storeLocation(storeLocationRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * LocationsApi - object-oriented interface
 * @export
 * @class LocationsApi
 * @extends {BaseAPI}
 */
export class LocationsApi extends BaseAPI {
    /**
     *
     * @summary Delete a location
     * @param {string} id ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    destroyLocation(id, options) {
        return LocationsApiFp(this.configuration).destroyLocation(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a location
     * @param {number} id ID of the location
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    getLocation(id, options) {
        return LocationsApiFp(this.configuration).getLocation(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Show the available locations.
     * @param {boolean} [withDeleted] Include deleted locations
     * @param {boolean} [withTeams] Include team fragments
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    getLocations(withDeleted, withTeams, options) {
        return LocationsApiFp(this.configuration).getLocations(withDeleted, withTeams, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Move unsold stock to another location.
     * @param {number} id
     * @param {MoveLocationStockRequest} moveLocationStockRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    moveLocationStock(id, moveLocationStockRequest, options) {
        return LocationsApiFp(this.configuration).moveLocationStock(id, moveLocationStockRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch a location
     * @param {string} id ID
     * @param {PatchLocationRequest} patchLocationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    patchLocation(id, patchLocationRequest, options) {
        return LocationsApiFp(this.configuration).patchLocation(id, patchLocationRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Restore a location from a deleted state
     * @param {number} id ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    restoreLocation(id, options) {
        return LocationsApiFp(this.configuration).restoreLocation(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create a location
     * @param {StoreLocationRequest} storeLocationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    storeLocation(storeLocationRequest, options) {
        return LocationsApiFp(this.configuration).storeLocation(storeLocationRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * OffersApi - axios parameter creator
 * @export
 */
export const OffersApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Convert an offer.
         * @param {number} id Offer ID
         * @param {ConvertOfferRequest} [convertOfferRequest] Convert Offer Request Body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        convertOffer: async (id, convertOfferRequest, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('convertOffer', 'id', id);
            const localVarPath = `/offers/{id}/convert`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(convertOfferRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete an offer.
         * @param {number} id Offer ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOffer: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOffer', 'id', id);
            const localVarPath = `/offers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get an offer.
         * @param {number} id Offer ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOffer: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getOffer', 'id', id);
            const localVarPath = `/offers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Gets a paginated list of offers.
         * @param {number} [perPage] Per Page
         * @param {number} [contactId] Filter by Contact
         * @param {number} [stockListingId] Filter by Stock Listing
         * @param {number} [page] Page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOffers: async (perPage, contactId, stockListingId, page, options = {}) => {
            const localVarPath = `/offers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }
            if (contactId !== undefined) {
                localVarQueryParameter['contact_id'] = contactId;
            }
            if (stockListingId !== undefined) {
                localVarQueryParameter['stock_listing_id'] = stockListingId;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create an offer.
         * @param {CreateOfferRequestBody} [createOfferRequestBody] Store Offer Request Body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeOffer: async (createOfferRequestBody, options = {}) => {
            const localVarPath = `/offers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createOfferRequestBody, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * OffersApi - functional programming interface
 * @export
 */
export const OffersApiFp = function (configuration) {
    const localVarAxiosParamCreator = OffersApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Convert an offer.
         * @param {number} id Offer ID
         * @param {ConvertOfferRequest} [convertOfferRequest] Convert Offer Request Body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async convertOffer(id, convertOfferRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.convertOffer(id, convertOfferRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OffersApi.convertOffer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Delete an offer.
         * @param {number} id Offer ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOffer(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOffer(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OffersApi.deleteOffer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get an offer.
         * @param {number} id Offer ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOffer(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOffer(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OffersApi.getOffer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Gets a paginated list of offers.
         * @param {number} [perPage] Per Page
         * @param {number} [contactId] Filter by Contact
         * @param {number} [stockListingId] Filter by Stock Listing
         * @param {number} [page] Page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOffers(perPage, contactId, stockListingId, page, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOffers(perPage, contactId, stockListingId, page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OffersApi.getOffers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Create an offer.
         * @param {CreateOfferRequestBody} [createOfferRequestBody] Store Offer Request Body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storeOffer(createOfferRequestBody, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storeOffer(createOfferRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OffersApi.storeOffer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * OffersApi - factory interface
 * @export
 */
export const OffersApiFactory = function (configuration, basePath, axios) {
    const localVarFp = OffersApiFp(configuration);
    return {
        /**
         *
         * @summary Convert an offer.
         * @param {number} id Offer ID
         * @param {ConvertOfferRequest} [convertOfferRequest] Convert Offer Request Body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        convertOffer(id, convertOfferRequest, options) {
            return localVarFp.convertOffer(id, convertOfferRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete an offer.
         * @param {number} id Offer ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOffer(id, options) {
            return localVarFp.deleteOffer(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get an offer.
         * @param {number} id Offer ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOffer(id, options) {
            return localVarFp.getOffer(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets a paginated list of offers.
         * @param {number} [perPage] Per Page
         * @param {number} [contactId] Filter by Contact
         * @param {number} [stockListingId] Filter by Stock Listing
         * @param {number} [page] Page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOffers(perPage, contactId, stockListingId, page, options) {
            return localVarFp.getOffers(perPage, contactId, stockListingId, page, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create an offer.
         * @param {CreateOfferRequestBody} [createOfferRequestBody] Store Offer Request Body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeOffer(createOfferRequestBody, options) {
            return localVarFp.storeOffer(createOfferRequestBody, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * OffersApi - object-oriented interface
 * @export
 * @class OffersApi
 * @extends {BaseAPI}
 */
export class OffersApi extends BaseAPI {
    /**
     *
     * @summary Convert an offer.
     * @param {number} id Offer ID
     * @param {ConvertOfferRequest} [convertOfferRequest] Convert Offer Request Body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OffersApi
     */
    convertOffer(id, convertOfferRequest, options) {
        return OffersApiFp(this.configuration).convertOffer(id, convertOfferRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete an offer.
     * @param {number} id Offer ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OffersApi
     */
    deleteOffer(id, options) {
        return OffersApiFp(this.configuration).deleteOffer(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get an offer.
     * @param {number} id Offer ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OffersApi
     */
    getOffer(id, options) {
        return OffersApiFp(this.configuration).getOffer(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets a paginated list of offers.
     * @param {number} [perPage] Per Page
     * @param {number} [contactId] Filter by Contact
     * @param {number} [stockListingId] Filter by Stock Listing
     * @param {number} [page] Page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OffersApi
     */
    getOffers(perPage, contactId, stockListingId, page, options) {
        return OffersApiFp(this.configuration).getOffers(perPage, contactId, stockListingId, page, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create an offer.
     * @param {CreateOfferRequestBody} [createOfferRequestBody] Store Offer Request Body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OffersApi
     */
    storeOffer(createOfferRequestBody, options) {
        return OffersApiFp(this.configuration).storeOffer(createOfferRequestBody, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * PartsApi - axios parameter creator
 * @export
 */
export const PartsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Delete an inventory transaction
         * @param {number} partId Part ID
         * @param {number} transactionId Transaction ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        destroyInventoryTransaction: async (partId, transactionId, options = {}) => {
            // verify required parameter 'partId' is not null or undefined
            assertParamExists('destroyInventoryTransaction', 'partId', partId);
            // verify required parameter 'transactionId' is not null or undefined
            assertParamExists('destroyInventoryTransaction', 'transactionId', transactionId);
            const localVarPath = `/parts/{part_id}/inventory/{transaction_id}`
                .replace(`{${"part_id"}}`, encodeURIComponent(String(partId)))
                .replace(`{${"transaction_id"}}`, encodeURIComponent(String(transactionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete a part
         * @param {number} id Part ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        destroyPart: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('destroyPart', 'id', id);
            const localVarPath = `/parts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete a part order
         * @param {number} id Part Order ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        destroyPartOrder: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('destroyPartOrder', 'id', id);
            const localVarPath = `/part-orders/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a part
         * @param {number} id Part ID
         * @param {boolean} [inventory] Include inventory levels
         * @param {boolean} [lastOrderSummary] Include last order summary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPart: async (id, inventory, lastOrderSummary, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPart', 'id', id);
            const localVarPath = `/parts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (inventory !== undefined) {
                localVarQueryParameter['inventory'] = inventory;
            }
            if (lastOrderSummary !== undefined) {
                localVarQueryParameter['last-order-summary'] = lastOrderSummary;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a part order
         * @param {number} id Part Order ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartOrder: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPartOrder', 'id', id);
            const localVarPath = `/part-orders/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Gets a paginated list of part orders
         * @param {number} [page] Page
         * @param {number} [partId] Part ID
         * @param {number} [perPage] Per Page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartOrders: async (page, partId, perPage, options = {}) => {
            const localVarPath = `/part-orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (partId !== undefined) {
                localVarQueryParameter['part_id'] = partId;
            }
            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Gets a paginated list of parts
         * @param {number} [page] Page
         * @param {boolean} [inventory] Include inventory levels
         * @param {boolean} [lastOrderSummary] Last order summary
         * @param {number} [perPage] Per Page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParts: async (page, inventory, lastOrderSummary, perPage, options = {}) => {
            const localVarPath = `/parts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (inventory !== undefined) {
                localVarQueryParameter['inventory'] = inventory;
            }
            if (lastOrderSummary !== undefined) {
                localVarQueryParameter['last-order-summary'] = lastOrderSummary;
            }
            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch a part
         * @param {number} id Part ID
         * @param {PatchPartPayload} patchPartPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchPart: async (id, patchPartPayload, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patchPart', 'id', id);
            // verify required parameter 'patchPartPayload' is not null or undefined
            assertParamExists('patchPart', 'patchPartPayload', patchPartPayload);
            const localVarPath = `/parts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(patchPartPayload, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch a part order
         * @param {number} id Part Order ID
         * @param {PatchPartOrderPayload} patchPartOrderPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchPartOrder: async (id, patchPartOrderPayload, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patchPartOrder', 'id', id);
            // verify required parameter 'patchPartOrderPayload' is not null or undefined
            assertParamExists('patchPartOrder', 'patchPartOrderPayload', patchPartOrderPayload);
            const localVarPath = `/part-orders/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(patchPartOrderPayload, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch a part order
         * @param {number} orderId Part Order ID
         * @param {PatchPartOrderFulfillmentPayload} patchPartOrderFulfillmentPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchPartOrderFulfillment: async (orderId, patchPartOrderFulfillmentPayload, options = {}) => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('patchPartOrderFulfillment', 'orderId', orderId);
            // verify required parameter 'patchPartOrderFulfillmentPayload' is not null or undefined
            assertParamExists('patchPartOrderFulfillment', 'patchPartOrderFulfillmentPayload', patchPartOrderFulfillmentPayload);
            const localVarPath = `/part-orders/{order_id}/fulfillment`
                .replace(`{${"order_id"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(patchPartOrderFulfillmentPayload, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Gets a paginated list of parts
         * @param {string} [query] Query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchParts: async (query, options = {}) => {
            const localVarPath = `/parts/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create an inventory transaction
         * @param {number} partId Part ID
         * @param {StoreInventoryTransactionRequest} storeInventoryTransactionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeInventoryTransaction: async (partId, storeInventoryTransactionRequest, options = {}) => {
            // verify required parameter 'partId' is not null or undefined
            assertParamExists('storeInventoryTransaction', 'partId', partId);
            // verify required parameter 'storeInventoryTransactionRequest' is not null or undefined
            assertParamExists('storeInventoryTransaction', 'storeInventoryTransactionRequest', storeInventoryTransactionRequest);
            const localVarPath = `/parts/{part_id}/inventory`
                .replace(`{${"part_id"}}`, encodeURIComponent(String(partId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(storeInventoryTransactionRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create a part
         * @param {StorePartPayload} storePartPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storePart: async (storePartPayload, options = {}) => {
            // verify required parameter 'storePartPayload' is not null or undefined
            assertParamExists('storePart', 'storePartPayload', storePartPayload);
            const localVarPath = `/parts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(storePartPayload, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create a part order
         * @param {StorePartOrderPayload} storePartOrderPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storePartOrder: async (storePartOrderPayload, options = {}) => {
            // verify required parameter 'storePartOrderPayload' is not null or undefined
            assertParamExists('storePartOrder', 'storePartOrderPayload', storePartOrderPayload);
            const localVarPath = `/part-orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(storePartOrderPayload, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * PartsApi - functional programming interface
 * @export
 */
export const PartsApiFp = function (configuration) {
    const localVarAxiosParamCreator = PartsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Delete an inventory transaction
         * @param {number} partId Part ID
         * @param {number} transactionId Transaction ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async destroyInventoryTransaction(partId, transactionId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.destroyInventoryTransaction(partId, transactionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PartsApi.destroyInventoryTransaction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Delete a part
         * @param {number} id Part ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async destroyPart(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.destroyPart(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PartsApi.destroyPart']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Delete a part order
         * @param {number} id Part Order ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async destroyPartOrder(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.destroyPartOrder(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PartsApi.destroyPartOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get a part
         * @param {number} id Part ID
         * @param {boolean} [inventory] Include inventory levels
         * @param {boolean} [lastOrderSummary] Include last order summary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPart(id, inventory, lastOrderSummary, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPart(id, inventory, lastOrderSummary, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PartsApi.getPart']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get a part order
         * @param {number} id Part Order ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPartOrder(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPartOrder(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PartsApi.getPartOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Gets a paginated list of part orders
         * @param {number} [page] Page
         * @param {number} [partId] Part ID
         * @param {number} [perPage] Per Page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPartOrders(page, partId, perPage, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPartOrders(page, partId, perPage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PartsApi.getPartOrders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Gets a paginated list of parts
         * @param {number} [page] Page
         * @param {boolean} [inventory] Include inventory levels
         * @param {boolean} [lastOrderSummary] Last order summary
         * @param {number} [perPage] Per Page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getParts(page, inventory, lastOrderSummary, perPage, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getParts(page, inventory, lastOrderSummary, perPage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PartsApi.getParts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Patch a part
         * @param {number} id Part ID
         * @param {PatchPartPayload} patchPartPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchPart(id, patchPartPayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchPart(id, patchPartPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PartsApi.patchPart']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Patch a part order
         * @param {number} id Part Order ID
         * @param {PatchPartOrderPayload} patchPartOrderPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchPartOrder(id, patchPartOrderPayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchPartOrder(id, patchPartOrderPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PartsApi.patchPartOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Patch a part order
         * @param {number} orderId Part Order ID
         * @param {PatchPartOrderFulfillmentPayload} patchPartOrderFulfillmentPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchPartOrderFulfillment(orderId, patchPartOrderFulfillmentPayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchPartOrderFulfillment(orderId, patchPartOrderFulfillmentPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PartsApi.patchPartOrderFulfillment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Gets a paginated list of parts
         * @param {string} [query] Query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchParts(query, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchParts(query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PartsApi.searchParts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Create an inventory transaction
         * @param {number} partId Part ID
         * @param {StoreInventoryTransactionRequest} storeInventoryTransactionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storeInventoryTransaction(partId, storeInventoryTransactionRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storeInventoryTransaction(partId, storeInventoryTransactionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PartsApi.storeInventoryTransaction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Create a part
         * @param {StorePartPayload} storePartPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storePart(storePartPayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storePart(storePartPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PartsApi.storePart']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Create a part order
         * @param {StorePartOrderPayload} storePartOrderPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storePartOrder(storePartOrderPayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storePartOrder(storePartOrderPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PartsApi.storePartOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * PartsApi - factory interface
 * @export
 */
export const PartsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = PartsApiFp(configuration);
    return {
        /**
         *
         * @summary Delete an inventory transaction
         * @param {number} partId Part ID
         * @param {number} transactionId Transaction ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        destroyInventoryTransaction(partId, transactionId, options) {
            return localVarFp.destroyInventoryTransaction(partId, transactionId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a part
         * @param {number} id Part ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        destroyPart(id, options) {
            return localVarFp.destroyPart(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a part order
         * @param {number} id Part Order ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        destroyPartOrder(id, options) {
            return localVarFp.destroyPartOrder(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a part
         * @param {number} id Part ID
         * @param {boolean} [inventory] Include inventory levels
         * @param {boolean} [lastOrderSummary] Include last order summary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPart(id, inventory, lastOrderSummary, options) {
            return localVarFp.getPart(id, inventory, lastOrderSummary, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a part order
         * @param {number} id Part Order ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartOrder(id, options) {
            return localVarFp.getPartOrder(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets a paginated list of part orders
         * @param {number} [page] Page
         * @param {number} [partId] Part ID
         * @param {number} [perPage] Per Page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartOrders(page, partId, perPage, options) {
            return localVarFp.getPartOrders(page, partId, perPage, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets a paginated list of parts
         * @param {number} [page] Page
         * @param {boolean} [inventory] Include inventory levels
         * @param {boolean} [lastOrderSummary] Last order summary
         * @param {number} [perPage] Per Page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParts(page, inventory, lastOrderSummary, perPage, options) {
            return localVarFp.getParts(page, inventory, lastOrderSummary, perPage, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch a part
         * @param {number} id Part ID
         * @param {PatchPartPayload} patchPartPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchPart(id, patchPartPayload, options) {
            return localVarFp.patchPart(id, patchPartPayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch a part order
         * @param {number} id Part Order ID
         * @param {PatchPartOrderPayload} patchPartOrderPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchPartOrder(id, patchPartOrderPayload, options) {
            return localVarFp.patchPartOrder(id, patchPartOrderPayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch a part order
         * @param {number} orderId Part Order ID
         * @param {PatchPartOrderFulfillmentPayload} patchPartOrderFulfillmentPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchPartOrderFulfillment(orderId, patchPartOrderFulfillmentPayload, options) {
            return localVarFp.patchPartOrderFulfillment(orderId, patchPartOrderFulfillmentPayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets a paginated list of parts
         * @param {string} [query] Query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchParts(query, options) {
            return localVarFp.searchParts(query, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create an inventory transaction
         * @param {number} partId Part ID
         * @param {StoreInventoryTransactionRequest} storeInventoryTransactionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeInventoryTransaction(partId, storeInventoryTransactionRequest, options) {
            return localVarFp.storeInventoryTransaction(partId, storeInventoryTransactionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create a part
         * @param {StorePartPayload} storePartPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storePart(storePartPayload, options) {
            return localVarFp.storePart(storePartPayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create a part order
         * @param {StorePartOrderPayload} storePartOrderPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storePartOrder(storePartOrderPayload, options) {
            return localVarFp.storePartOrder(storePartOrderPayload, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * PartsApi - object-oriented interface
 * @export
 * @class PartsApi
 * @extends {BaseAPI}
 */
export class PartsApi extends BaseAPI {
    /**
     *
     * @summary Delete an inventory transaction
     * @param {number} partId Part ID
     * @param {number} transactionId Transaction ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartsApi
     */
    destroyInventoryTransaction(partId, transactionId, options) {
        return PartsApiFp(this.configuration).destroyInventoryTransaction(partId, transactionId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete a part
     * @param {number} id Part ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartsApi
     */
    destroyPart(id, options) {
        return PartsApiFp(this.configuration).destroyPart(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete a part order
     * @param {number} id Part Order ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartsApi
     */
    destroyPartOrder(id, options) {
        return PartsApiFp(this.configuration).destroyPartOrder(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a part
     * @param {number} id Part ID
     * @param {boolean} [inventory] Include inventory levels
     * @param {boolean} [lastOrderSummary] Include last order summary
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartsApi
     */
    getPart(id, inventory, lastOrderSummary, options) {
        return PartsApiFp(this.configuration).getPart(id, inventory, lastOrderSummary, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a part order
     * @param {number} id Part Order ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartsApi
     */
    getPartOrder(id, options) {
        return PartsApiFp(this.configuration).getPartOrder(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets a paginated list of part orders
     * @param {number} [page] Page
     * @param {number} [partId] Part ID
     * @param {number} [perPage] Per Page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartsApi
     */
    getPartOrders(page, partId, perPage, options) {
        return PartsApiFp(this.configuration).getPartOrders(page, partId, perPage, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets a paginated list of parts
     * @param {number} [page] Page
     * @param {boolean} [inventory] Include inventory levels
     * @param {boolean} [lastOrderSummary] Last order summary
     * @param {number} [perPage] Per Page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartsApi
     */
    getParts(page, inventory, lastOrderSummary, perPage, options) {
        return PartsApiFp(this.configuration).getParts(page, inventory, lastOrderSummary, perPage, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch a part
     * @param {number} id Part ID
     * @param {PatchPartPayload} patchPartPayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartsApi
     */
    patchPart(id, patchPartPayload, options) {
        return PartsApiFp(this.configuration).patchPart(id, patchPartPayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch a part order
     * @param {number} id Part Order ID
     * @param {PatchPartOrderPayload} patchPartOrderPayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartsApi
     */
    patchPartOrder(id, patchPartOrderPayload, options) {
        return PartsApiFp(this.configuration).patchPartOrder(id, patchPartOrderPayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch a part order
     * @param {number} orderId Part Order ID
     * @param {PatchPartOrderFulfillmentPayload} patchPartOrderFulfillmentPayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartsApi
     */
    patchPartOrderFulfillment(orderId, patchPartOrderFulfillmentPayload, options) {
        return PartsApiFp(this.configuration).patchPartOrderFulfillment(orderId, patchPartOrderFulfillmentPayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets a paginated list of parts
     * @param {string} [query] Query
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartsApi
     */
    searchParts(query, options) {
        return PartsApiFp(this.configuration).searchParts(query, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create an inventory transaction
     * @param {number} partId Part ID
     * @param {StoreInventoryTransactionRequest} storeInventoryTransactionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartsApi
     */
    storeInventoryTransaction(partId, storeInventoryTransactionRequest, options) {
        return PartsApiFp(this.configuration).storeInventoryTransaction(partId, storeInventoryTransactionRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create a part
     * @param {StorePartPayload} storePartPayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartsApi
     */
    storePart(storePartPayload, options) {
        return PartsApiFp(this.configuration).storePart(storePartPayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create a part order
     * @param {StorePartOrderPayload} storePartOrderPayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartsApi
     */
    storePartOrder(storePartOrderPayload, options) {
        return PartsApiFp(this.configuration).storePartOrder(storePartOrderPayload, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * PreparationApi - axios parameter creator
 * @export
 */
export const PreparationApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Completed a preparation stage for a vehicle
         * @param {number} id Stock Listing ID
         * @param {CompletePrepStagePayload} completePrepStagePayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completePrepStage: async (id, completePrepStagePayload, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('completePrepStage', 'id', id);
            // verify required parameter 'completePrepStagePayload' is not null or undefined
            assertParamExists('completePrepStage', 'completePrepStagePayload', completePrepStagePayload);
            const localVarPath = `/preparation/stock-listings/{id}/complete-stage`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(completePrepStagePayload, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Gets a paginated list of parts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrepStageSummary: async (options = {}) => {
            const localVarPath = `/preparation/stage-summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Gets a paginated list of parts
         * @param {number} id Stock Listing ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStockListingPrepSummary: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getStockListingPrepSummary', 'id', id);
            const localVarPath = `/preparation/stock-listings/{id}/stage-summary`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Changes a vehicle preparation stage
         * @param {number} id Stock Listing ID
         * @param {ChangePrepStagePayload} changePrepStagePayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putPrepStage: async (id, changePrepStagePayload, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('putPrepStage', 'id', id);
            // verify required parameter 'changePrepStagePayload' is not null or undefined
            assertParamExists('putPrepStage', 'changePrepStagePayload', changePrepStagePayload);
            const localVarPath = `/preparation/stock-listings/{id}/enter-stage`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(changePrepStagePayload, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * PreparationApi - functional programming interface
 * @export
 */
export const PreparationApiFp = function (configuration) {
    const localVarAxiosParamCreator = PreparationApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Completed a preparation stage for a vehicle
         * @param {number} id Stock Listing ID
         * @param {CompletePrepStagePayload} completePrepStagePayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async completePrepStage(id, completePrepStagePayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.completePrepStage(id, completePrepStagePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PreparationApi.completePrepStage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Gets a paginated list of parts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPrepStageSummary(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPrepStageSummary(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PreparationApi.getPrepStageSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Gets a paginated list of parts
         * @param {number} id Stock Listing ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStockListingPrepSummary(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStockListingPrepSummary(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PreparationApi.getStockListingPrepSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Changes a vehicle preparation stage
         * @param {number} id Stock Listing ID
         * @param {ChangePrepStagePayload} changePrepStagePayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putPrepStage(id, changePrepStagePayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putPrepStage(id, changePrepStagePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PreparationApi.putPrepStage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * PreparationApi - factory interface
 * @export
 */
export const PreparationApiFactory = function (configuration, basePath, axios) {
    const localVarFp = PreparationApiFp(configuration);
    return {
        /**
         *
         * @summary Completed a preparation stage for a vehicle
         * @param {number} id Stock Listing ID
         * @param {CompletePrepStagePayload} completePrepStagePayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completePrepStage(id, completePrepStagePayload, options) {
            return localVarFp.completePrepStage(id, completePrepStagePayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets a paginated list of parts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrepStageSummary(options) {
            return localVarFp.getPrepStageSummary(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets a paginated list of parts
         * @param {number} id Stock Listing ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStockListingPrepSummary(id, options) {
            return localVarFp.getStockListingPrepSummary(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Changes a vehicle preparation stage
         * @param {number} id Stock Listing ID
         * @param {ChangePrepStagePayload} changePrepStagePayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putPrepStage(id, changePrepStagePayload, options) {
            return localVarFp.putPrepStage(id, changePrepStagePayload, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * PreparationApi - object-oriented interface
 * @export
 * @class PreparationApi
 * @extends {BaseAPI}
 */
export class PreparationApi extends BaseAPI {
    /**
     *
     * @summary Completed a preparation stage for a vehicle
     * @param {number} id Stock Listing ID
     * @param {CompletePrepStagePayload} completePrepStagePayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PreparationApi
     */
    completePrepStage(id, completePrepStagePayload, options) {
        return PreparationApiFp(this.configuration).completePrepStage(id, completePrepStagePayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets a paginated list of parts
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PreparationApi
     */
    getPrepStageSummary(options) {
        return PreparationApiFp(this.configuration).getPrepStageSummary(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets a paginated list of parts
     * @param {number} id Stock Listing ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PreparationApi
     */
    getStockListingPrepSummary(id, options) {
        return PreparationApiFp(this.configuration).getStockListingPrepSummary(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Changes a vehicle preparation stage
     * @param {number} id Stock Listing ID
     * @param {ChangePrepStagePayload} changePrepStagePayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PreparationApi
     */
    putPrepStage(id, changePrepStagePayload, options) {
        return PreparationApiFp(this.configuration).putPrepStage(id, changePrepStagePayload, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ProductsApi - axios parameter creator
 * @export
 */
export const ProductsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Show a product
         * @param {number} id ID of the product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProduct: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getProduct', 'id', id);
            const localVarPath = `/products/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Show the available products.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProducts: async (options = {}) => {
            const localVarPath = `/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Mark a purchased product as refunded.
         * @param {number} product ID of the quoted product to refund.
         * @param {RefundPurchasedProductPayload} refundPurchasedProductPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refundPurchasedProduct: async (product, refundPurchasedProductPayload, options = {}) => {
            // verify required parameter 'product' is not null or undefined
            assertParamExists('refundPurchasedProduct', 'product', product);
            // verify required parameter 'refundPurchasedProductPayload' is not null or undefined
            assertParamExists('refundPurchasedProduct', 'refundPurchasedProductPayload', refundPurchasedProductPayload);
            const localVarPath = `/purchased-products/{product}/refund`
                .replace(`{${"product"}}`, encodeURIComponent(String(product)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(refundPurchasedProductPayload, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create a product
         * @param {StoreProductRequest} storeProductRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeProduct: async (storeProductRequest, options = {}) => {
            // verify required parameter 'storeProductRequest' is not null or undefined
            assertParamExists('storeProduct', 'storeProductRequest', storeProductRequest);
            const localVarPath = `/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(storeProductRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Withdraw a product
         * @param {number} id ID of the product to withdraw
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        withdrawProduct: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('withdrawProduct', 'id', id);
            const localVarPath = `/products/{id}/withdraw`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ProductsApi - functional programming interface
 * @export
 */
export const ProductsApiFp = function (configuration) {
    const localVarAxiosParamCreator = ProductsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Show a product
         * @param {number} id ID of the product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProduct(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProduct(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.getProduct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Show the available products.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProducts(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProducts(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.getProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Mark a purchased product as refunded.
         * @param {number} product ID of the quoted product to refund.
         * @param {RefundPurchasedProductPayload} refundPurchasedProductPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refundPurchasedProduct(product, refundPurchasedProductPayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refundPurchasedProduct(product, refundPurchasedProductPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.refundPurchasedProduct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Create a product
         * @param {StoreProductRequest} storeProductRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storeProduct(storeProductRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storeProduct(storeProductRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.storeProduct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Withdraw a product
         * @param {number} id ID of the product to withdraw
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async withdrawProduct(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.withdrawProduct(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.withdrawProduct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * ProductsApi - factory interface
 * @export
 */
export const ProductsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ProductsApiFp(configuration);
    return {
        /**
         *
         * @summary Show a product
         * @param {number} id ID of the product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProduct(id, options) {
            return localVarFp.getProduct(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Show the available products.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProducts(options) {
            return localVarFp.getProducts(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Mark a purchased product as refunded.
         * @param {number} product ID of the quoted product to refund.
         * @param {RefundPurchasedProductPayload} refundPurchasedProductPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refundPurchasedProduct(product, refundPurchasedProductPayload, options) {
            return localVarFp.refundPurchasedProduct(product, refundPurchasedProductPayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create a product
         * @param {StoreProductRequest} storeProductRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeProduct(storeProductRequest, options) {
            return localVarFp.storeProduct(storeProductRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Withdraw a product
         * @param {number} id ID of the product to withdraw
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        withdrawProduct(id, options) {
            return localVarFp.withdrawProduct(id, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ProductsApi - object-oriented interface
 * @export
 * @class ProductsApi
 * @extends {BaseAPI}
 */
export class ProductsApi extends BaseAPI {
    /**
     *
     * @summary Show a product
     * @param {number} id ID of the product
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    getProduct(id, options) {
        return ProductsApiFp(this.configuration).getProduct(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Show the available products.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    getProducts(options) {
        return ProductsApiFp(this.configuration).getProducts(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Mark a purchased product as refunded.
     * @param {number} product ID of the quoted product to refund.
     * @param {RefundPurchasedProductPayload} refundPurchasedProductPayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    refundPurchasedProduct(product, refundPurchasedProductPayload, options) {
        return ProductsApiFp(this.configuration).refundPurchasedProduct(product, refundPurchasedProductPayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create a product
     * @param {StoreProductRequest} storeProductRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    storeProduct(storeProductRequest, options) {
        return ProductsApiFp(this.configuration).storeProduct(storeProductRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Withdraw a product
     * @param {number} id ID of the product to withdraw
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    withdrawProduct(id, options) {
        return ProductsApiFp(this.configuration).withdrawProduct(id, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ReportTemplatesApi - axios parameter creator
 * @export
 */
export const ReportTemplatesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Delete report template.
         * @param {number} templateId ID of the report template to be deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteReportTemplate: async (templateId, options = {}) => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('deleteReportTemplate', 'templateId', templateId);
            const localVarPath = `/report-templates/{template_id}`
                .replace(`{${"template_id"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Show report templates.
         * @param {number} templateId ID of the report template to be shown
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findReportTemplate: async (templateId, options = {}) => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('findReportTemplate', 'templateId', templateId);
            const localVarPath = `/report_templates/{template_id}`
                .replace(`{${"template_id"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary List templates.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listReportTemplates: async (options = {}) => {
            const localVarPath = `/report-templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Store a report template.
         * @param {ReportTemplate} reportTemplate Save report template request body.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeReportTemplate: async (reportTemplate, options = {}) => {
            // verify required parameter 'reportTemplate' is not null or undefined
            assertParamExists('storeReportTemplate', 'reportTemplate', reportTemplate);
            const localVarPath = `/report-templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(reportTemplate, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update a report template.
         * @param {number} templateId ID of the report template to be completed
         * @param {ReportTemplate} reportTemplate Save report template request body.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReportTemplate: async (templateId, reportTemplate, options = {}) => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('updateReportTemplate', 'templateId', templateId);
            // verify required parameter 'reportTemplate' is not null or undefined
            assertParamExists('updateReportTemplate', 'reportTemplate', reportTemplate);
            const localVarPath = `/report-templates/{template_id}`
                .replace(`{${"template_id"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(reportTemplate, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ReportTemplatesApi - functional programming interface
 * @export
 */
export const ReportTemplatesApiFp = function (configuration) {
    const localVarAxiosParamCreator = ReportTemplatesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Delete report template.
         * @param {number} templateId ID of the report template to be deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteReportTemplate(templateId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteReportTemplate(templateId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportTemplatesApi.deleteReportTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Show report templates.
         * @param {number} templateId ID of the report template to be shown
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findReportTemplate(templateId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findReportTemplate(templateId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportTemplatesApi.findReportTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary List templates.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listReportTemplates(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listReportTemplates(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportTemplatesApi.listReportTemplates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Store a report template.
         * @param {ReportTemplate} reportTemplate Save report template request body.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storeReportTemplate(reportTemplate, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storeReportTemplate(reportTemplate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportTemplatesApi.storeReportTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Update a report template.
         * @param {number} templateId ID of the report template to be completed
         * @param {ReportTemplate} reportTemplate Save report template request body.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateReportTemplate(templateId, reportTemplate, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateReportTemplate(templateId, reportTemplate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportTemplatesApi.updateReportTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * ReportTemplatesApi - factory interface
 * @export
 */
export const ReportTemplatesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ReportTemplatesApiFp(configuration);
    return {
        /**
         *
         * @summary Delete report template.
         * @param {number} templateId ID of the report template to be deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteReportTemplate(templateId, options) {
            return localVarFp.deleteReportTemplate(templateId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Show report templates.
         * @param {number} templateId ID of the report template to be shown
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findReportTemplate(templateId, options) {
            return localVarFp.findReportTemplate(templateId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List templates.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listReportTemplates(options) {
            return localVarFp.listReportTemplates(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Store a report template.
         * @param {ReportTemplate} reportTemplate Save report template request body.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeReportTemplate(reportTemplate, options) {
            return localVarFp.storeReportTemplate(reportTemplate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update a report template.
         * @param {number} templateId ID of the report template to be completed
         * @param {ReportTemplate} reportTemplate Save report template request body.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReportTemplate(templateId, reportTemplate, options) {
            return localVarFp.updateReportTemplate(templateId, reportTemplate, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ReportTemplatesApi - object-oriented interface
 * @export
 * @class ReportTemplatesApi
 * @extends {BaseAPI}
 */
export class ReportTemplatesApi extends BaseAPI {
    /**
     *
     * @summary Delete report template.
     * @param {number} templateId ID of the report template to be deleted
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportTemplatesApi
     */
    deleteReportTemplate(templateId, options) {
        return ReportTemplatesApiFp(this.configuration).deleteReportTemplate(templateId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Show report templates.
     * @param {number} templateId ID of the report template to be shown
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportTemplatesApi
     */
    findReportTemplate(templateId, options) {
        return ReportTemplatesApiFp(this.configuration).findReportTemplate(templateId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List templates.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportTemplatesApi
     */
    listReportTemplates(options) {
        return ReportTemplatesApiFp(this.configuration).listReportTemplates(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Store a report template.
     * @param {ReportTemplate} reportTemplate Save report template request body.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportTemplatesApi
     */
    storeReportTemplate(reportTemplate, options) {
        return ReportTemplatesApiFp(this.configuration).storeReportTemplate(reportTemplate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update a report template.
     * @param {number} templateId ID of the report template to be completed
     * @param {ReportTemplate} reportTemplate Save report template request body.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportTemplatesApi
     */
    updateReportTemplate(templateId, reportTemplate, options) {
        return ReportTemplatesApiFp(this.configuration).updateReportTemplate(templateId, reportTemplate, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ReportingApi - axios parameter creator
 * @export
 */
export const ReportingApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Download the completed background report.
         * @param {string} report The ID of the background report
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadBackgroundReport: async (report, options = {}) => {
            // verify required parameter 'report' is not null or undefined
            assertParamExists('downloadBackgroundReport', 'report', report);
            const localVarPath = `/background-reports/{report}/download`
                .replace(`{${"report"}}`, encodeURIComponent(String(report)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get the status of a background report.
         * @param {string} report The ID of the background report
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBackgroundReportStatus: async (report, options = {}) => {
            // verify required parameter 'report' is not null or undefined
            assertParamExists('getBackgroundReportStatus', 'report', report);
            const localVarPath = `/background-reports/{report}/status`
                .replace(`{${"report"}}`, encodeURIComponent(String(report)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ReportingApi - functional programming interface
 * @export
 */
export const ReportingApiFp = function (configuration) {
    const localVarAxiosParamCreator = ReportingApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Download the completed background report.
         * @param {string} report The ID of the background report
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadBackgroundReport(report, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadBackgroundReport(report, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportingApi.downloadBackgroundReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get the status of a background report.
         * @param {string} report The ID of the background report
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBackgroundReportStatus(report, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBackgroundReportStatus(report, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportingApi.getBackgroundReportStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * ReportingApi - factory interface
 * @export
 */
export const ReportingApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ReportingApiFp(configuration);
    return {
        /**
         *
         * @summary Download the completed background report.
         * @param {string} report The ID of the background report
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadBackgroundReport(report, options) {
            return localVarFp.downloadBackgroundReport(report, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get the status of a background report.
         * @param {string} report The ID of the background report
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBackgroundReportStatus(report, options) {
            return localVarFp.getBackgroundReportStatus(report, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ReportingApi - object-oriented interface
 * @export
 * @class ReportingApi
 * @extends {BaseAPI}
 */
export class ReportingApi extends BaseAPI {
    /**
     *
     * @summary Download the completed background report.
     * @param {string} report The ID of the background report
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportingApi
     */
    downloadBackgroundReport(report, options) {
        return ReportingApiFp(this.configuration).downloadBackgroundReport(report, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get the status of a background report.
     * @param {string} report The ID of the background report
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportingApi
     */
    getBackgroundReportStatus(report, options) {
        return ReportingApiFp(this.configuration).getBackgroundReportStatus(report, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * SettingsApi - axios parameter creator
 * @export
 */
export const SettingsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {JobCleanUpPayload} jobCleanUpPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cleanUpJobs: async (jobCleanUpPayload, options = {}) => {
            // verify required parameter 'jobCleanUpPayload' is not null or undefined
            assertParamExists('cleanUpJobs', 'jobCleanUpPayload', jobCleanUpPayload);
            const localVarPath = `/settings/job-clean-up`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(jobCleanUpPayload, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete a house cost
         * @param {string} handle Handle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        destroyHouseCost: async (handle, options = {}) => {
            // verify required parameter 'handle' is not null or undefined
            assertParamExists('destroyHouseCost', 'handle', handle);
            const localVarPath = `/settings/house-costs/{handle}`
                .replace(`{${"handle"}}`, encodeURIComponent(String(handle)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete a sales team\'s handover booking settings
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        destroySalesTeamHandoverBooking: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('destroySalesTeamHandoverBooking', 'id', id);
            const localVarPath = `/settings/sales/teams/{id}/handover-booking`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get accounting settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountingSettings: async (options = {}) => {
            const localVarPath = `/settings/accounting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get advertising settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdvertisingSettings: async (options = {}) => {
            const localVarPath = `/settings/advertising`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Show the companies sales volume targets
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanySalesVolumeTargets: async (options = {}) => {
            const localVarPath = `/settings/sales-volume-targets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get CRM settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCrmSettings: async (options = {}) => {
            const localVarPath = `/settings/crm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a house cost
         * @param {string} handle Handle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHouseCost: async (handle, options = {}) => {
            // verify required parameter 'handle' is not null or undefined
            assertParamExists('getHouseCost', 'handle', handle);
            const localVarPath = `/settings/house-costs/{handle}`
                .replace(`{${"handle"}}`, encodeURIComponent(String(handle)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary List house costs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHouseCosts: async (options = {}) => {
            const localVarPath = `/settings/house-costs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get job labour rate defaults
         * @param {JobLabourRateType} type Type of labour rate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobLabourRates: async (type, options = {}) => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('getJobLabourRates', 'type', type);
            const localVarPath = `/settings/jobs/labour-rates/{type}`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get job settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobSettings: async (options = {}) => {
            const localVarPath = `/settings/jobs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a summary of the outstanding jobs grouped by template type.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobsTypesToCleanUp: async (options = {}) => {
            const localVarPath = `/settings/job-clean-up`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Show the mot job card automation status.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMotJobCardAutomationStatus: async (options = {}) => {
            const localVarPath = `/settings/stock/mot-job-card-automation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get sales settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalesSettings: async (options = {}) => {
            const localVarPath = `/settings/sales`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a sales team\'s handover booking settings
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalesTeamHandoverBooking: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSalesTeamHandoverBooking', 'id', id);
            const localVarPath = `/settings/sales/teams/{id}/handover-booking`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get stock settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStockSettings: async (options = {}) => {
            const localVarPath = `/settings/stock`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch accounting settings
         * @param {AccountingSettingsPayload} accountingSettingsPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAccountingSettings: async (accountingSettingsPayload, options = {}) => {
            // verify required parameter 'accountingSettingsPayload' is not null or undefined
            assertParamExists('patchAccountingSettings', 'accountingSettingsPayload', accountingSettingsPayload);
            const localVarPath = `/settings/accounting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(accountingSettingsPayload, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch advertising settings
         * @param {PatchAdvertisingSettingsPayload} patchAdvertisingSettingsPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAdvertisingSettings: async (patchAdvertisingSettingsPayload, options = {}) => {
            // verify required parameter 'patchAdvertisingSettingsPayload' is not null or undefined
            assertParamExists('patchAdvertisingSettings', 'patchAdvertisingSettingsPayload', patchAdvertisingSettingsPayload);
            const localVarPath = `/settings/advertising`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(patchAdvertisingSettingsPayload, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch the companies sales volume targets
         * @param {SalesVolumeTargetConfigurationPayload} [salesVolumeTargetConfigurationPayload] Patch Company Sales Volume Targets Request Body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCompanySalesVolumeTargets: async (salesVolumeTargetConfigurationPayload, options = {}) => {
            const localVarPath = `/settings/sales-volume-targets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(salesVolumeTargetConfigurationPayload, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch CRM settings
         * @param {CrmSettingsPayload} crmSettingsPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCrmSettings: async (crmSettingsPayload, options = {}) => {
            // verify required parameter 'crmSettingsPayload' is not null or undefined
            assertParamExists('patchCrmSettings', 'crmSettingsPayload', crmSettingsPayload);
            const localVarPath = `/settings/crm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(crmSettingsPayload, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch a house cost
         * @param {string} handle Handle
         * @param {PatchHouseCostPayload} patchHouseCostPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchHouseCost: async (handle, patchHouseCostPayload, options = {}) => {
            // verify required parameter 'handle' is not null or undefined
            assertParamExists('patchHouseCost', 'handle', handle);
            // verify required parameter 'patchHouseCostPayload' is not null or undefined
            assertParamExists('patchHouseCost', 'patchHouseCostPayload', patchHouseCostPayload);
            const localVarPath = `/settings/house-costs/{handle}`
                .replace(`{${"handle"}}`, encodeURIComponent(String(handle)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(patchHouseCostPayload, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch job settings
         * @param {JobSettingsPayload} jobSettingsPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchJobSettings: async (jobSettingsPayload, options = {}) => {
            // verify required parameter 'jobSettingsPayload' is not null or undefined
            assertParamExists('patchJobSettings', 'jobSettingsPayload', jobSettingsPayload);
            const localVarPath = `/settings/jobs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(jobSettingsPayload, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch the status of the MOT automation
         * @param {PatchMotJobCardAutomationStatusRequest} patchMotJobCardAutomationStatusRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchMotJobCardAutomationStatus: async (patchMotJobCardAutomationStatusRequest, options = {}) => {
            // verify required parameter 'patchMotJobCardAutomationStatusRequest' is not null or undefined
            assertParamExists('patchMotJobCardAutomationStatus', 'patchMotJobCardAutomationStatusRequest', patchMotJobCardAutomationStatusRequest);
            const localVarPath = `/settings/stock/mot-job-card-automation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(patchMotJobCardAutomationStatusRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch sales settings
         * @param {SalesSettingsPayload} salesSettingsPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchSalesSettings: async (salesSettingsPayload, options = {}) => {
            // verify required parameter 'salesSettingsPayload' is not null or undefined
            assertParamExists('patchSalesSettings', 'salesSettingsPayload', salesSettingsPayload);
            const localVarPath = `/settings/sales`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(salesSettingsPayload, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch stock settings
         * @param {StockSettingsPayload} stockSettingsPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchStockSettings: async (stockSettingsPayload, options = {}) => {
            // verify required parameter 'stockSettingsPayload' is not null or undefined
            assertParamExists('patchStockSettings', 'stockSettingsPayload', stockSettingsPayload);
            const localVarPath = `/settings/stock`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(stockSettingsPayload, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch job labour rate defaults
         * @param {JobLabourRateType} type Type of labour rate
         * @param {PutJobLabourRatesPayload} putJobLabourRatesPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putJobLabourRates: async (type, putJobLabourRatesPayload, options = {}) => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('putJobLabourRates', 'type', type);
            // verify required parameter 'putJobLabourRatesPayload' is not null or undefined
            assertParamExists('putJobLabourRates', 'putJobLabourRatesPayload', putJobLabourRatesPayload);
            const localVarPath = `/settings/jobs/labour-rates/{type}`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(putJobLabourRatesPayload, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Reset (disconnect) the account\'s WhatsApp integration.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetWhatsApp: async (options = {}) => {
            const localVarPath = `/settings/crm/whatsapp/reset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create a house cost
         * @param {StoreHouseCostPayload} storeHouseCostPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeHouseCost: async (storeHouseCostPayload, options = {}) => {
            // verify required parameter 'storeHouseCostPayload' is not null or undefined
            assertParamExists('storeHouseCost', 'storeHouseCostPayload', storeHouseCostPayload);
            const localVarPath = `/settings/house-costs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(storeHouseCostPayload, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Store a sales team\'s handover booking settings
         * @param {number} id
         * @param {SalesTeamHandoverBookingPayload} salesTeamHandoverBookingPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeSalesTeamHandoverBooking: async (id, salesTeamHandoverBookingPayload, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('storeSalesTeamHandoverBooking', 'id', id);
            // verify required parameter 'salesTeamHandoverBookingPayload' is not null or undefined
            assertParamExists('storeSalesTeamHandoverBooking', 'salesTeamHandoverBookingPayload', salesTeamHandoverBookingPayload);
            const localVarPath = `/settings/sales/teams/{id}/handover-booking`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(salesTeamHandoverBookingPayload, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * SettingsApi - functional programming interface
 * @export
 */
export const SettingsApiFp = function (configuration) {
    const localVarAxiosParamCreator = SettingsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {JobCleanUpPayload} jobCleanUpPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cleanUpJobs(jobCleanUpPayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cleanUpJobs(jobCleanUpPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.cleanUpJobs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Delete a house cost
         * @param {string} handle Handle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async destroyHouseCost(handle, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.destroyHouseCost(handle, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.destroyHouseCost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Delete a sales team\'s handover booking settings
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async destroySalesTeamHandoverBooking(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.destroySalesTeamHandoverBooking(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.destroySalesTeamHandoverBooking']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get accounting settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountingSettings(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountingSettings(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.getAccountingSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get advertising settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdvertisingSettings(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdvertisingSettings(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.getAdvertisingSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Show the companies sales volume targets
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompanySalesVolumeTargets(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompanySalesVolumeTargets(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.getCompanySalesVolumeTargets']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get CRM settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCrmSettings(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCrmSettings(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.getCrmSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get a house cost
         * @param {string} handle Handle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHouseCost(handle, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHouseCost(handle, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.getHouseCost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary List house costs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHouseCosts(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHouseCosts(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.getHouseCosts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get job labour rate defaults
         * @param {JobLabourRateType} type Type of labour rate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getJobLabourRates(type, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getJobLabourRates(type, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.getJobLabourRates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get job settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getJobSettings(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getJobSettings(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.getJobSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get a summary of the outstanding jobs grouped by template type.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getJobsTypesToCleanUp(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getJobsTypesToCleanUp(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.getJobsTypesToCleanUp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Show the mot job card automation status.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMotJobCardAutomationStatus(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMotJobCardAutomationStatus(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.getMotJobCardAutomationStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get sales settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSalesSettings(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSalesSettings(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.getSalesSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get a sales team\'s handover booking settings
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSalesTeamHandoverBooking(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSalesTeamHandoverBooking(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.getSalesTeamHandoverBooking']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get stock settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStockSettings(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStockSettings(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.getStockSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Patch accounting settings
         * @param {AccountingSettingsPayload} accountingSettingsPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchAccountingSettings(accountingSettingsPayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchAccountingSettings(accountingSettingsPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.patchAccountingSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Patch advertising settings
         * @param {PatchAdvertisingSettingsPayload} patchAdvertisingSettingsPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchAdvertisingSettings(patchAdvertisingSettingsPayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchAdvertisingSettings(patchAdvertisingSettingsPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.patchAdvertisingSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Patch the companies sales volume targets
         * @param {SalesVolumeTargetConfigurationPayload} [salesVolumeTargetConfigurationPayload] Patch Company Sales Volume Targets Request Body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchCompanySalesVolumeTargets(salesVolumeTargetConfigurationPayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchCompanySalesVolumeTargets(salesVolumeTargetConfigurationPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.patchCompanySalesVolumeTargets']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Patch CRM settings
         * @param {CrmSettingsPayload} crmSettingsPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchCrmSettings(crmSettingsPayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchCrmSettings(crmSettingsPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.patchCrmSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Patch a house cost
         * @param {string} handle Handle
         * @param {PatchHouseCostPayload} patchHouseCostPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchHouseCost(handle, patchHouseCostPayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchHouseCost(handle, patchHouseCostPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.patchHouseCost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Patch job settings
         * @param {JobSettingsPayload} jobSettingsPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchJobSettings(jobSettingsPayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchJobSettings(jobSettingsPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.patchJobSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Patch the status of the MOT automation
         * @param {PatchMotJobCardAutomationStatusRequest} patchMotJobCardAutomationStatusRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchMotJobCardAutomationStatus(patchMotJobCardAutomationStatusRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchMotJobCardAutomationStatus(patchMotJobCardAutomationStatusRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.patchMotJobCardAutomationStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Patch sales settings
         * @param {SalesSettingsPayload} salesSettingsPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchSalesSettings(salesSettingsPayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchSalesSettings(salesSettingsPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.patchSalesSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Patch stock settings
         * @param {StockSettingsPayload} stockSettingsPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchStockSettings(stockSettingsPayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchStockSettings(stockSettingsPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.patchStockSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Patch job labour rate defaults
         * @param {JobLabourRateType} type Type of labour rate
         * @param {PutJobLabourRatesPayload} putJobLabourRatesPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putJobLabourRates(type, putJobLabourRatesPayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putJobLabourRates(type, putJobLabourRatesPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.putJobLabourRates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Reset (disconnect) the account\'s WhatsApp integration.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetWhatsApp(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetWhatsApp(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.resetWhatsApp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Create a house cost
         * @param {StoreHouseCostPayload} storeHouseCostPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storeHouseCost(storeHouseCostPayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storeHouseCost(storeHouseCostPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.storeHouseCost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Store a sales team\'s handover booking settings
         * @param {number} id
         * @param {SalesTeamHandoverBookingPayload} salesTeamHandoverBookingPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storeSalesTeamHandoverBooking(id, salesTeamHandoverBookingPayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storeSalesTeamHandoverBooking(id, salesTeamHandoverBookingPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.storeSalesTeamHandoverBooking']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * SettingsApi - factory interface
 * @export
 */
export const SettingsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SettingsApiFp(configuration);
    return {
        /**
         *
         * @param {JobCleanUpPayload} jobCleanUpPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cleanUpJobs(jobCleanUpPayload, options) {
            return localVarFp.cleanUpJobs(jobCleanUpPayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a house cost
         * @param {string} handle Handle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        destroyHouseCost(handle, options) {
            return localVarFp.destroyHouseCost(handle, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a sales team\'s handover booking settings
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        destroySalesTeamHandoverBooking(id, options) {
            return localVarFp.destroySalesTeamHandoverBooking(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get accounting settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountingSettings(options) {
            return localVarFp.getAccountingSettings(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get advertising settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdvertisingSettings(options) {
            return localVarFp.getAdvertisingSettings(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Show the companies sales volume targets
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanySalesVolumeTargets(options) {
            return localVarFp.getCompanySalesVolumeTargets(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get CRM settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCrmSettings(options) {
            return localVarFp.getCrmSettings(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a house cost
         * @param {string} handle Handle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHouseCost(handle, options) {
            return localVarFp.getHouseCost(handle, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List house costs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHouseCosts(options) {
            return localVarFp.getHouseCosts(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get job labour rate defaults
         * @param {JobLabourRateType} type Type of labour rate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobLabourRates(type, options) {
            return localVarFp.getJobLabourRates(type, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get job settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobSettings(options) {
            return localVarFp.getJobSettings(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a summary of the outstanding jobs grouped by template type.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobsTypesToCleanUp(options) {
            return localVarFp.getJobsTypesToCleanUp(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Show the mot job card automation status.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMotJobCardAutomationStatus(options) {
            return localVarFp.getMotJobCardAutomationStatus(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get sales settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalesSettings(options) {
            return localVarFp.getSalesSettings(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a sales team\'s handover booking settings
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSalesTeamHandoverBooking(id, options) {
            return localVarFp.getSalesTeamHandoverBooking(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get stock settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStockSettings(options) {
            return localVarFp.getStockSettings(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch accounting settings
         * @param {AccountingSettingsPayload} accountingSettingsPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAccountingSettings(accountingSettingsPayload, options) {
            return localVarFp.patchAccountingSettings(accountingSettingsPayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch advertising settings
         * @param {PatchAdvertisingSettingsPayload} patchAdvertisingSettingsPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAdvertisingSettings(patchAdvertisingSettingsPayload, options) {
            return localVarFp.patchAdvertisingSettings(patchAdvertisingSettingsPayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch the companies sales volume targets
         * @param {SalesVolumeTargetConfigurationPayload} [salesVolumeTargetConfigurationPayload] Patch Company Sales Volume Targets Request Body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCompanySalesVolumeTargets(salesVolumeTargetConfigurationPayload, options) {
            return localVarFp.patchCompanySalesVolumeTargets(salesVolumeTargetConfigurationPayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch CRM settings
         * @param {CrmSettingsPayload} crmSettingsPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCrmSettings(crmSettingsPayload, options) {
            return localVarFp.patchCrmSettings(crmSettingsPayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch a house cost
         * @param {string} handle Handle
         * @param {PatchHouseCostPayload} patchHouseCostPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchHouseCost(handle, patchHouseCostPayload, options) {
            return localVarFp.patchHouseCost(handle, patchHouseCostPayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch job settings
         * @param {JobSettingsPayload} jobSettingsPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchJobSettings(jobSettingsPayload, options) {
            return localVarFp.patchJobSettings(jobSettingsPayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch the status of the MOT automation
         * @param {PatchMotJobCardAutomationStatusRequest} patchMotJobCardAutomationStatusRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchMotJobCardAutomationStatus(patchMotJobCardAutomationStatusRequest, options) {
            return localVarFp.patchMotJobCardAutomationStatus(patchMotJobCardAutomationStatusRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch sales settings
         * @param {SalesSettingsPayload} salesSettingsPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchSalesSettings(salesSettingsPayload, options) {
            return localVarFp.patchSalesSettings(salesSettingsPayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch stock settings
         * @param {StockSettingsPayload} stockSettingsPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchStockSettings(stockSettingsPayload, options) {
            return localVarFp.patchStockSettings(stockSettingsPayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch job labour rate defaults
         * @param {JobLabourRateType} type Type of labour rate
         * @param {PutJobLabourRatesPayload} putJobLabourRatesPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putJobLabourRates(type, putJobLabourRatesPayload, options) {
            return localVarFp.putJobLabourRates(type, putJobLabourRatesPayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Reset (disconnect) the account\'s WhatsApp integration.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetWhatsApp(options) {
            return localVarFp.resetWhatsApp(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create a house cost
         * @param {StoreHouseCostPayload} storeHouseCostPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeHouseCost(storeHouseCostPayload, options) {
            return localVarFp.storeHouseCost(storeHouseCostPayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Store a sales team\'s handover booking settings
         * @param {number} id
         * @param {SalesTeamHandoverBookingPayload} salesTeamHandoverBookingPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeSalesTeamHandoverBooking(id, salesTeamHandoverBookingPayload, options) {
            return localVarFp.storeSalesTeamHandoverBooking(id, salesTeamHandoverBookingPayload, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * SettingsApi - object-oriented interface
 * @export
 * @class SettingsApi
 * @extends {BaseAPI}
 */
export class SettingsApi extends BaseAPI {
    /**
     *
     * @param {JobCleanUpPayload} jobCleanUpPayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    cleanUpJobs(jobCleanUpPayload, options) {
        return SettingsApiFp(this.configuration).cleanUpJobs(jobCleanUpPayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete a house cost
     * @param {string} handle Handle
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    destroyHouseCost(handle, options) {
        return SettingsApiFp(this.configuration).destroyHouseCost(handle, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete a sales team\'s handover booking settings
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    destroySalesTeamHandoverBooking(id, options) {
        return SettingsApiFp(this.configuration).destroySalesTeamHandoverBooking(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get accounting settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    getAccountingSettings(options) {
        return SettingsApiFp(this.configuration).getAccountingSettings(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get advertising settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    getAdvertisingSettings(options) {
        return SettingsApiFp(this.configuration).getAdvertisingSettings(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Show the companies sales volume targets
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    getCompanySalesVolumeTargets(options) {
        return SettingsApiFp(this.configuration).getCompanySalesVolumeTargets(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get CRM settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    getCrmSettings(options) {
        return SettingsApiFp(this.configuration).getCrmSettings(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a house cost
     * @param {string} handle Handle
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    getHouseCost(handle, options) {
        return SettingsApiFp(this.configuration).getHouseCost(handle, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List house costs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    getHouseCosts(options) {
        return SettingsApiFp(this.configuration).getHouseCosts(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get job labour rate defaults
     * @param {JobLabourRateType} type Type of labour rate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    getJobLabourRates(type, options) {
        return SettingsApiFp(this.configuration).getJobLabourRates(type, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get job settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    getJobSettings(options) {
        return SettingsApiFp(this.configuration).getJobSettings(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a summary of the outstanding jobs grouped by template type.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    getJobsTypesToCleanUp(options) {
        return SettingsApiFp(this.configuration).getJobsTypesToCleanUp(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Show the mot job card automation status.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    getMotJobCardAutomationStatus(options) {
        return SettingsApiFp(this.configuration).getMotJobCardAutomationStatus(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get sales settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    getSalesSettings(options) {
        return SettingsApiFp(this.configuration).getSalesSettings(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a sales team\'s handover booking settings
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    getSalesTeamHandoverBooking(id, options) {
        return SettingsApiFp(this.configuration).getSalesTeamHandoverBooking(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get stock settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    getStockSettings(options) {
        return SettingsApiFp(this.configuration).getStockSettings(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch accounting settings
     * @param {AccountingSettingsPayload} accountingSettingsPayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    patchAccountingSettings(accountingSettingsPayload, options) {
        return SettingsApiFp(this.configuration).patchAccountingSettings(accountingSettingsPayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch advertising settings
     * @param {PatchAdvertisingSettingsPayload} patchAdvertisingSettingsPayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    patchAdvertisingSettings(patchAdvertisingSettingsPayload, options) {
        return SettingsApiFp(this.configuration).patchAdvertisingSettings(patchAdvertisingSettingsPayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch the companies sales volume targets
     * @param {SalesVolumeTargetConfigurationPayload} [salesVolumeTargetConfigurationPayload] Patch Company Sales Volume Targets Request Body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    patchCompanySalesVolumeTargets(salesVolumeTargetConfigurationPayload, options) {
        return SettingsApiFp(this.configuration).patchCompanySalesVolumeTargets(salesVolumeTargetConfigurationPayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch CRM settings
     * @param {CrmSettingsPayload} crmSettingsPayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    patchCrmSettings(crmSettingsPayload, options) {
        return SettingsApiFp(this.configuration).patchCrmSettings(crmSettingsPayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch a house cost
     * @param {string} handle Handle
     * @param {PatchHouseCostPayload} patchHouseCostPayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    patchHouseCost(handle, patchHouseCostPayload, options) {
        return SettingsApiFp(this.configuration).patchHouseCost(handle, patchHouseCostPayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch job settings
     * @param {JobSettingsPayload} jobSettingsPayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    patchJobSettings(jobSettingsPayload, options) {
        return SettingsApiFp(this.configuration).patchJobSettings(jobSettingsPayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch the status of the MOT automation
     * @param {PatchMotJobCardAutomationStatusRequest} patchMotJobCardAutomationStatusRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    patchMotJobCardAutomationStatus(patchMotJobCardAutomationStatusRequest, options) {
        return SettingsApiFp(this.configuration).patchMotJobCardAutomationStatus(patchMotJobCardAutomationStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch sales settings
     * @param {SalesSettingsPayload} salesSettingsPayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    patchSalesSettings(salesSettingsPayload, options) {
        return SettingsApiFp(this.configuration).patchSalesSettings(salesSettingsPayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch stock settings
     * @param {StockSettingsPayload} stockSettingsPayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    patchStockSettings(stockSettingsPayload, options) {
        return SettingsApiFp(this.configuration).patchStockSettings(stockSettingsPayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch job labour rate defaults
     * @param {JobLabourRateType} type Type of labour rate
     * @param {PutJobLabourRatesPayload} putJobLabourRatesPayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    putJobLabourRates(type, putJobLabourRatesPayload, options) {
        return SettingsApiFp(this.configuration).putJobLabourRates(type, putJobLabourRatesPayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Reset (disconnect) the account\'s WhatsApp integration.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    resetWhatsApp(options) {
        return SettingsApiFp(this.configuration).resetWhatsApp(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create a house cost
     * @param {StoreHouseCostPayload} storeHouseCostPayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    storeHouseCost(storeHouseCostPayload, options) {
        return SettingsApiFp(this.configuration).storeHouseCost(storeHouseCostPayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Store a sales team\'s handover booking settings
     * @param {number} id
     * @param {SalesTeamHandoverBookingPayload} salesTeamHandoverBookingPayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    storeSalesTeamHandoverBooking(id, salesTeamHandoverBookingPayload, options) {
        return SettingsApiFp(this.configuration).storeSalesTeamHandoverBooking(id, salesTeamHandoverBookingPayload, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * StockListApi - axios parameter creator
 * @export
 */
export const StockListApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Generate the default advertising copy from the configured templates located within the accounts configuration file.
         * @param {number} stockListing ID of stock listing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchDefaultAdvertCopy: async (stockListing, options = {}) => {
            // verify required parameter 'stockListing' is not null or undefined
            assertParamExists('fetchDefaultAdvertCopy', 'stockListing', stockListing);
            const localVarPath = `/stock-list/{stock_listing}/default-advert-copy`
                .replace(`{${"stock_listing"}}`, encodeURIComponent(String(stockListing)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get missing image aspect suggestions as well as existing image label suggestions
         * @param {number} stockId ID of stock listing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchStockListingCoDriverImageSuggestions: async (stockId, options = {}) => {
            // verify required parameter 'stockId' is not null or undefined
            assertParamExists('fetchStockListingCoDriverImageSuggestions', 'stockId', stockId);
            const localVarPath = `/co-driver-image-suggestions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (stockId !== undefined) {
                localVarQueryParameter['stock_id'] = stockId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Generate advertising copy via AutoTrader Co-Driver API
         * @param {number} stockId ID of stock listing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchStockListingCoPilotCopy: async (stockId, options = {}) => {
            // verify required parameter 'stockId' is not null or undefined
            assertParamExists('fetchStockListingCoPilotCopy', 'stockId', stockId);
            const localVarPath = `/co-driver-description`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (stockId !== undefined) {
                localVarQueryParameter['stock_id'] = stockId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Generate advertising copy via GPT3
         * @param {number} stockListing ID of stock listing
         * @param {GPTAdvertisingIntroductionPayload} [gPTAdvertisingIntroductionPayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchStockListingGptCopy: async (stockListing, gPTAdvertisingIntroductionPayload, options = {}) => {
            // verify required parameter 'stockListing' is not null or undefined
            assertParamExists('fetchStockListingGptCopy', 'stockListing', stockListing);
            const localVarPath = `/stock-list/{stock_listing}/fetch-gpt-advert-copy`
                .replace(`{${"stock_listing"}}`, encodeURIComponent(String(stockListing)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(gPTAdvertisingIntroductionPayload, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a list of settlements that can be contra entered against a finance settlement.
         * @param {number} id Stock Listing ID
         * @param {number} [retailPrice] Retail Price
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPricingInsights: async (id, retailPrice, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPricingInsights', 'id', id);
            const localVarPath = `/stock-list/{id}/pricing-insights`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (retailPrice !== undefined) {
                localVarQueryParameter['retail_price'] = retailPrice;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Gets a paginated list of vehicles.
         * @param {boolean} [excludeSold] Exclude Sold
         * @param {boolean} [excludeTrade] Exclude Trade
         * @param {boolean} [media] Media
         * @param {boolean} [specifications] All Specifications
         * @param {boolean} [standardSpecifications] Standard Specifications
         * @param {boolean} [optionalSpecifications] Optional Specifications
         * @param {boolean} [technicalSpecifications] Technical Specifications
         * @param {boolean} [purchase] Purchase
         * @param {boolean} [sale] Sale
         * @param {boolean} [financials] Financials
         * @param {boolean} [pricingHistory] Pricing History
         * @param {boolean} [advertising] Advertising
         * @param {boolean} [autotrader] AutoTrader
         * @param {boolean} [autotraderMetrics] AutoTrader Metrics
         * @param {boolean} [leadSummary] Lead Summary
         * @param {boolean} [jobSummary] Job Summary
         * @param {boolean} [inspectionSummary] Inspection Summary
         * @param {number} [perPage] Per Page
         * @param {number} [page] Page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStockList: async (excludeSold, excludeTrade, media, specifications, standardSpecifications, optionalSpecifications, technicalSpecifications, purchase, sale, financials, pricingHistory, advertising, autotrader, autotraderMetrics, leadSummary, jobSummary, inspectionSummary, perPage, page, options = {}) => {
            const localVarPath = `/stock-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (excludeSold !== undefined) {
                localVarQueryParameter['exclude_sold'] = excludeSold;
            }
            if (excludeTrade !== undefined) {
                localVarQueryParameter['exclude_trade'] = excludeTrade;
            }
            if (media !== undefined) {
                localVarQueryParameter['media'] = media;
            }
            if (specifications !== undefined) {
                localVarQueryParameter['specifications'] = specifications;
            }
            if (standardSpecifications !== undefined) {
                localVarQueryParameter['standard_specifications'] = standardSpecifications;
            }
            if (optionalSpecifications !== undefined) {
                localVarQueryParameter['optional_specifications'] = optionalSpecifications;
            }
            if (technicalSpecifications !== undefined) {
                localVarQueryParameter['technical_specifications'] = technicalSpecifications;
            }
            if (purchase !== undefined) {
                localVarQueryParameter['purchase'] = purchase;
            }
            if (sale !== undefined) {
                localVarQueryParameter['sale'] = sale;
            }
            if (financials !== undefined) {
                localVarQueryParameter['financials'] = financials;
            }
            if (pricingHistory !== undefined) {
                localVarQueryParameter['pricing_history'] = pricingHistory;
            }
            if (advertising !== undefined) {
                localVarQueryParameter['advertising'] = advertising;
            }
            if (autotrader !== undefined) {
                localVarQueryParameter['autotrader'] = autotrader;
            }
            if (autotraderMetrics !== undefined) {
                localVarQueryParameter['autotrader_metrics'] = autotraderMetrics;
            }
            if (leadSummary !== undefined) {
                localVarQueryParameter['lead_summary'] = leadSummary;
            }
            if (jobSummary !== undefined) {
                localVarQueryParameter['job_summary'] = jobSummary;
            }
            if (inspectionSummary !== undefined) {
                localVarQueryParameter['inspection_summary'] = inspectionSummary;
            }
            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get the stock list feed for the given authentication token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStockListFeed: async (options = {}) => {
            const localVarPath = `/stock-list/feed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get the stock list feed facets for the given authentication token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStockListFeedFacets: async (options = {}) => {
            const localVarPath = `/stock-list/feed/facets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get the finance representative for the stock list feed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStockListFeedFinanceRepresentative: async (options = {}) => {
            const localVarPath = `/stock-list/feed/finance-representative`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Show the feed stock listing.
         * @param {number} stockListing ID of stock listing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStockListFeedListing: async (stockListing, options = {}) => {
            // verify required parameter 'stockListing' is not null or undefined
            assertParamExists('getStockListFeedListing', 'stockListing', stockListing);
            const localVarPath = `/stock-list/feed/{stock_listing}`
                .replace(`{${"stock_listing"}}`, encodeURIComponent(String(stockListing)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a stock listing.
         * @param {number} stockListing ID
         * @param {boolean} [media] Media
         * @param {boolean} [specifications] All Specifications
         * @param {boolean} [standardSpecifications] Standard Specifications
         * @param {boolean} [optionalSpecifications] Optional Specifications
         * @param {boolean} [technicalSpecifications] Technical Specifications
         * @param {boolean} [purchase] Purchase
         * @param {boolean} [sale] Sale
         * @param {boolean} [financials] Financials
         * @param {boolean} [pricingHistory] Pricing History
         * @param {boolean} [advertising] Advertising
         * @param {boolean} [autotrader] AutoTrader
         * @param {boolean} [autotraderMetrics] AutoTrader Metrics
         * @param {boolean} [leadSummary] Lead Summary
         * @param {boolean} [jobSummary] Job Summary
         * @param {boolean} [inspectionSummary] Inspection Summary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStockListing: async (stockListing, media, specifications, standardSpecifications, optionalSpecifications, technicalSpecifications, purchase, sale, financials, pricingHistory, advertising, autotrader, autotraderMetrics, leadSummary, jobSummary, inspectionSummary, options = {}) => {
            // verify required parameter 'stockListing' is not null or undefined
            assertParamExists('getStockListing', 'stockListing', stockListing);
            const localVarPath = `/stock-list/{stock_listing}`
                .replace(`{${"stock_listing"}}`, encodeURIComponent(String(stockListing)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (media !== undefined) {
                localVarQueryParameter['media'] = media;
            }
            if (specifications !== undefined) {
                localVarQueryParameter['specifications'] = specifications;
            }
            if (standardSpecifications !== undefined) {
                localVarQueryParameter['standard_specifications'] = standardSpecifications;
            }
            if (optionalSpecifications !== undefined) {
                localVarQueryParameter['optional_specifications'] = optionalSpecifications;
            }
            if (technicalSpecifications !== undefined) {
                localVarQueryParameter['technical_specifications'] = technicalSpecifications;
            }
            if (purchase !== undefined) {
                localVarQueryParameter['purchase'] = purchase;
            }
            if (sale !== undefined) {
                localVarQueryParameter['sale'] = sale;
            }
            if (financials !== undefined) {
                localVarQueryParameter['financials'] = financials;
            }
            if (pricingHistory !== undefined) {
                localVarQueryParameter['pricing_history'] = pricingHistory;
            }
            if (advertising !== undefined) {
                localVarQueryParameter['advertising'] = advertising;
            }
            if (autotrader !== undefined) {
                localVarQueryParameter['autotrader'] = autotrader;
            }
            if (autotraderMetrics !== undefined) {
                localVarQueryParameter['autotrader_metrics'] = autotraderMetrics;
            }
            if (leadSummary !== undefined) {
                localVarQueryParameter['lead_summary'] = leadSummary;
            }
            if (jobSummary !== undefined) {
                localVarQueryParameter['job_summary'] = jobSummary;
            }
            if (inspectionSummary !== undefined) {
                localVarQueryParameter['inspection_summary'] = inspectionSummary;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get active products (policies) for a stock listing.
         * @param {number} stockListing ID of the stock listing to get products for for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStockListingActiveProducts: async (stockListing, options = {}) => {
            // verify required parameter 'stockListing' is not null or undefined
            assertParamExists('getStockListingActiveProducts', 'stockListing', stockListing);
            const localVarPath = `/stock-list/{stock_listing}/active-products`
                .replace(`{${"stock_listing"}}`, encodeURIComponent(String(stockListing)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Gets a paginated list of vehicles.
         * @param {number} stockListing Stock Listing
         * @param {number} [perPage] Per Page
         * @param {number} [page] Page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStockListingPricingHistory: async (stockListing, perPage, page, options = {}) => {
            // verify required parameter 'stockListing' is not null or undefined
            assertParamExists('getStockListingPricingHistory', 'stockListing', stockListing);
            const localVarPath = `/stock-list/{stock_listing}/pricing-history`
                .replace(`{${"stock_listing"}}`, encodeURIComponent(String(stockListing)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a product quote for a stock listing.
         * @param {number} stockListing ID of the stock listing to quote for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStockListingProductQuote: async (stockListing, options = {}) => {
            // verify required parameter 'stockListing' is not null or undefined
            assertParamExists('getStockListingProductQuote', 'stockListing', stockListing);
            const localVarPath = `/stock-list/{stock_listing}/available-products`
                .replace(`{${"stock_listing"}}`, encodeURIComponent(String(stockListing)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch a stock listing.
         * @param {number} stockListing ID of stock listing
         * @param {PatchStockListingRequestBody} [patchStockListingRequestBody] Patch Stock Listing Request Body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchStockListing: async (stockListing, patchStockListingRequestBody, options = {}) => {
            // verify required parameter 'stockListing' is not null or undefined
            assertParamExists('patchStockListing', 'stockListing', stockListing);
            const localVarPath = `/stock-list/{stock_listing}`
                .replace(`{${"stock_listing"}}`, encodeURIComponent(String(stockListing)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(patchStockListingRequestBody, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Remove sale or return status from the stock listing.
         * @param {number} stockListing ID of stock listing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeSaleOrReturn: async (stockListing, options = {}) => {
            // verify required parameter 'stockListing' is not null or undefined
            assertParamExists('removeSaleOrReturn', 'stockListing', stockListing);
            const localVarPath = `/stock-list/{stock_listing}/sale-or-return`
                .replace(`{${"stock_listing"}}`, encodeURIComponent(String(stockListing)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Remove a vehicles status as written off
         * @param {number} stockListing Stock Listing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreWrittenOffStockListing: async (stockListing, options = {}) => {
            // verify required parameter 'stockListing' is not null or undefined
            assertParamExists('restoreWrittenOffStockListing', 'stockListing', stockListing);
            const localVarPath = `/stock-list/{stock_listing}/restore-written-off`
                .replace(`{${"stock_listing"}}`, encodeURIComponent(String(stockListing)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Searches the stock list using the given terms and returns a paginated list of stock listings.
         * @param {string} [term] Terms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchStockList: async (term, options = {}) => {
            const localVarPath = `/stock-list/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Set sale or return status of the stock listing.
         * @param {number} stockListing ID of stock listing
         * @param {SetSaleOrReturnRequest} [setSaleOrReturnRequest] Sale or return request body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setSaleOrReturn: async (stockListing, setSaleOrReturnRequest, options = {}) => {
            // verify required parameter 'stockListing' is not null or undefined
            assertParamExists('setSaleOrReturn', 'stockListing', stockListing);
            const localVarPath = `/stock-list/{stock_listing}/sale-or-return`
                .replace(`{${"stock_listing"}}`, encodeURIComponent(String(stockListing)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(setSaleOrReturnRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Mark a vehicle as written off
         * @param {number} stockListing Stock Listing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        writeOffStockListing: async (stockListing, options = {}) => {
            // verify required parameter 'stockListing' is not null or undefined
            assertParamExists('writeOffStockListing', 'stockListing', stockListing);
            const localVarPath = `/stock-list/{stock_listing}/write-off`
                .replace(`{${"stock_listing"}}`, encodeURIComponent(String(stockListing)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * StockListApi - functional programming interface
 * @export
 */
export const StockListApiFp = function (configuration) {
    const localVarAxiosParamCreator = StockListApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Generate the default advertising copy from the configured templates located within the accounts configuration file.
         * @param {number} stockListing ID of stock listing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchDefaultAdvertCopy(stockListing, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchDefaultAdvertCopy(stockListing, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StockListApi.fetchDefaultAdvertCopy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get missing image aspect suggestions as well as existing image label suggestions
         * @param {number} stockId ID of stock listing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchStockListingCoDriverImageSuggestions(stockId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchStockListingCoDriverImageSuggestions(stockId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StockListApi.fetchStockListingCoDriverImageSuggestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Generate advertising copy via AutoTrader Co-Driver API
         * @param {number} stockId ID of stock listing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchStockListingCoPilotCopy(stockId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchStockListingCoPilotCopy(stockId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StockListApi.fetchStockListingCoPilotCopy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Generate advertising copy via GPT3
         * @param {number} stockListing ID of stock listing
         * @param {GPTAdvertisingIntroductionPayload} [gPTAdvertisingIntroductionPayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchStockListingGptCopy(stockListing, gPTAdvertisingIntroductionPayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchStockListingGptCopy(stockListing, gPTAdvertisingIntroductionPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StockListApi.fetchStockListingGptCopy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get a list of settlements that can be contra entered against a finance settlement.
         * @param {number} id Stock Listing ID
         * @param {number} [retailPrice] Retail Price
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPricingInsights(id, retailPrice, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPricingInsights(id, retailPrice, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StockListApi.getPricingInsights']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Gets a paginated list of vehicles.
         * @param {boolean} [excludeSold] Exclude Sold
         * @param {boolean} [excludeTrade] Exclude Trade
         * @param {boolean} [media] Media
         * @param {boolean} [specifications] All Specifications
         * @param {boolean} [standardSpecifications] Standard Specifications
         * @param {boolean} [optionalSpecifications] Optional Specifications
         * @param {boolean} [technicalSpecifications] Technical Specifications
         * @param {boolean} [purchase] Purchase
         * @param {boolean} [sale] Sale
         * @param {boolean} [financials] Financials
         * @param {boolean} [pricingHistory] Pricing History
         * @param {boolean} [advertising] Advertising
         * @param {boolean} [autotrader] AutoTrader
         * @param {boolean} [autotraderMetrics] AutoTrader Metrics
         * @param {boolean} [leadSummary] Lead Summary
         * @param {boolean} [jobSummary] Job Summary
         * @param {boolean} [inspectionSummary] Inspection Summary
         * @param {number} [perPage] Per Page
         * @param {number} [page] Page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStockList(excludeSold, excludeTrade, media, specifications, standardSpecifications, optionalSpecifications, technicalSpecifications, purchase, sale, financials, pricingHistory, advertising, autotrader, autotraderMetrics, leadSummary, jobSummary, inspectionSummary, perPage, page, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStockList(excludeSold, excludeTrade, media, specifications, standardSpecifications, optionalSpecifications, technicalSpecifications, purchase, sale, financials, pricingHistory, advertising, autotrader, autotraderMetrics, leadSummary, jobSummary, inspectionSummary, perPage, page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StockListApi.getStockList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get the stock list feed for the given authentication token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStockListFeed(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStockListFeed(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StockListApi.getStockListFeed']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get the stock list feed facets for the given authentication token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStockListFeedFacets(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStockListFeedFacets(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StockListApi.getStockListFeedFacets']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get the finance representative for the stock list feed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStockListFeedFinanceRepresentative(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStockListFeedFinanceRepresentative(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StockListApi.getStockListFeedFinanceRepresentative']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Show the feed stock listing.
         * @param {number} stockListing ID of stock listing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStockListFeedListing(stockListing, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStockListFeedListing(stockListing, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StockListApi.getStockListFeedListing']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get a stock listing.
         * @param {number} stockListing ID
         * @param {boolean} [media] Media
         * @param {boolean} [specifications] All Specifications
         * @param {boolean} [standardSpecifications] Standard Specifications
         * @param {boolean} [optionalSpecifications] Optional Specifications
         * @param {boolean} [technicalSpecifications] Technical Specifications
         * @param {boolean} [purchase] Purchase
         * @param {boolean} [sale] Sale
         * @param {boolean} [financials] Financials
         * @param {boolean} [pricingHistory] Pricing History
         * @param {boolean} [advertising] Advertising
         * @param {boolean} [autotrader] AutoTrader
         * @param {boolean} [autotraderMetrics] AutoTrader Metrics
         * @param {boolean} [leadSummary] Lead Summary
         * @param {boolean} [jobSummary] Job Summary
         * @param {boolean} [inspectionSummary] Inspection Summary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStockListing(stockListing, media, specifications, standardSpecifications, optionalSpecifications, technicalSpecifications, purchase, sale, financials, pricingHistory, advertising, autotrader, autotraderMetrics, leadSummary, jobSummary, inspectionSummary, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStockListing(stockListing, media, specifications, standardSpecifications, optionalSpecifications, technicalSpecifications, purchase, sale, financials, pricingHistory, advertising, autotrader, autotraderMetrics, leadSummary, jobSummary, inspectionSummary, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StockListApi.getStockListing']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get active products (policies) for a stock listing.
         * @param {number} stockListing ID of the stock listing to get products for for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStockListingActiveProducts(stockListing, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStockListingActiveProducts(stockListing, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StockListApi.getStockListingActiveProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Gets a paginated list of vehicles.
         * @param {number} stockListing Stock Listing
         * @param {number} [perPage] Per Page
         * @param {number} [page] Page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStockListingPricingHistory(stockListing, perPage, page, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStockListingPricingHistory(stockListing, perPage, page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StockListApi.getStockListingPricingHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get a product quote for a stock listing.
         * @param {number} stockListing ID of the stock listing to quote for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStockListingProductQuote(stockListing, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStockListingProductQuote(stockListing, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StockListApi.getStockListingProductQuote']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Patch a stock listing.
         * @param {number} stockListing ID of stock listing
         * @param {PatchStockListingRequestBody} [patchStockListingRequestBody] Patch Stock Listing Request Body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchStockListing(stockListing, patchStockListingRequestBody, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchStockListing(stockListing, patchStockListingRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StockListApi.patchStockListing']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Remove sale or return status from the stock listing.
         * @param {number} stockListing ID of stock listing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeSaleOrReturn(stockListing, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeSaleOrReturn(stockListing, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StockListApi.removeSaleOrReturn']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Remove a vehicles status as written off
         * @param {number} stockListing Stock Listing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restoreWrittenOffStockListing(stockListing, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restoreWrittenOffStockListing(stockListing, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StockListApi.restoreWrittenOffStockListing']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Searches the stock list using the given terms and returns a paginated list of stock listings.
         * @param {string} [term] Terms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchStockList(term, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchStockList(term, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StockListApi.searchStockList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Set sale or return status of the stock listing.
         * @param {number} stockListing ID of stock listing
         * @param {SetSaleOrReturnRequest} [setSaleOrReturnRequest] Sale or return request body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setSaleOrReturn(stockListing, setSaleOrReturnRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setSaleOrReturn(stockListing, setSaleOrReturnRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StockListApi.setSaleOrReturn']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Mark a vehicle as written off
         * @param {number} stockListing Stock Listing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async writeOffStockListing(stockListing, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.writeOffStockListing(stockListing, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StockListApi.writeOffStockListing']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * StockListApi - factory interface
 * @export
 */
export const StockListApiFactory = function (configuration, basePath, axios) {
    const localVarFp = StockListApiFp(configuration);
    return {
        /**
         *
         * @summary Generate the default advertising copy from the configured templates located within the accounts configuration file.
         * @param {number} stockListing ID of stock listing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchDefaultAdvertCopy(stockListing, options) {
            return localVarFp.fetchDefaultAdvertCopy(stockListing, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get missing image aspect suggestions as well as existing image label suggestions
         * @param {number} stockId ID of stock listing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchStockListingCoDriverImageSuggestions(stockId, options) {
            return localVarFp.fetchStockListingCoDriverImageSuggestions(stockId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Generate advertising copy via AutoTrader Co-Driver API
         * @param {number} stockId ID of stock listing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchStockListingCoPilotCopy(stockId, options) {
            return localVarFp.fetchStockListingCoPilotCopy(stockId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Generate advertising copy via GPT3
         * @param {number} stockListing ID of stock listing
         * @param {GPTAdvertisingIntroductionPayload} [gPTAdvertisingIntroductionPayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchStockListingGptCopy(stockListing, gPTAdvertisingIntroductionPayload, options) {
            return localVarFp.fetchStockListingGptCopy(stockListing, gPTAdvertisingIntroductionPayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a list of settlements that can be contra entered against a finance settlement.
         * @param {number} id Stock Listing ID
         * @param {number} [retailPrice] Retail Price
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPricingInsights(id, retailPrice, options) {
            return localVarFp.getPricingInsights(id, retailPrice, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets a paginated list of vehicles.
         * @param {boolean} [excludeSold] Exclude Sold
         * @param {boolean} [excludeTrade] Exclude Trade
         * @param {boolean} [media] Media
         * @param {boolean} [specifications] All Specifications
         * @param {boolean} [standardSpecifications] Standard Specifications
         * @param {boolean} [optionalSpecifications] Optional Specifications
         * @param {boolean} [technicalSpecifications] Technical Specifications
         * @param {boolean} [purchase] Purchase
         * @param {boolean} [sale] Sale
         * @param {boolean} [financials] Financials
         * @param {boolean} [pricingHistory] Pricing History
         * @param {boolean} [advertising] Advertising
         * @param {boolean} [autotrader] AutoTrader
         * @param {boolean} [autotraderMetrics] AutoTrader Metrics
         * @param {boolean} [leadSummary] Lead Summary
         * @param {boolean} [jobSummary] Job Summary
         * @param {boolean} [inspectionSummary] Inspection Summary
         * @param {number} [perPage] Per Page
         * @param {number} [page] Page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStockList(excludeSold, excludeTrade, media, specifications, standardSpecifications, optionalSpecifications, technicalSpecifications, purchase, sale, financials, pricingHistory, advertising, autotrader, autotraderMetrics, leadSummary, jobSummary, inspectionSummary, perPage, page, options) {
            return localVarFp.getStockList(excludeSold, excludeTrade, media, specifications, standardSpecifications, optionalSpecifications, technicalSpecifications, purchase, sale, financials, pricingHistory, advertising, autotrader, autotraderMetrics, leadSummary, jobSummary, inspectionSummary, perPage, page, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get the stock list feed for the given authentication token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStockListFeed(options) {
            return localVarFp.getStockListFeed(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get the stock list feed facets for the given authentication token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStockListFeedFacets(options) {
            return localVarFp.getStockListFeedFacets(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get the finance representative for the stock list feed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStockListFeedFinanceRepresentative(options) {
            return localVarFp.getStockListFeedFinanceRepresentative(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Show the feed stock listing.
         * @param {number} stockListing ID of stock listing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStockListFeedListing(stockListing, options) {
            return localVarFp.getStockListFeedListing(stockListing, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a stock listing.
         * @param {number} stockListing ID
         * @param {boolean} [media] Media
         * @param {boolean} [specifications] All Specifications
         * @param {boolean} [standardSpecifications] Standard Specifications
         * @param {boolean} [optionalSpecifications] Optional Specifications
         * @param {boolean} [technicalSpecifications] Technical Specifications
         * @param {boolean} [purchase] Purchase
         * @param {boolean} [sale] Sale
         * @param {boolean} [financials] Financials
         * @param {boolean} [pricingHistory] Pricing History
         * @param {boolean} [advertising] Advertising
         * @param {boolean} [autotrader] AutoTrader
         * @param {boolean} [autotraderMetrics] AutoTrader Metrics
         * @param {boolean} [leadSummary] Lead Summary
         * @param {boolean} [jobSummary] Job Summary
         * @param {boolean} [inspectionSummary] Inspection Summary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStockListing(stockListing, media, specifications, standardSpecifications, optionalSpecifications, technicalSpecifications, purchase, sale, financials, pricingHistory, advertising, autotrader, autotraderMetrics, leadSummary, jobSummary, inspectionSummary, options) {
            return localVarFp.getStockListing(stockListing, media, specifications, standardSpecifications, optionalSpecifications, technicalSpecifications, purchase, sale, financials, pricingHistory, advertising, autotrader, autotraderMetrics, leadSummary, jobSummary, inspectionSummary, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get active products (policies) for a stock listing.
         * @param {number} stockListing ID of the stock listing to get products for for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStockListingActiveProducts(stockListing, options) {
            return localVarFp.getStockListingActiveProducts(stockListing, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets a paginated list of vehicles.
         * @param {number} stockListing Stock Listing
         * @param {number} [perPage] Per Page
         * @param {number} [page] Page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStockListingPricingHistory(stockListing, perPage, page, options) {
            return localVarFp.getStockListingPricingHistory(stockListing, perPage, page, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a product quote for a stock listing.
         * @param {number} stockListing ID of the stock listing to quote for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStockListingProductQuote(stockListing, options) {
            return localVarFp.getStockListingProductQuote(stockListing, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch a stock listing.
         * @param {number} stockListing ID of stock listing
         * @param {PatchStockListingRequestBody} [patchStockListingRequestBody] Patch Stock Listing Request Body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchStockListing(stockListing, patchStockListingRequestBody, options) {
            return localVarFp.patchStockListing(stockListing, patchStockListingRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Remove sale or return status from the stock listing.
         * @param {number} stockListing ID of stock listing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeSaleOrReturn(stockListing, options) {
            return localVarFp.removeSaleOrReturn(stockListing, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Remove a vehicles status as written off
         * @param {number} stockListing Stock Listing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreWrittenOffStockListing(stockListing, options) {
            return localVarFp.restoreWrittenOffStockListing(stockListing, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Searches the stock list using the given terms and returns a paginated list of stock listings.
         * @param {string} [term] Terms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchStockList(term, options) {
            return localVarFp.searchStockList(term, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Set sale or return status of the stock listing.
         * @param {number} stockListing ID of stock listing
         * @param {SetSaleOrReturnRequest} [setSaleOrReturnRequest] Sale or return request body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setSaleOrReturn(stockListing, setSaleOrReturnRequest, options) {
            return localVarFp.setSaleOrReturn(stockListing, setSaleOrReturnRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Mark a vehicle as written off
         * @param {number} stockListing Stock Listing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        writeOffStockListing(stockListing, options) {
            return localVarFp.writeOffStockListing(stockListing, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * StockListApi - object-oriented interface
 * @export
 * @class StockListApi
 * @extends {BaseAPI}
 */
export class StockListApi extends BaseAPI {
    /**
     *
     * @summary Generate the default advertising copy from the configured templates located within the accounts configuration file.
     * @param {number} stockListing ID of stock listing
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockListApi
     */
    fetchDefaultAdvertCopy(stockListing, options) {
        return StockListApiFp(this.configuration).fetchDefaultAdvertCopy(stockListing, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get missing image aspect suggestions as well as existing image label suggestions
     * @param {number} stockId ID of stock listing
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockListApi
     */
    fetchStockListingCoDriverImageSuggestions(stockId, options) {
        return StockListApiFp(this.configuration).fetchStockListingCoDriverImageSuggestions(stockId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Generate advertising copy via AutoTrader Co-Driver API
     * @param {number} stockId ID of stock listing
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockListApi
     */
    fetchStockListingCoPilotCopy(stockId, options) {
        return StockListApiFp(this.configuration).fetchStockListingCoPilotCopy(stockId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Generate advertising copy via GPT3
     * @param {number} stockListing ID of stock listing
     * @param {GPTAdvertisingIntroductionPayload} [gPTAdvertisingIntroductionPayload]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockListApi
     */
    fetchStockListingGptCopy(stockListing, gPTAdvertisingIntroductionPayload, options) {
        return StockListApiFp(this.configuration).fetchStockListingGptCopy(stockListing, gPTAdvertisingIntroductionPayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a list of settlements that can be contra entered against a finance settlement.
     * @param {number} id Stock Listing ID
     * @param {number} [retailPrice] Retail Price
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockListApi
     */
    getPricingInsights(id, retailPrice, options) {
        return StockListApiFp(this.configuration).getPricingInsights(id, retailPrice, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets a paginated list of vehicles.
     * @param {boolean} [excludeSold] Exclude Sold
     * @param {boolean} [excludeTrade] Exclude Trade
     * @param {boolean} [media] Media
     * @param {boolean} [specifications] All Specifications
     * @param {boolean} [standardSpecifications] Standard Specifications
     * @param {boolean} [optionalSpecifications] Optional Specifications
     * @param {boolean} [technicalSpecifications] Technical Specifications
     * @param {boolean} [purchase] Purchase
     * @param {boolean} [sale] Sale
     * @param {boolean} [financials] Financials
     * @param {boolean} [pricingHistory] Pricing History
     * @param {boolean} [advertising] Advertising
     * @param {boolean} [autotrader] AutoTrader
     * @param {boolean} [autotraderMetrics] AutoTrader Metrics
     * @param {boolean} [leadSummary] Lead Summary
     * @param {boolean} [jobSummary] Job Summary
     * @param {boolean} [inspectionSummary] Inspection Summary
     * @param {number} [perPage] Per Page
     * @param {number} [page] Page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockListApi
     */
    getStockList(excludeSold, excludeTrade, media, specifications, standardSpecifications, optionalSpecifications, technicalSpecifications, purchase, sale, financials, pricingHistory, advertising, autotrader, autotraderMetrics, leadSummary, jobSummary, inspectionSummary, perPage, page, options) {
        return StockListApiFp(this.configuration).getStockList(excludeSold, excludeTrade, media, specifications, standardSpecifications, optionalSpecifications, technicalSpecifications, purchase, sale, financials, pricingHistory, advertising, autotrader, autotraderMetrics, leadSummary, jobSummary, inspectionSummary, perPage, page, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get the stock list feed for the given authentication token.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockListApi
     */
    getStockListFeed(options) {
        return StockListApiFp(this.configuration).getStockListFeed(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get the stock list feed facets for the given authentication token.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockListApi
     */
    getStockListFeedFacets(options) {
        return StockListApiFp(this.configuration).getStockListFeedFacets(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get the finance representative for the stock list feed.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockListApi
     */
    getStockListFeedFinanceRepresentative(options) {
        return StockListApiFp(this.configuration).getStockListFeedFinanceRepresentative(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Show the feed stock listing.
     * @param {number} stockListing ID of stock listing
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockListApi
     */
    getStockListFeedListing(stockListing, options) {
        return StockListApiFp(this.configuration).getStockListFeedListing(stockListing, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a stock listing.
     * @param {number} stockListing ID
     * @param {boolean} [media] Media
     * @param {boolean} [specifications] All Specifications
     * @param {boolean} [standardSpecifications] Standard Specifications
     * @param {boolean} [optionalSpecifications] Optional Specifications
     * @param {boolean} [technicalSpecifications] Technical Specifications
     * @param {boolean} [purchase] Purchase
     * @param {boolean} [sale] Sale
     * @param {boolean} [financials] Financials
     * @param {boolean} [pricingHistory] Pricing History
     * @param {boolean} [advertising] Advertising
     * @param {boolean} [autotrader] AutoTrader
     * @param {boolean} [autotraderMetrics] AutoTrader Metrics
     * @param {boolean} [leadSummary] Lead Summary
     * @param {boolean} [jobSummary] Job Summary
     * @param {boolean} [inspectionSummary] Inspection Summary
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockListApi
     */
    getStockListing(stockListing, media, specifications, standardSpecifications, optionalSpecifications, technicalSpecifications, purchase, sale, financials, pricingHistory, advertising, autotrader, autotraderMetrics, leadSummary, jobSummary, inspectionSummary, options) {
        return StockListApiFp(this.configuration).getStockListing(stockListing, media, specifications, standardSpecifications, optionalSpecifications, technicalSpecifications, purchase, sale, financials, pricingHistory, advertising, autotrader, autotraderMetrics, leadSummary, jobSummary, inspectionSummary, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get active products (policies) for a stock listing.
     * @param {number} stockListing ID of the stock listing to get products for for.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockListApi
     */
    getStockListingActiveProducts(stockListing, options) {
        return StockListApiFp(this.configuration).getStockListingActiveProducts(stockListing, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets a paginated list of vehicles.
     * @param {number} stockListing Stock Listing
     * @param {number} [perPage] Per Page
     * @param {number} [page] Page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockListApi
     */
    getStockListingPricingHistory(stockListing, perPage, page, options) {
        return StockListApiFp(this.configuration).getStockListingPricingHistory(stockListing, perPage, page, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a product quote for a stock listing.
     * @param {number} stockListing ID of the stock listing to quote for.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockListApi
     */
    getStockListingProductQuote(stockListing, options) {
        return StockListApiFp(this.configuration).getStockListingProductQuote(stockListing, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch a stock listing.
     * @param {number} stockListing ID of stock listing
     * @param {PatchStockListingRequestBody} [patchStockListingRequestBody] Patch Stock Listing Request Body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockListApi
     */
    patchStockListing(stockListing, patchStockListingRequestBody, options) {
        return StockListApiFp(this.configuration).patchStockListing(stockListing, patchStockListingRequestBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Remove sale or return status from the stock listing.
     * @param {number} stockListing ID of stock listing
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockListApi
     */
    removeSaleOrReturn(stockListing, options) {
        return StockListApiFp(this.configuration).removeSaleOrReturn(stockListing, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Remove a vehicles status as written off
     * @param {number} stockListing Stock Listing
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockListApi
     */
    restoreWrittenOffStockListing(stockListing, options) {
        return StockListApiFp(this.configuration).restoreWrittenOffStockListing(stockListing, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Searches the stock list using the given terms and returns a paginated list of stock listings.
     * @param {string} [term] Terms
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockListApi
     */
    searchStockList(term, options) {
        return StockListApiFp(this.configuration).searchStockList(term, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Set sale or return status of the stock listing.
     * @param {number} stockListing ID of stock listing
     * @param {SetSaleOrReturnRequest} [setSaleOrReturnRequest] Sale or return request body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockListApi
     */
    setSaleOrReturn(stockListing, setSaleOrReturnRequest, options) {
        return StockListApiFp(this.configuration).setSaleOrReturn(stockListing, setSaleOrReturnRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Mark a vehicle as written off
     * @param {number} stockListing Stock Listing
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockListApi
     */
    writeOffStockListing(stockListing, options) {
        return StockListApiFp(this.configuration).writeOffStockListing(stockListing, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * TeamsApi - axios parameter creator
 * @export
 */
export const TeamsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Delete the specified team
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        destroyTeam: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('destroyTeam', 'id', id);
            const localVarPath = `/teams/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Show the team
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeam: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTeam', 'id', id);
            const localVarPath = `/teams/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Show the available teams.
         * @param {boolean} [authorised] Whether to return only authorised / non-authorised teams
         * @param {number} [location] Whether to return only a locations teams
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeams: async (authorised, location, options = {}) => {
            const localVarPath = `/teams`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (authorised !== undefined) {
                localVarQueryParameter['authorised'] = authorised;
            }
            if (location !== undefined) {
                localVarQueryParameter['location'] = location;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update the team details
         * @param {number} id
         * @param {TeamBasePayload} teamBasePayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchTeam: async (id, teamBasePayload, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patchTeam', 'id', id);
            // verify required parameter 'teamBasePayload' is not null or undefined
            assertParamExists('patchTeam', 'teamBasePayload', teamBasePayload);
            const localVarPath = `/teams/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(teamBasePayload, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create a new team
         * @param {StoreTeamPayload} storeTeamPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeTeam: async (storeTeamPayload, options = {}) => {
            // verify required parameter 'storeTeamPayload' is not null or undefined
            assertParamExists('storeTeam', 'storeTeamPayload', storeTeamPayload);
            const localVarPath = `/teams`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(storeTeamPayload, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * TeamsApi - functional programming interface
 * @export
 */
export const TeamsApiFp = function (configuration) {
    const localVarAxiosParamCreator = TeamsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Delete the specified team
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async destroyTeam(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.destroyTeam(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamsApi.destroyTeam']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Show the team
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeam(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeam(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamsApi.getTeam']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Show the available teams.
         * @param {boolean} [authorised] Whether to return only authorised / non-authorised teams
         * @param {number} [location] Whether to return only a locations teams
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeams(authorised, location, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeams(authorised, location, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamsApi.getTeams']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Update the team details
         * @param {number} id
         * @param {TeamBasePayload} teamBasePayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchTeam(id, teamBasePayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchTeam(id, teamBasePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamsApi.patchTeam']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Create a new team
         * @param {StoreTeamPayload} storeTeamPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storeTeam(storeTeamPayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storeTeam(storeTeamPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamsApi.storeTeam']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * TeamsApi - factory interface
 * @export
 */
export const TeamsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = TeamsApiFp(configuration);
    return {
        /**
         *
         * @summary Delete the specified team
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        destroyTeam(id, options) {
            return localVarFp.destroyTeam(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Show the team
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeam(id, options) {
            return localVarFp.getTeam(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Show the available teams.
         * @param {boolean} [authorised] Whether to return only authorised / non-authorised teams
         * @param {number} [location] Whether to return only a locations teams
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeams(authorised, location, options) {
            return localVarFp.getTeams(authorised, location, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update the team details
         * @param {number} id
         * @param {TeamBasePayload} teamBasePayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchTeam(id, teamBasePayload, options) {
            return localVarFp.patchTeam(id, teamBasePayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create a new team
         * @param {StoreTeamPayload} storeTeamPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeTeam(storeTeamPayload, options) {
            return localVarFp.storeTeam(storeTeamPayload, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * TeamsApi - object-oriented interface
 * @export
 * @class TeamsApi
 * @extends {BaseAPI}
 */
export class TeamsApi extends BaseAPI {
    /**
     *
     * @summary Delete the specified team
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApi
     */
    destroyTeam(id, options) {
        return TeamsApiFp(this.configuration).destroyTeam(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Show the team
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApi
     */
    getTeam(id, options) {
        return TeamsApiFp(this.configuration).getTeam(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Show the available teams.
     * @param {boolean} [authorised] Whether to return only authorised / non-authorised teams
     * @param {number} [location] Whether to return only a locations teams
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApi
     */
    getTeams(authorised, location, options) {
        return TeamsApiFp(this.configuration).getTeams(authorised, location, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update the team details
     * @param {number} id
     * @param {TeamBasePayload} teamBasePayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApi
     */
    patchTeam(id, teamBasePayload, options) {
        return TeamsApiFp(this.configuration).patchTeam(id, teamBasePayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create a new team
     * @param {StoreTeamPayload} storeTeamPayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApi
     */
    storeTeam(storeTeamPayload, options) {
        return TeamsApiFp(this.configuration).storeTeam(storeTeamPayload, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * TemplatesApi - axios parameter creator
 * @export
 */
export const TemplatesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Delete a template
         * @param {number} id ID of the template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        destroyTemplate: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('destroyTemplate', 'id', id);
            const localVarPath = `/templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a template
         * @param {number} id ID of the template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplate: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTemplate', 'id', id);
            const localVarPath = `/templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary List templates
         * @param {number} [page] Page Number
         * @param {TemplateDataSource} [dataSource] Filter by data sources (can be comma-separated or array)
         * @param {TemplateFormat} [format] Filter by format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplates: async (page, dataSource, format, options = {}) => {
            const localVarPath = `/templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (dataSource !== undefined) {
                localVarQueryParameter['data_source'] = dataSource;
            }
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update a template
         * @param {number} id ID of the template
         * @param {PatchTemplatePayload} patchTemplatePayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchTemplate: async (id, patchTemplatePayload, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patchTemplate', 'id', id);
            // verify required parameter 'patchTemplatePayload' is not null or undefined
            assertParamExists('patchTemplate', 'patchTemplatePayload', patchTemplatePayload);
            const localVarPath = `/templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(patchTemplatePayload, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Render or preview a template
         * @param {number} id ID of the template
         * @param {TemplateDataSource} dataSource Data source type
         * @param {number} dataSourceId ID of the data source
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renderTemplate: async (id, dataSource, dataSourceId, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('renderTemplate', 'id', id);
            // verify required parameter 'dataSource' is not null or undefined
            assertParamExists('renderTemplate', 'dataSource', dataSource);
            // verify required parameter 'dataSourceId' is not null or undefined
            assertParamExists('renderTemplate', 'dataSourceId', dataSourceId);
            const localVarPath = `/templates/{id}/render`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (dataSource !== undefined) {
                localVarQueryParameter['data_source'] = dataSource;
            }
            if (dataSourceId !== undefined) {
                localVarQueryParameter['data_source_id'] = dataSourceId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create a template
         * @param {StoreTemplatePayload} storeTemplatePayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeTemplate: async (storeTemplatePayload, options = {}) => {
            // verify required parameter 'storeTemplatePayload' is not null or undefined
            assertParamExists('storeTemplate', 'storeTemplatePayload', storeTemplatePayload);
            const localVarPath = `/templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(storeTemplatePayload, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * TemplatesApi - functional programming interface
 * @export
 */
export const TemplatesApiFp = function (configuration) {
    const localVarAxiosParamCreator = TemplatesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Delete a template
         * @param {number} id ID of the template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async destroyTemplate(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.destroyTemplate(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TemplatesApi.destroyTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get a template
         * @param {number} id ID of the template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTemplate(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTemplate(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TemplatesApi.getTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary List templates
         * @param {number} [page] Page Number
         * @param {TemplateDataSource} [dataSource] Filter by data sources (can be comma-separated or array)
         * @param {TemplateFormat} [format] Filter by format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTemplates(page, dataSource, format, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTemplates(page, dataSource, format, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TemplatesApi.getTemplates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Update a template
         * @param {number} id ID of the template
         * @param {PatchTemplatePayload} patchTemplatePayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchTemplate(id, patchTemplatePayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchTemplate(id, patchTemplatePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TemplatesApi.patchTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Render or preview a template
         * @param {number} id ID of the template
         * @param {TemplateDataSource} dataSource Data source type
         * @param {number} dataSourceId ID of the data source
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async renderTemplate(id, dataSource, dataSourceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.renderTemplate(id, dataSource, dataSourceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TemplatesApi.renderTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Create a template
         * @param {StoreTemplatePayload} storeTemplatePayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storeTemplate(storeTemplatePayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storeTemplate(storeTemplatePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TemplatesApi.storeTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * TemplatesApi - factory interface
 * @export
 */
export const TemplatesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = TemplatesApiFp(configuration);
    return {
        /**
         *
         * @summary Delete a template
         * @param {number} id ID of the template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        destroyTemplate(id, options) {
            return localVarFp.destroyTemplate(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a template
         * @param {number} id ID of the template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplate(id, options) {
            return localVarFp.getTemplate(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List templates
         * @param {number} [page] Page Number
         * @param {TemplateDataSource} [dataSource] Filter by data sources (can be comma-separated or array)
         * @param {TemplateFormat} [format] Filter by format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplates(page, dataSource, format, options) {
            return localVarFp.getTemplates(page, dataSource, format, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update a template
         * @param {number} id ID of the template
         * @param {PatchTemplatePayload} patchTemplatePayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchTemplate(id, patchTemplatePayload, options) {
            return localVarFp.patchTemplate(id, patchTemplatePayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Render or preview a template
         * @param {number} id ID of the template
         * @param {TemplateDataSource} dataSource Data source type
         * @param {number} dataSourceId ID of the data source
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renderTemplate(id, dataSource, dataSourceId, options) {
            return localVarFp.renderTemplate(id, dataSource, dataSourceId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create a template
         * @param {StoreTemplatePayload} storeTemplatePayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeTemplate(storeTemplatePayload, options) {
            return localVarFp.storeTemplate(storeTemplatePayload, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * TemplatesApi - object-oriented interface
 * @export
 * @class TemplatesApi
 * @extends {BaseAPI}
 */
export class TemplatesApi extends BaseAPI {
    /**
     *
     * @summary Delete a template
     * @param {number} id ID of the template
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplatesApi
     */
    destroyTemplate(id, options) {
        return TemplatesApiFp(this.configuration).destroyTemplate(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a template
     * @param {number} id ID of the template
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplatesApi
     */
    getTemplate(id, options) {
        return TemplatesApiFp(this.configuration).getTemplate(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List templates
     * @param {number} [page] Page Number
     * @param {TemplateDataSource} [dataSource] Filter by data sources (can be comma-separated or array)
     * @param {TemplateFormat} [format] Filter by format
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplatesApi
     */
    getTemplates(page, dataSource, format, options) {
        return TemplatesApiFp(this.configuration).getTemplates(page, dataSource, format, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update a template
     * @param {number} id ID of the template
     * @param {PatchTemplatePayload} patchTemplatePayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplatesApi
     */
    patchTemplate(id, patchTemplatePayload, options) {
        return TemplatesApiFp(this.configuration).patchTemplate(id, patchTemplatePayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Render or preview a template
     * @param {number} id ID of the template
     * @param {TemplateDataSource} dataSource Data source type
     * @param {number} dataSourceId ID of the data source
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplatesApi
     */
    renderTemplate(id, dataSource, dataSourceId, options) {
        return TemplatesApiFp(this.configuration).renderTemplate(id, dataSource, dataSourceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create a template
     * @param {StoreTemplatePayload} storeTemplatePayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplatesApi
     */
    storeTemplate(storeTemplatePayload, options) {
        return TemplatesApiFp(this.configuration).storeTemplate(storeTemplatePayload, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * UsersApi - axios parameter creator
 * @export
 */
export const UsersApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Delete User Grid State
         * @param {any} grid ID of the grid to put state for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserGridState: async (grid, options = {}) => {
            // verify required parameter 'grid' is not null or undefined
            assertParamExists('deleteUserGridState', 'grid', grid);
            const localVarPath = `/users/me/grid-state/{grid}`
                .replace(`{${"grid"}}`, encodeURIComponent(String(grid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get User Grid State
         * @param {any} grid ID of the grid to get the state for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserGridState: async (grid, options = {}) => {
            // verify required parameter 'grid' is not null or undefined
            assertParamExists('getUserGridState', 'grid', grid);
            const localVarPath = `/users/me/grid-state/{grid}`
                .replace(`{${"grid"}}`, encodeURIComponent(String(grid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Put User Grid State
         * @param {any} grid ID of the grid to put state for
         * @param {PutGridStatePayload} putGridStatePayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putUserGridState: async (grid, putGridStatePayload, options = {}) => {
            // verify required parameter 'grid' is not null or undefined
            assertParamExists('putUserGridState', 'grid', grid);
            // verify required parameter 'putGridStatePayload' is not null or undefined
            assertParamExists('putUserGridState', 'putGridStatePayload', putGridStatePayload);
            const localVarPath = `/users/me/grid-state/{grid}`
                .replace(`{${"grid"}}`, encodeURIComponent(String(grid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(putGridStatePayload, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * UsersApi - functional programming interface
 * @export
 */
export const UsersApiFp = function (configuration) {
    const localVarAxiosParamCreator = UsersApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Delete User Grid State
         * @param {any} grid ID of the grid to put state for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUserGridState(grid, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUserGridState(grid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.deleteUserGridState']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get User Grid State
         * @param {any} grid ID of the grid to get the state for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserGridState(grid, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserGridState(grid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.getUserGridState']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Put User Grid State
         * @param {any} grid ID of the grid to put state for
         * @param {PutGridStatePayload} putGridStatePayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putUserGridState(grid, putGridStatePayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putUserGridState(grid, putGridStatePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.putUserGridState']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * UsersApi - factory interface
 * @export
 */
export const UsersApiFactory = function (configuration, basePath, axios) {
    const localVarFp = UsersApiFp(configuration);
    return {
        /**
         *
         * @summary Delete User Grid State
         * @param {any} grid ID of the grid to put state for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserGridState(grid, options) {
            return localVarFp.deleteUserGridState(grid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get User Grid State
         * @param {any} grid ID of the grid to get the state for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserGridState(grid, options) {
            return localVarFp.getUserGridState(grid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Put User Grid State
         * @param {any} grid ID of the grid to put state for
         * @param {PutGridStatePayload} putGridStatePayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putUserGridState(grid, putGridStatePayload, options) {
            return localVarFp.putUserGridState(grid, putGridStatePayload, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
export class UsersApi extends BaseAPI {
    /**
     *
     * @summary Delete User Grid State
     * @param {any} grid ID of the grid to put state for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    deleteUserGridState(grid, options) {
        return UsersApiFp(this.configuration).deleteUserGridState(grid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get User Grid State
     * @param {any} grid ID of the grid to get the state for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    getUserGridState(grid, options) {
        return UsersApiFp(this.configuration).getUserGridState(grid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Put User Grid State
     * @param {any} grid ID of the grid to put state for
     * @param {PutGridStatePayload} putGridStatePayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    putUserGridState(grid, putGridStatePayload, options) {
        return UsersApiFp(this.configuration).putUserGridState(grid, putGridStatePayload, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * UtilitiesApi - axios parameter creator
 * @export
 */
export const UtilitiesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Show the Open API specification.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOpenApi: async (options = {}) => {
            const localVarPath = `/open-api`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * UtilitiesApi - functional programming interface
 * @export
 */
export const UtilitiesApiFp = function (configuration) {
    const localVarAxiosParamCreator = UtilitiesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Show the Open API specification.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOpenApi(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOpenApi(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UtilitiesApi.getOpenApi']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * UtilitiesApi - factory interface
 * @export
 */
export const UtilitiesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = UtilitiesApiFp(configuration);
    return {
        /**
         *
         * @summary Show the Open API specification.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOpenApi(options) {
            return localVarFp.getOpenApi(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * UtilitiesApi - object-oriented interface
 * @export
 * @class UtilitiesApi
 * @extends {BaseAPI}
 */
export class UtilitiesApi extends BaseAPI {
    /**
     *
     * @summary Show the Open API specification.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilitiesApi
     */
    getOpenApi(options) {
        return UtilitiesApiFp(this.configuration).getOpenApi(options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ValuationsApi - axios parameter creator
 * @export
 */
export const ValuationsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get a valuation for a vehicle identity.
         * @param {ValuationRequestPayload} valuationRequestPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getValuation: async (valuationRequestPayload, options = {}) => {
            // verify required parameter 'valuationRequestPayload' is not null or undefined
            assertParamExists('getValuation', 'valuationRequestPayload', valuationRequestPayload);
            const localVarPath = `/valuations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(valuationRequestPayload, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ValuationsApi - functional programming interface
 * @export
 */
export const ValuationsApiFp = function (configuration) {
    const localVarAxiosParamCreator = ValuationsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Get a valuation for a vehicle identity.
         * @param {ValuationRequestPayload} valuationRequestPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getValuation(valuationRequestPayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getValuation(valuationRequestPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ValuationsApi.getValuation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * ValuationsApi - factory interface
 * @export
 */
export const ValuationsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ValuationsApiFp(configuration);
    return {
        /**
         *
         * @summary Get a valuation for a vehicle identity.
         * @param {ValuationRequestPayload} valuationRequestPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getValuation(valuationRequestPayload, options) {
            return localVarFp.getValuation(valuationRequestPayload, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ValuationsApi - object-oriented interface
 * @export
 * @class ValuationsApi
 * @extends {BaseAPI}
 */
export class ValuationsApi extends BaseAPI {
    /**
     *
     * @summary Get a valuation for a vehicle identity.
     * @param {ValuationRequestPayload} valuationRequestPayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValuationsApi
     */
    getValuation(valuationRequestPayload, options) {
        return ValuationsApiFp(this.configuration).getValuation(valuationRequestPayload, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * VehicleAppraisalsApi - axios parameter creator
 * @export
 */
export const VehicleAppraisalsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Delete a vehicle appraisal.
         * @param {number} appraisal Appraisal ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        destroyVehicleAppraisal: async (appraisal, options = {}) => {
            // verify required parameter 'appraisal' is not null or undefined
            assertParamExists('destroyVehicleAppraisal', 'appraisal', appraisal);
            const localVarPath = `/vehicle-appraisals/{appraisal}`
                .replace(`{${"appraisal"}}`, encodeURIComponent(String(appraisal)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get an appraisal.
         * @param {number} appraisal ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppraisal: async (appraisal, options = {}) => {
            // verify required parameter 'appraisal' is not null or undefined
            assertParamExists('getAppraisal', 'appraisal', appraisal);
            const localVarPath = `/vehicle-appraisals/{appraisal}`
                .replace(`{${"appraisal"}}`, encodeURIComponent(String(appraisal)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Gets a paginated list of appraisals.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppraisals: async (options = {}) => {
            const localVarPath = `/vehicle-appraisals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch a vehicle appraisal.
         * @param {number} appraisal Appraisal ID
         * @param {PatchVehicleAppraisalPayload} patchVehicleAppraisalPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchVehicleAppraisal: async (appraisal, patchVehicleAppraisalPayload, options = {}) => {
            // verify required parameter 'appraisal' is not null or undefined
            assertParamExists('patchVehicleAppraisal', 'appraisal', appraisal);
            // verify required parameter 'patchVehicleAppraisalPayload' is not null or undefined
            assertParamExists('patchVehicleAppraisal', 'patchVehicleAppraisalPayload', patchVehicleAppraisalPayload);
            const localVarPath = `/vehicle-appraisals/{appraisal}`
                .replace(`{${"appraisal"}}`, encodeURIComponent(String(appraisal)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(patchVehicleAppraisalPayload, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Store vehicle appraisal.
         * @param {StoreVehicleAppraisalPayload} storeVehicleAppraisalPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeVehicleAppraisal: async (storeVehicleAppraisalPayload, options = {}) => {
            // verify required parameter 'storeVehicleAppraisalPayload' is not null or undefined
            assertParamExists('storeVehicleAppraisal', 'storeVehicleAppraisalPayload', storeVehicleAppraisalPayload);
            const localVarPath = `/vehicle-appraisals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(storeVehicleAppraisalPayload, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * VehicleAppraisalsApi - functional programming interface
 * @export
 */
export const VehicleAppraisalsApiFp = function (configuration) {
    const localVarAxiosParamCreator = VehicleAppraisalsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Delete a vehicle appraisal.
         * @param {number} appraisal Appraisal ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async destroyVehicleAppraisal(appraisal, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.destroyVehicleAppraisal(appraisal, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleAppraisalsApi.destroyVehicleAppraisal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get an appraisal.
         * @param {number} appraisal ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAppraisal(appraisal, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAppraisal(appraisal, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleAppraisalsApi.getAppraisal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Gets a paginated list of appraisals.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAppraisals(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAppraisals(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleAppraisalsApi.getAppraisals']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Patch a vehicle appraisal.
         * @param {number} appraisal Appraisal ID
         * @param {PatchVehicleAppraisalPayload} patchVehicleAppraisalPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchVehicleAppraisal(appraisal, patchVehicleAppraisalPayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchVehicleAppraisal(appraisal, patchVehicleAppraisalPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleAppraisalsApi.patchVehicleAppraisal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Store vehicle appraisal.
         * @param {StoreVehicleAppraisalPayload} storeVehicleAppraisalPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storeVehicleAppraisal(storeVehicleAppraisalPayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storeVehicleAppraisal(storeVehicleAppraisalPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleAppraisalsApi.storeVehicleAppraisal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * VehicleAppraisalsApi - factory interface
 * @export
 */
export const VehicleAppraisalsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = VehicleAppraisalsApiFp(configuration);
    return {
        /**
         *
         * @summary Delete a vehicle appraisal.
         * @param {number} appraisal Appraisal ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        destroyVehicleAppraisal(appraisal, options) {
            return localVarFp.destroyVehicleAppraisal(appraisal, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get an appraisal.
         * @param {number} appraisal ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppraisal(appraisal, options) {
            return localVarFp.getAppraisal(appraisal, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets a paginated list of appraisals.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppraisals(options) {
            return localVarFp.getAppraisals(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch a vehicle appraisal.
         * @param {number} appraisal Appraisal ID
         * @param {PatchVehicleAppraisalPayload} patchVehicleAppraisalPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchVehicleAppraisal(appraisal, patchVehicleAppraisalPayload, options) {
            return localVarFp.patchVehicleAppraisal(appraisal, patchVehicleAppraisalPayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Store vehicle appraisal.
         * @param {StoreVehicleAppraisalPayload} storeVehicleAppraisalPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeVehicleAppraisal(storeVehicleAppraisalPayload, options) {
            return localVarFp.storeVehicleAppraisal(storeVehicleAppraisalPayload, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * VehicleAppraisalsApi - object-oriented interface
 * @export
 * @class VehicleAppraisalsApi
 * @extends {BaseAPI}
 */
export class VehicleAppraisalsApi extends BaseAPI {
    /**
     *
     * @summary Delete a vehicle appraisal.
     * @param {number} appraisal Appraisal ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleAppraisalsApi
     */
    destroyVehicleAppraisal(appraisal, options) {
        return VehicleAppraisalsApiFp(this.configuration).destroyVehicleAppraisal(appraisal, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get an appraisal.
     * @param {number} appraisal ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleAppraisalsApi
     */
    getAppraisal(appraisal, options) {
        return VehicleAppraisalsApiFp(this.configuration).getAppraisal(appraisal, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets a paginated list of appraisals.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleAppraisalsApi
     */
    getAppraisals(options) {
        return VehicleAppraisalsApiFp(this.configuration).getAppraisals(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Patch a vehicle appraisal.
     * @param {number} appraisal Appraisal ID
     * @param {PatchVehicleAppraisalPayload} patchVehicleAppraisalPayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleAppraisalsApi
     */
    patchVehicleAppraisal(appraisal, patchVehicleAppraisalPayload, options) {
        return VehicleAppraisalsApiFp(this.configuration).patchVehicleAppraisal(appraisal, patchVehicleAppraisalPayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Store vehicle appraisal.
     * @param {StoreVehicleAppraisalPayload} storeVehicleAppraisalPayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleAppraisalsApi
     */
    storeVehicleAppraisal(storeVehicleAppraisalPayload, options) {
        return VehicleAppraisalsApiFp(this.configuration).storeVehicleAppraisal(storeVehicleAppraisalPayload, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * VehiclesApi - axios parameter creator
 * @export
 */
export const VehiclesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Create a vehicle.
         * @param {CreateVehicleRequestBody} [createVehicleRequestBody] Create Vehicle Request Body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVehicle: async (createVehicleRequestBody, options = {}) => {
            const localVarPath = `/vehicles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(createVehicleRequestBody, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get the current valuation for the vehicle.
         * @param {number} vehicle ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentVehicleValuation: async (vehicle, options = {}) => {
            // verify required parameter 'vehicle' is not null or undefined
            assertParamExists('getCurrentVehicleValuation', 'vehicle', vehicle);
            const localVarPath = `/vehicles/{vehicle}/current-valuation`
                .replace(`{${"vehicle"}}`, encodeURIComponent(String(vehicle)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Find a vehicle.
         * @param {number} vehicle ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVehicle: async (vehicle, options = {}) => {
            // verify required parameter 'vehicle' is not null or undefined
            assertParamExists('getVehicle', 'vehicle', vehicle);
            const localVarPath = `/vehicles/{vehicle}`
                .replace(`{${"vehicle"}}`, encodeURIComponent(String(vehicle)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Gets a paginated list of valuations.
         * @param {number} vehicle ID
         * @param {number} [perPage] Per Page
         * @param {number} [page] Page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVehicleValuations: async (vehicle, perPage, page, options = {}) => {
            // verify required parameter 'vehicle' is not null or undefined
            assertParamExists('getVehicleValuations', 'vehicle', vehicle);
            const localVarPath = `/vehicles/{vehicle}/valuations`
                .replace(`{${"vehicle"}}`, encodeURIComponent(String(vehicle)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Refresh a vehicles data from the DVSA & DVLA
         * @param {number} id ID of the vehicle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshGovData: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('refreshGovData', 'id', id);
            const localVarPath = `/vehicles/{id}/refresh-gov-data`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a new valuation for an existing vehicle.
         * @param {number} vehicle ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        valueExistingVehicle: async (vehicle, options = {}) => {
            // verify required parameter 'vehicle' is not null or undefined
            assertParamExists('valueExistingVehicle', 'vehicle', vehicle);
            const localVarPath = `/vehicles/{vehicle}/value`
                .replace(`{${"vehicle"}}`, encodeURIComponent(String(vehicle)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * VehiclesApi - functional programming interface
 * @export
 */
export const VehiclesApiFp = function (configuration) {
    const localVarAxiosParamCreator = VehiclesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Create a vehicle.
         * @param {CreateVehicleRequestBody} [createVehicleRequestBody] Create Vehicle Request Body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createVehicle(createVehicleRequestBody, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createVehicle(createVehicleRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehiclesApi.createVehicle']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get the current valuation for the vehicle.
         * @param {number} vehicle ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentVehicleValuation(vehicle, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentVehicleValuation(vehicle, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehiclesApi.getCurrentVehicleValuation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Find a vehicle.
         * @param {number} vehicle ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVehicle(vehicle, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVehicle(vehicle, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehiclesApi.getVehicle']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Gets a paginated list of valuations.
         * @param {number} vehicle ID
         * @param {number} [perPage] Per Page
         * @param {number} [page] Page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVehicleValuations(vehicle, perPage, page, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVehicleValuations(vehicle, perPage, page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehiclesApi.getVehicleValuations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Refresh a vehicles data from the DVSA & DVLA
         * @param {number} id ID of the vehicle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refreshGovData(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refreshGovData(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehiclesApi.refreshGovData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Get a new valuation for an existing vehicle.
         * @param {number} vehicle ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async valueExistingVehicle(vehicle, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.valueExistingVehicle(vehicle, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehiclesApi.valueExistingVehicle']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * VehiclesApi - factory interface
 * @export
 */
export const VehiclesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = VehiclesApiFp(configuration);
    return {
        /**
         *
         * @summary Create a vehicle.
         * @param {CreateVehicleRequestBody} [createVehicleRequestBody] Create Vehicle Request Body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVehicle(createVehicleRequestBody, options) {
            return localVarFp.createVehicle(createVehicleRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get the current valuation for the vehicle.
         * @param {number} vehicle ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentVehicleValuation(vehicle, options) {
            return localVarFp.getCurrentVehicleValuation(vehicle, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Find a vehicle.
         * @param {number} vehicle ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVehicle(vehicle, options) {
            return localVarFp.getVehicle(vehicle, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets a paginated list of valuations.
         * @param {number} vehicle ID
         * @param {number} [perPage] Per Page
         * @param {number} [page] Page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVehicleValuations(vehicle, perPage, page, options) {
            return localVarFp.getVehicleValuations(vehicle, perPage, page, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Refresh a vehicles data from the DVSA & DVLA
         * @param {number} id ID of the vehicle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshGovData(id, options) {
            return localVarFp.refreshGovData(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a new valuation for an existing vehicle.
         * @param {number} vehicle ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        valueExistingVehicle(vehicle, options) {
            return localVarFp.valueExistingVehicle(vehicle, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * VehiclesApi - object-oriented interface
 * @export
 * @class VehiclesApi
 * @extends {BaseAPI}
 */
export class VehiclesApi extends BaseAPI {
    /**
     *
     * @summary Create a vehicle.
     * @param {CreateVehicleRequestBody} [createVehicleRequestBody] Create Vehicle Request Body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    createVehicle(createVehicleRequestBody, options) {
        return VehiclesApiFp(this.configuration).createVehicle(createVehicleRequestBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get the current valuation for the vehicle.
     * @param {number} vehicle ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    getCurrentVehicleValuation(vehicle, options) {
        return VehiclesApiFp(this.configuration).getCurrentVehicleValuation(vehicle, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Find a vehicle.
     * @param {number} vehicle ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    getVehicle(vehicle, options) {
        return VehiclesApiFp(this.configuration).getVehicle(vehicle, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets a paginated list of valuations.
     * @param {number} vehicle ID
     * @param {number} [perPage] Per Page
     * @param {number} [page] Page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    getVehicleValuations(vehicle, perPage, page, options) {
        return VehiclesApiFp(this.configuration).getVehicleValuations(vehicle, perPage, page, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Refresh a vehicles data from the DVSA & DVLA
     * @param {number} id ID of the vehicle
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    refreshGovData(id, options) {
        return VehiclesApiFp(this.configuration).refreshGovData(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a new valuation for an existing vehicle.
     * @param {number} vehicle ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    valueExistingVehicle(vehicle, options) {
        return VehiclesApiFp(this.configuration).valueExistingVehicle(vehicle, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * WriteDownsApi - axios parameter creator
 * @export
 */
export const WriteDownsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Destroy a write-down entry.
         * @param {number} id Write Down ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        destroyWriteDown: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('destroyWriteDown', 'id', id);
            const localVarPath = `/write-downs/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary List all write-down entries.
         * @param {number} [stockListingId] Stock Listing ID
         * @param {number} [page] Page
         * @param {number} [perPage] Per Page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWriteDowns: async (stockListingId, page, perPage, options = {}) => {
            const localVarPath = `/write-downs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (stockListingId !== undefined) {
                localVarQueryParameter['stock_listing_id'] = stockListingId;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Store a write-down entry.
         * @param {WriteDownPayload} writeDownPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeWriteDown: async (writeDownPayload, options = {}) => {
            // verify required parameter 'writeDownPayload' is not null or undefined
            assertParamExists('storeWriteDown', 'writeDownPayload', writeDownPayload);
            const localVarPath = `/write-downs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(writeDownPayload, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * WriteDownsApi - functional programming interface
 * @export
 */
export const WriteDownsApiFp = function (configuration) {
    const localVarAxiosParamCreator = WriteDownsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Destroy a write-down entry.
         * @param {number} id Write Down ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async destroyWriteDown(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.destroyWriteDown(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WriteDownsApi.destroyWriteDown']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary List all write-down entries.
         * @param {number} [stockListingId] Stock Listing ID
         * @param {number} [page] Page
         * @param {number} [perPage] Per Page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listWriteDowns(stockListingId, page, perPage, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listWriteDowns(stockListingId, page, perPage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WriteDownsApi.listWriteDowns']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Store a write-down entry.
         * @param {WriteDownPayload} writeDownPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storeWriteDown(writeDownPayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storeWriteDown(writeDownPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WriteDownsApi.storeWriteDown']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * WriteDownsApi - factory interface
 * @export
 */
export const WriteDownsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = WriteDownsApiFp(configuration);
    return {
        /**
         *
         * @summary Destroy a write-down entry.
         * @param {number} id Write Down ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        destroyWriteDown(id, options) {
            return localVarFp.destroyWriteDown(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List all write-down entries.
         * @param {number} [stockListingId] Stock Listing ID
         * @param {number} [page] Page
         * @param {number} [perPage] Per Page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWriteDowns(stockListingId, page, perPage, options) {
            return localVarFp.listWriteDowns(stockListingId, page, perPage, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Store a write-down entry.
         * @param {WriteDownPayload} writeDownPayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeWriteDown(writeDownPayload, options) {
            return localVarFp.storeWriteDown(writeDownPayload, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * WriteDownsApi - object-oriented interface
 * @export
 * @class WriteDownsApi
 * @extends {BaseAPI}
 */
export class WriteDownsApi extends BaseAPI {
    /**
     *
     * @summary Destroy a write-down entry.
     * @param {number} id Write Down ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WriteDownsApi
     */
    destroyWriteDown(id, options) {
        return WriteDownsApiFp(this.configuration).destroyWriteDown(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List all write-down entries.
     * @param {number} [stockListingId] Stock Listing ID
     * @param {number} [page] Page
     * @param {number} [perPage] Per Page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WriteDownsApi
     */
    listWriteDowns(stockListingId, page, perPage, options) {
        return WriteDownsApiFp(this.configuration).listWriteDowns(stockListingId, page, perPage, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Store a write-down entry.
     * @param {WriteDownPayload} writeDownPayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WriteDownsApi
     */
    storeWriteDown(writeDownPayload, options) {
        return WriteDownsApiFp(this.configuration).storeWriteDown(writeDownPayload, options).then((request) => request(this.axios, this.basePath));
    }
}
